import car1 from '../img/car.png'
import car2 from '../img/car2.png'

const Platform = () => {
  return (
    <div className="m-platform">
      <div className="m-platform__container">
			<svg viewBox="-1790 100 5483.51 3310.69">
<g>
	<g>
		<rect x="506.39" y="802.92" className="st0" width="674.81" height="1755.43"/>
	</g>
</g>
<g>
	<g>
		<rect x="-1455.32" y="752.88" className="st1" width="2200" height="1798.48"/>
	</g>
</g>
<g>
	<g>
		<rect x="1127.51" y="746.33" className="st1" width="2200" height="1808.18"/>
	</g>
</g>
<g>
	<g>
		<rect x="-1461.82" y="2522.77" className="st0" width="4792.79" height="379.79"/>
	</g>
</g>
<g>
	<g>
		<rect x="1181.2" y="770.76" className="st2" width="714.81" height="2"/>
	</g>
</g>
<g>
	<g>
		<rect x="1169.34" y="752.17" className="st3" width="745.45" height="6.7"/>
	</g>
</g>
<g>
	<g>
		<rect x="57.61" y="760.61" className="st3" width="661.59" height="6.7"/>
	</g>
</g>
<g>
	<g>
		<g>
			<polygon className="st4" points="946.32,889.34 946.32,812.45 939.56,812.45 939.56,904.66 955.77,889.34 			"/>
		</g>
		<g>
			<path className="st4" d="M939.44,904.95v-92.63h7.01v76.89h9.64L939.44,904.95z M939.69,812.57v91.8l15.77-14.92h-9.26v-76.89H939.69
				z"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st4" points="932.68,889.34 923.23,889.34 939.44,904.66 939.44,812.45 932.68,812.45 			"/>
		</g>
		<g>
			<path className="st4" d="M939.56,904.95l-16.65-15.75h9.64v-76.89h7.01V904.95z M923.54,889.46l15.77,14.92v-91.8h-6.51v76.89H923.54
				z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<polygon className="st4" points="946.32,1158.47 946.32,1081.58 939.56,1081.58 939.56,1173.8 955.77,1158.47 			"/>
		</g>
		<g>
			<path className="st4" d="M939.44,1174.09v-92.64h7.01v76.89h9.64L939.44,1174.09z M939.69,1081.7v91.81l15.77-14.92h-9.26v-76.89
				H939.69z"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st4" points="932.68,1158.47 923.23,1158.47 939.44,1173.8 939.44,1081.58 932.68,1081.58 			"/>
		</g>
		<g>
			<path className="st4" d="M939.56,1174.09l-16.65-15.75h9.64v-76.89h7.01V1174.09z M923.54,1158.59l15.77,14.92v-91.81h-6.51v76.89
				H923.54z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<polygon className="st4" points="946.32,1427.6 946.32,1350.71 939.56,1350.71 939.56,1442.93 955.77,1427.6 			"/>
		</g>
		<g>
			<path className="st4" d="M939.44,1443.22v-92.64h7.01v76.89h9.64L939.44,1443.22z M939.69,1350.83v91.81l15.77-14.92h-9.26v-76.89
				H939.69z"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st4" points="932.68,1427.6 923.23,1427.6 939.44,1442.93 939.44,1350.71 932.68,1350.71 			"/>
		</g>
		<g>
			<path className="st4" d="M939.56,1443.22l-16.65-15.75h9.64v-76.89h7.01V1443.22z M923.54,1427.72l15.77,14.92v-91.81h-6.51v76.89
				H923.54z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<polygon className="st4" points="946.32,1696.73 946.32,1619.84 939.56,1619.84 939.56,1712.06 955.77,1696.73 			"/>
		</g>
		<g>
			<path className="st4" d="M939.44,1712.35v-92.64h7.01v76.89h9.64L939.44,1712.35z M939.69,1619.96v91.81l15.77-14.92h-9.26v-76.89
				H939.69z"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st4" points="932.68,1696.73 923.23,1696.73 939.44,1712.06 939.44,1619.84 932.68,1619.84 			"/>
		</g>
		<g>
			<path className="st4" d="M939.56,1712.35l-16.65-15.75h9.64v-76.89h7.01V1712.35z M923.54,1696.85l15.77,14.92v-91.81h-6.51v76.89
				H923.54z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<polygon className="st4" points="946.32,1965.86 946.32,1888.97 939.56,1888.97 939.56,1981.19 955.77,1965.86 			"/>
		</g>
		<g>
			<path className="st4" d="M939.44,1981.48v-92.63h7.01v76.89h9.64L939.44,1981.48z M939.69,1889.09v91.8l15.77-14.92h-9.26v-76.89
				H939.69z"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st4" points="932.68,1965.86 923.23,1965.86 939.44,1981.19 939.44,1888.97 932.68,1888.97 			"/>
		</g>
		<g>
			<path className="st4" d="M939.56,1981.48l-16.65-15.75h9.64v-76.89h7.01V1981.48z M923.54,1965.98l15.77,14.92v-91.8h-6.51v76.89
				H923.54z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<polygon className="st4" points="946.32,2234.99 946.32,2158.09 939.56,2158.09 939.56,2250.31 955.77,2234.99 			"/>
		</g>
		<g>
			<path className="st4" d="M939.44,2250.6v-92.63h7.01v76.89h9.64L939.44,2250.6z M939.69,2158.22v91.8l15.77-14.92h-9.26v-76.89
				H939.69z"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st4" points="932.68,2234.99 923.23,2234.99 939.44,2250.31 939.44,2158.09 932.68,2158.09 			"/>
		</g>
		<g>
			<path className="st4" d="M939.56,2250.6l-16.65-15.75h9.64v-76.89h7.01V2250.6z M923.54,2235.11l15.77,14.92v-91.8h-6.51v76.89
				H923.54z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<polygon className="st4" points="946.32,2504.11 946.32,2427.23 939.56,2427.23 939.56,2519.45 955.77,2504.11 			"/>
		</g>
		<g>
			<path className="st4" d="M939.44,2519.73v-92.63h7.01v76.89h9.64L939.44,2519.73z M939.69,2427.35v91.8l15.77-14.92h-9.26v-76.89
				H939.69z"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st4" points="932.68,2504.11 923.23,2504.11 939.44,2519.45 939.44,2427.23 932.68,2427.23 			"/>
		</g>
		<g>
			<path className="st4" d="M939.56,2519.73l-16.65-15.75h9.64v-76.89h7.01V2519.73z M923.54,2504.24l15.77,14.92v-91.8h-6.51v76.89
				H923.54z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<g>
				<path className="st4" d="M1383.07,601.68h-0.06l-3.21,1.73l-0.48-1.9l4.03-2.15h2.12v18.47h-2.41v-16.15H1383.07z"/>
			</g>
		</g>
	</g>
</g>
<g>
	<g>
		<rect x="1485.44" y="622.04" className="st4" width="82.87" height="121.54"/>
	</g>
	<g>
		<path className="st5" d="M1569.81,745.07h-85.87V620.54h85.87V745.07z M1486.95,742.07h79.87V623.54h-79.87V742.07z"/>
	</g>
</g>
<g>
	<g>
		<polygon className="st6" points="1587.38,775.15 1582.38,775.15 1582.38,638.75 1568.53,638.75 1568.53,633.75 1587.38,633.75 		"/>
	</g>
</g>
<g>
	<g>
		<polygon className="st6" points="1587.38,731.73 1582.38,731.73 1582.38,699.61 1568.53,699.61 1568.53,694.61 1587.38,694.61 		"/>
	</g>
</g>
<g>
	<g>
		<polygon className="st6" points="1471.43,731.73 1466.43,731.73 1466.43,694.61 1483.87,694.61 1483.87,699.61 1471.43,699.61 		"/>
	</g>
</g>
<g>
	<g>
		<rect x="1582.38" y="622.04" className="st6" width="5" height="43.67"/>
	</g>
</g>
<g>
	<g>
		<polygon className="st6" points="1471.58,775.94 1466.58,775.94 1466.58,634.54 1485.45,634.54 1485.45,639.54 1471.58,639.54 		"/>
	</g>
</g>
<g>
	<g>
		<rect x="1466.58" y="622.82" className="st6" width="5" height="43.67"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="648.1" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="652.83" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="657.57" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="662.31" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="670.2" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="674.93" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="679.67" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="682.83" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="687.56" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="692.3" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1495.3" y="697.03" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="648.1" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="652.83" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="657.57" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="662.31" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="670.2" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="674.93" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="679.67" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="682.83" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="687.56" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="692.3" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="1531.62" y="697.03" className="st5" width="28" height="0.75"/>
	</g>
</g>
<g>
	<g>
		<rect x="87.24" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="695.24" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="383.99" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="234.96" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="539.62" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="75.44" y="779.19" className="st2" width="634.4" height="2"/>
	</g>
</g>
<g>
	<g>
		<rect x="-675.05" y="760.61" className="st3" width="661.59" height="6.7"/>
	</g>
</g>
<g>
	<g>
		<rect x="-645.42" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="-37.42" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="-348.67" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="-497.7" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="-193.04" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="-657.22" y="779.19" className="st2" width="634.4" height="2"/>
	</g>
</g>
<g>
	<g>
		<rect x="-1414.04" y="760.61" className="st3" width="661.59" height="6.7"/>
	</g>
</g>
<g>
	<g>
		<rect x="-1384.41" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="-776.41" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="-1087.66" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="-1236.69" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="-932.03" y="767.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="-1396.21" y="779.19" className="st2" width="634.4" height="2"/>
	</g>
</g>
<g>
	<g>
		<rect x="1979.21" y="752.17" className="st3" width="661.59" height="6.7"/>
	</g>
</g>
<g>
	<g>
		<rect x="2024.12" y="759.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="2616.84" y="758.87" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="2320.87" y="759.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="2171.84" y="759.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="2476.5" y="759.32" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="1997.04" y="770.76" className="st2" width="634.4" height="2"/>
	</g>
</g>
<g>
	<g>
		<rect x="2783.87" y="752.17" className="st3" width="483.51" height="6.7"/>
	</g>
</g>
<g>
	<g>
		<rect x="2813.5" y="758.87" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="3249.47" y="758.87" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="3110.25" y="758.87" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="2961.22" y="758.87" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="2796.9" y="770.76" className="st2" width="463.64" height="2"/>
	</g>
</g>
<g>
	<g>
		<rect x="1196.62" y="758.87" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="1881.68" y="758.87" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="1530.97" y="758.87" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="1257.08" y="758.87" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<rect x="1706.33" y="758.87" className="st2" width="3" height="25.76"/>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st7" d="M1354.15,531.67l-117.6-28.49v-41.87h270.52v29.77l-97.04,39.68c-1.3,0.53-2.08,1.88-1.9,3.28l33.98,253.14
				h-107.58L1354.15,531.67z"/>
		</g>
	</g>
	<g>
		<g>
			<rect x="1298.91" y="467.73" className="st6" width="124.7" height="26.83"/>
		</g>
	</g>
	<g>
		<g>
			<rect x="1433.86" y="467.73" className="st6" width="49.72" height="26.83"/>
		</g>
	</g>
	<g>
		<g>
			<rect x="1303.64" y="471.68" className="st1" width="114.44" height="18.94"/>
		</g>
	</g>
	<g>
		<g>
			<rect x="1439.39" y="471.68" className="st1" width="39.46" height="18.94"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<g>
					<path className="st8" d="M1273.94,484.17c-0.43,0.16-1.29,0.41-2.29,0.41c-1.13,0-2.06-0.29-2.78-0.98
						c-0.64-0.62-1.04-1.61-1.04-2.76c0-2.22,1.53-3.85,4.03-3.85c0.86,0,1.54,0.19,1.86,0.34l-0.24,0.78
						c-0.4-0.18-0.89-0.32-1.65-0.32c-1.81,0-2.99,1.12-2.99,2.99c0,1.89,1.13,3,2.87,3c0.63,0,1.06-0.09,1.28-0.2v-2.22h-1.51
						v-0.77h2.45v3.58H1273.94z"/>
				</g>
			</g>
			<g>
				<g>
					<path className="st8" d="M1277.05,484.49l-2.44-7.45h1.04l1.16,3.67c0.32,1,0.6,1.91,0.8,2.78h0.03c0.21-0.86,0.51-1.8,0.85-2.77
						l1.26-3.68h1.03l-2.66,7.45L1277.05,484.49L1277.05,484.49z"/>
				</g>
			</g>
			<g>
				<g>
					<path className="st8" d="M1281.57,477.15c0.43-0.09,1.09-0.16,1.76-0.16c0.97,0,1.58,0.16,2.04,0.54c0.39,0.29,0.62,0.74,0.62,1.32
						c0,0.72-0.48,1.35-1.26,1.63v0.03c0.71,0.17,1.54,0.75,1.54,1.87c0,0.64-0.25,1.13-0.64,1.48c-0.51,0.48-1.35,0.7-2.57,0.7
						c-0.67,0-1.17-0.05-1.49-0.08L1281.57,477.15L1281.57,477.15z M1282.53,480.2h0.88c1.01,0,1.6-0.54,1.6-1.26
						c0-0.86-0.65-1.21-1.63-1.21c-0.45,0-0.7,0.03-0.86,0.07v2.4H1282.53z M1282.53,483.76c0.2,0.04,0.46,0.05,0.81,0.05
						c1,0,1.92-0.37,1.92-1.45c0-1.01-0.88-1.44-1.93-1.44h-0.8V483.76z"/>
				</g>
			</g>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1307.19" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1307.19" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1307.19" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1312.71" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1312.71" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1312.71" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1318.23" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1318.23" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1318.23" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1323.77" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1323.77" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1323.77" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1329.29" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1329.29" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1329.29" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1334.82" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1334.82" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1334.82" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1340.33" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1340.33" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1340.33" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1345.86" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1345.86" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1345.86" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1351.39" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1351.39" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1351.39" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1356.92" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1356.92" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1356.92" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1362.44" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1362.44" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1362.44" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1367.96" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1367.96" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1367.96" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1373.48" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1373.48" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1373.48" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1379.02" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1379.02" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1379.02" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1384.54" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1384.54" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1384.54" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1390.07" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1390.07" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1390.07" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1395.58" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1395.58" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1395.58" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1401.11" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1401.11" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1401.11" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1406.64" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1406.64" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1406.64" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1412.16" cy="475.23" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1412.16" cy="479.96" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1412.16" cy="484.7" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1443.72" cy="476.02" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1443.72" cy="480.76" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1443.72" cy="485.49" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1449.26" cy="476.02" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1449.26" cy="480.76" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1449.26" cy="485.49" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1454.78" cy="476.02" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1454.78" cy="480.76" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1454.78" cy="485.49" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1460.31" cy="476.02" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1460.31" cy="480.76" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1460.31" cy="485.49" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1465.82" cy="476.02" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1465.82" cy="480.76" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1465.82" cy="485.49" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1471.35" cy="476.02" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1471.35" cy="480.76" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			<circle className="st6" cx="1471.35" cy="485.49" r="1.97"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1251.88" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -46.6012 748.9861)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1256.62" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -45.7114 752.1508)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1261.35" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -45.1124 754.0445)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1266.09" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -44.2064 757.2733)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1270.82" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -43.61 759.1629)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1275.56" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -42.7156 762.3348)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1280.3" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -41.9479 764.96)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1285.03" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -41.1961 767.5188)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1289.77" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -40.4575 770.0209)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1294.5" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -39.8382 772.0241)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1299.24" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -38.9377 775.2054)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1303.97" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -38.3504 777.0807)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1308.71" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -37.4326 780.3279)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1313.44" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -36.848 782.1992)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1318.18" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -35.9276 785.4504)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1333.18" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -33.5436 793.5644)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1322.91" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -35.33 787.3809)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1328.44" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -34.3125 790.9372)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1337.91" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -32.7917 796.1232)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1342.65" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -32.0544 798.6232)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1347.38" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -31.4471 800.6078)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1352.12" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -30.5333 803.8099)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1356.85" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -29.9606 805.6624)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1361.59" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -29.0282 808.9323)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1371.06" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -27.5398 813.9901)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1366.32" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -28.4582 810.7808)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1375.79" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -26.9389 815.9647)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1380.53" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -26.018 819.1778)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1385.27" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -25.2817 821.6761)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1390" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -24.5129 824.3003)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1394.74" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -23.7595 826.8644)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1399.47" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -23.1987 828.6987)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1408.94" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -21.6962 833.8171)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1404.21" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -22.2545 831.9869)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1413.68" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -20.7494 837.1094)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1418.41" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -20.1758 839.0026)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1423.15" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -19.2623 842.1652)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1427.89" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -18.491 844.796)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1432.62" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -17.7391 847.3549)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1437.36" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -17.0042 849.8512)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1446.83" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -15.4807 855.0415)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1442.1" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -16.4367 851.735)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1451.56" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -14.9342 856.8534)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1456.3" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -13.9756 860.1639)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1461.03" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -13.4127 862.0406)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1465.77" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -12.4896 865.2181)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1470.5" y="445.02" transform="matrix(0.8413 -0.5405 0.5405 0.8413 -11.9101 867.1594)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1475.24" y="445.02" transform="matrix(0.8411 -0.5409 0.5409 0.8411 -10.9654 870.4094)" className="st9" width="1" height="17.69"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1472.42" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 299.418 1455.5522)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1477.15" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 300.7705 1458.5643)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1467.68" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 296.4207 1450.598)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1462.95" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 294.2455 1446.6144)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1458.21" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 292.0706 1442.6312)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1453.48" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 290.7048 1439.6104)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1448.74" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 287.7206 1434.6646)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1444.01" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 286.3484 1431.6399)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1433.75" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 281.6286 1423.0044)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1438.48" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 283.0078 1426.0336)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1429.01" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 278.6578 1418.0668)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1424.27" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 276.4806 1414.0796)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1419.54" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 274.3077 1410.1001)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1414.8" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 272.1306 1406.1128)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1410.07" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 269.9556 1402.1296)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1405.33" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 267.7805 1398.146)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1395.86" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 263.4307 1390.1797)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1400.6" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 266.3783 1395.1022)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1391.13" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 262.022 1387.1316)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1386.39" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 259.0808 1382.2134)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1381.65" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 256.9034 1378.2257)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1376.92" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 254.7308 1374.2467)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1372.18" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 252.5536 1370.2594)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1367.45" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 250.3785 1366.2758)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1358.77" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 247.1351 1359.8944)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1363.5" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 248.5665 1362.9573)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1354.03" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 244.2164 1354.9905)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1349.3" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 242.7788 1351.9238)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1344.56" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 239.8665 1347.0242)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1339.82" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 237.6892 1343.0365)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1335.09" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 235.5165 1339.0574)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1330.35" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 233.3393 1335.0702)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1320.09" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 228.6264 1326.4388)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1324.83" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 230.8035 1330.426)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1315.36" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 226.4515 1322.4557)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1310.62" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 224.2763 1318.472)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1305.89" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 222.8087 1315.3861)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1301.15" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 219.9265 1310.5057)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1296.42" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 218.4523 1307.4155)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1291.68" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 215.5766 1302.5394)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1282.21" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 211.2266 1294.5726)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1286.94" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 213.3993 1298.5518)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1277.47" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 209.0492 1290.585)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1272.74" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 206.8743 1286.6018)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1268" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 204.6994 1282.6187)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1263.27" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 203.2021 1279.5134)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1258.53" y="453.36" transform="matrix(0.5407 -0.8412 0.8412 0.5407 200.3493 1274.6519)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="1253.8" y="453.36" transform="matrix(0.54 -0.8417 0.8417 0.54 198.8457 1271.5428)" className="st9" width="17.69" height="1"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st4" d="M1408.27,582.58h-53.77c-4.77,0-8.63-3.86-8.63-8.63v-26.93c0-4.77,3.86-8.63,8.63-8.63h53.77
				c4.77,0,8.63,3.86,8.63,8.63v26.93C1416.9,578.71,1413.04,582.58,1408.27,582.58z"/>
		</g>
		<g>
			<path className="st6" d="M1408.26,583.57h-53.77c-5.31,0-9.63-4.32-9.63-9.63v-26.93c0-5.31,4.32-9.63,9.63-9.63h53.77
				c5.31,0,9.63,4.32,9.63,9.63v26.93C1417.89,579.25,1413.57,583.57,1408.26,583.57z M1354.5,539.38c-4.21,0-7.63,3.42-7.63,7.63
				v26.93c0,4.21,3.42,7.63,7.63,7.63h53.77c4.21,0,7.63-3.42,7.63-7.63v-26.93c0-4.21-3.42-7.63-7.63-7.63H1354.5z"/>
		</g>
	</g>
	<g>
		<g>
			<ellipse className="st4" cx="1378.22" cy="552.98" rx="11.84" ry="7.5"/>
		</g>
		<g>
			<path className="st6" d="M1378.22,560.98c-6.8,0-12.34-3.59-12.34-8s5.54-8,12.34-8s12.34,3.59,12.34,8
				S1385.03,560.98,1378.22,560.98z M1378.22,545.98c-6.25,0-11.34,3.14-11.34,7s5.09,7,11.34,7s11.34-3.14,11.34-7
				S1384.48,545.98,1378.22,545.98z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<polygon points="1403.57,549.48 1403.57,568.73 1405.26,568.73 1405.26,545.65 1401.19,549.48 				"/>
			</g>
			<g>
				<path d="M1405.38,568.86h-1.94v-19.25h-2.56l4.5-4.26V568.86z M1403.69,568.61h1.44v-22.67l-3.62,3.42h2.18V568.61z"/>
			</g>
		</g>
		<g>
			<g>
				<polygon points="1406.97,549.48 1409.34,549.48 1405.29,545.65 1405.29,568.73 1406.97,568.73 				"/>
			</g>
			<g>
				<path d="M1407.1,568.86h-1.94v-23.51l4.5,4.26h-2.56V568.86z M1405.41,568.61h1.44v-19.25h2.18l-3.62-3.42V568.61z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<g>
					<path d="M1374.71,568.61h-2.89v2.69h3.23v0.8h-4.2v-7.45h4.03v0.8h-3.06v2.36h2.89V568.61z"/>
				</g>
			</g>
			<g>
				<g>
					<path d="M1376.62,566.77l1.17,3.16c0.12,0.35,0.26,0.77,0.34,1.09h0.03c0.1-0.31,0.21-0.72,0.34-1.11l1.06-3.14h1.03
						l-1.46,3.81c-0.69,1.84-1.17,2.77-1.83,3.35c-0.48,0.42-0.95,0.58-1.19,0.62l-0.24-0.81c0.24-0.08,0.56-0.23,0.85-0.47
						c0.26-0.21,0.59-0.59,0.81-1.08c0.05-0.1,0.08-0.17,0.08-0.23c0-0.05-0.02-0.13-0.07-0.25l-1.97-4.93h1.05V566.77z"/>
				</g>
			</g>
			<g>
				<g>
					<path d="M1382.03,569.61c0.02,1.31,0.85,1.86,1.83,1.86c0.69,0,1.12-0.12,1.48-0.27l0.17,0.69c-0.34,0.16-0.93,0.34-1.78,0.34
						c-1.64,0-2.63-1.09-2.63-2.7c0-1.62,0.95-2.88,2.51-2.88c1.74,0,2.2,1.53,2.2,2.51c0,0.2-0.01,0.35-0.03,0.46L1382.03,569.61
						L1382.03,569.61z M1384.86,568.91c0.01-0.61-0.25-1.57-1.34-1.57c-0.99,0-1.41,0.9-1.49,1.57H1384.86z"/>
				</g>
			</g>
		</g>
	</g>
</g>
<g>
	<g>
		<rect x="1365.98" y="590.07" className="st8" width="34.73" height="34.73"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="792.9" className="st10" width="5" height="273.58"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="818.05" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="877.15" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="935.57" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="997.37" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="1168.81" className="st10" width="5" height="273.58"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="1193.94" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="1253.05" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="1311.47" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="1373.28" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="1600.81" className="st10" width="5" height="273.58"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="1625.94" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="1685.05" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="1743.47" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="1805.28" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="2050.35" className="st10" width="5" height="273.58"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="2075.49" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="2134.59" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="2193.01" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1160.8" y="2254.82" className="st11" width="5" height="29.77"/>
	</g>
</g>
<g>
	<g>
		<rect x="1372.72" y="596.51" className="st12" width="19.98" height="24.35"/>
	</g>
</g>
<g className="st13">
	<g>
		<path className="st4" d="M1386.02,616.68h-2.5v-15.91c-0.6,0.57-1.39,1.15-2.37,1.72c-0.98,0.57-1.85,1-2.63,1.29v-2.41
			c1.4-0.66,2.62-1.45,3.66-2.39c1.04-0.93,1.79-1.84,2.22-2.72h1.61V616.68z"/>
	</g>
</g>
<g>
	<g>
		<rect x="1307.84" y="474.54" className="st12" width="123.96" height="18.46"/>
	</g>
</g>
<g className="st13">
	<g>
		<path className="st14" d="M1309.22,485.92v-12.14h1.71l3.89,6.14c0.9,1.42,1.6,2.7,2.18,3.94l0.04-0.02c-0.14-1.62-0.18-3.1-0.18-4.99
			v-5.08h1.48v12.14h-1.58l-3.85-6.16c-0.85-1.35-1.66-2.74-2.27-4.05l-0.05,0.02c0.09,1.53,0.13,2.99,0.13,5.01v5.19H1309.22z"/>
	</g>
	<g>
		<path className="st14" d="M1328.53,473.14v10.53c0,0.77,0.02,1.66,0.07,2.25h-1.42l-0.07-1.51h-0.04c-0.49,0.97-1.55,1.71-2.97,1.71
			c-2.11,0-3.73-1.78-3.73-4.43c-0.02-2.9,1.78-4.68,3.91-4.68c1.33,0,2.23,0.63,2.63,1.33h0.04v-5.2H1328.53z M1326.95,480.75
			c0-0.2-0.02-0.47-0.07-0.67c-0.23-1.01-1.1-1.84-2.29-1.84c-1.64,0-2.61,1.44-2.61,3.37c0,1.76,0.86,3.22,2.57,3.22
			c1.06,0,2.04-0.7,2.32-1.89c0.05-0.22,0.07-0.43,0.07-0.68V480.75z"/>
	</g>
	<g>
		<path className="st14" d="M1330.94,484.3c0.47,0.31,1.3,0.63,2.09,0.63c1.15,0,1.69-0.58,1.69-1.3c0-0.76-0.45-1.17-1.62-1.6
			c-1.57-0.56-2.3-1.42-2.3-2.47c0-1.41,1.13-2.56,3.01-2.56c0.88,0,1.66,0.25,2.14,0.54l-0.4,1.15c-0.34-0.22-0.97-0.5-1.78-0.5
			c-0.94,0-1.46,0.54-1.46,1.19c0,0.72,0.52,1.04,1.66,1.48c1.51,0.58,2.29,1.33,2.29,2.63c0,1.53-1.19,2.61-3.26,2.61
			c-0.95,0-1.84-0.23-2.45-0.59L1330.94,484.3z"/>
	</g>
	<g>
		<path className="st14" d="M1338.29,479.56c0-0.9-0.02-1.64-0.07-2.36h1.39l0.07,1.4h0.05c0.49-0.83,1.3-1.6,2.74-1.6
			c1.19,0,2.09,0.72,2.47,1.75h0.04c0.27-0.49,0.61-0.86,0.97-1.13c0.52-0.4,1.1-0.61,1.93-0.61c1.15,0,2.86,0.76,2.86,3.78v5.13
			h-1.55v-4.93c0-1.67-0.61-2.68-1.89-2.68c-0.9,0-1.6,0.67-1.87,1.44c-0.07,0.22-0.13,0.5-0.13,0.79v5.38h-1.55v-5.22
			c0-1.39-0.61-2.39-1.82-2.39c-0.99,0-1.71,0.79-1.96,1.58c-0.09,0.23-0.13,0.5-0.13,0.77v5.26h-1.55V479.56z"/>
	</g>
</g>
<g>
	<g>
		<path className="st8" d="M1494.52,630.92c0.34-0.06,0.78-0.1,1.34-0.1c0.69,0,1.19,0.16,1.51,0.45c0.3,0.26,0.47,0.65,0.47,1.13
			c0,0.49-0.14,0.87-0.42,1.15c-0.37,0.39-0.97,0.59-1.65,0.59c-0.21,0-0.4-0.01-0.56-0.05v2.16h-0.7V630.92z M1495.21,633.52
			c0.15,0.04,0.34,0.06,0.58,0.06c0.84,0,1.35-0.41,1.35-1.15c0-0.71-0.5-1.05-1.27-1.05c-0.3,0-0.54,0.02-0.66,0.06V633.52z"/>
	</g>
	<g>
		<path className="st8" d="M1502.05,634.28c0,1.43-0.99,2.05-1.93,2.05c-1.05,0-1.85-0.77-1.85-1.99c0-1.29,0.85-2.05,1.92-2.05
			C1501.3,632.29,1502.05,633.09,1502.05,634.28z M1498.98,634.32c0,0.85,0.49,1.49,1.17,1.49c0.67,0,1.18-0.63,1.18-1.5
			c0-0.66-0.33-1.49-1.16-1.49C1499.34,632.82,1498.98,633.58,1498.98,634.32z"/>
	</g>
	<g>
		<path className="st8" d="M1502.94,633.42c0-0.4-0.01-0.73-0.03-1.05h0.62l0.04,0.64h0.02c0.19-0.37,0.64-0.73,1.28-0.73
			c0.54,0,1.37,0.32,1.37,1.65v2.31h-0.7v-2.23c0-0.62-0.23-1.14-0.9-1.14c-0.46,0-0.82,0.33-0.94,0.72
			c-0.03,0.09-0.05,0.21-0.05,0.33v2.33h-0.7V633.42z"/>
	</g>
	<g>
		<path className="st8" d="M1508.2,631.26v1.11h1.01v0.54h-1.01V635c0,0.48,0.14,0.75,0.53,0.75c0.18,0,0.32-0.02,0.41-0.05l0.03,0.53
			c-0.14,0.06-0.35,0.1-0.62,0.1c-0.33,0-0.59-0.1-0.76-0.3c-0.2-0.21-0.27-0.55-0.27-1.01v-2.11h-0.6v-0.54h0.6v-0.93
			L1508.2,631.26z"/>
	</g>
	<g>
		<path className="st8" d="M1511.69,633.42c0-0.4-0.01-0.73-0.03-1.05h0.62l0.04,0.64h0.02c0.19-0.37,0.64-0.73,1.28-0.73
			c0.54,0,1.37,0.32,1.37,1.65v2.31h-0.7v-2.23c0-0.62-0.23-1.14-0.9-1.14c-0.46,0-0.82,0.33-0.94,0.72
			c-0.03,0.09-0.05,0.21-0.05,0.33v2.33h-0.7V633.42z"/>
	</g>
	<g>
		<path className="st8" d="M1518.28,636.25l-0.06-0.49h-0.02c-0.22,0.3-0.63,0.58-1.18,0.58c-0.78,0-1.18-0.55-1.18-1.11
			c0-0.94,0.83-1.45,2.33-1.44v-0.08c0-0.32-0.09-0.9-0.88-0.9c-0.36,0-0.74,0.11-1.01,0.29l-0.16-0.46
			c0.32-0.21,0.78-0.34,1.27-0.34c1.18,0,1.47,0.81,1.47,1.58v1.45c0,0.34,0.02,0.66,0.06,0.93H1518.28z M1518.17,634.27
			c-0.77-0.02-1.64,0.12-1.64,0.87c0,0.46,0.3,0.67,0.66,0.67c0.5,0,0.82-0.32,0.94-0.65c0.02-0.07,0.04-0.15,0.04-0.22V634.27z"/>
	</g>
	<g>
		<path className="st8" d="M1522.13,636.25l-0.06-0.49h-0.02c-0.22,0.3-0.63,0.58-1.18,0.58c-0.78,0-1.18-0.55-1.18-1.11
			c0-0.94,0.83-1.45,2.33-1.44v-0.08c0-0.32-0.09-0.9-0.88-0.9c-0.36,0-0.74,0.11-1.01,0.29l-0.16-0.46
			c0.32-0.21,0.78-0.34,1.27-0.34c1.18,0,1.47,0.81,1.47,1.58v1.45c0,0.34,0.02,0.66,0.06,0.93H1522.13z M1522.03,634.27
			c-0.77-0.02-1.64,0.12-1.64,0.87c0,0.46,0.3,0.67,0.66,0.67c0.5,0,0.82-0.32,0.94-0.65c0.02-0.07,0.04-0.15,0.04-0.22V634.27z"/>
	</g>
	<g>
		<path className="st8" d="M1523.85,633.58c0-0.46-0.01-0.85-0.03-1.21h0.62l0.02,0.76h0.03c0.18-0.52,0.6-0.85,1.07-0.85
			c0.08,0,0.14,0.01,0.2,0.02v0.66c-0.07-0.02-0.14-0.02-0.24-0.02c-0.5,0-0.85,0.38-0.94,0.9c-0.02,0.1-0.03,0.21-0.03,0.33v2.06
			h-0.7V633.58z"/>
	</g>
	<g>
		<path className="st8" d="M1525.87,636.57l2.23-5.8h0.54l-2.24,5.8H1525.87z"/>
	</g>
	<g>
		<path className="st8" d="M1530.97,636.25v-3.33h-0.54v-0.54h0.54v-0.18c0-0.54,0.12-1.04,0.45-1.35c0.26-0.26,0.62-0.36,0.94-0.36
			c0.25,0,0.46,0.06,0.6,0.11l-0.1,0.54c-0.1-0.05-0.25-0.09-0.45-0.09c-0.6,0-0.75,0.53-0.75,1.12v0.21h0.94v0.54h-0.94v3.33
			H1530.97z"/>
	</g>
	<g>
		<path className="st8" d="M1533.53,634.44c0.02,0.95,0.62,1.34,1.33,1.34c0.5,0,0.81-0.09,1.07-0.2l0.12,0.5
			c-0.25,0.11-0.67,0.24-1.29,0.24c-1.19,0-1.9-0.78-1.9-1.95c0-1.17,0.69-2.09,1.82-2.09c1.26,0,1.6,1.11,1.6,1.82
			c0,0.14-0.02,0.26-0.02,0.33H1533.53z M1535.59,633.93c0.01-0.45-0.18-1.14-0.97-1.14c-0.71,0-1.02,0.66-1.08,1.14H1535.59z"/>
	</g>
	<g>
		<path className="st8" d="M1537.14,633.58c0-0.46-0.01-0.85-0.03-1.21h0.62l0.02,0.76h0.03c0.18-0.52,0.6-0.85,1.07-0.85
			c0.08,0,0.14,0.01,0.2,0.02v0.66c-0.07-0.02-0.14-0.02-0.24-0.02c-0.5,0-0.85,0.38-0.94,0.9c-0.02,0.1-0.03,0.21-0.03,0.33v2.06
			h-0.7V633.58z"/>
	</g>
	<g>
		<path className="st8" d="M1539.79,633.58c0-0.46-0.01-0.85-0.03-1.21h0.62l0.02,0.76h0.03c0.18-0.52,0.6-0.85,1.07-0.85
			c0.08,0,0.14,0.01,0.2,0.02v0.66c-0.07-0.02-0.14-0.02-0.24-0.02c-0.5,0-0.85,0.38-0.94,0.9c-0.02,0.1-0.03,0.21-0.03,0.33v2.06
			h-0.7V633.58z"/>
	</g>
	<g>
		<path className="st8" d="M1542.86,632.38l0.85,2.29c0.09,0.26,0.18,0.56,0.25,0.79h0.02c0.07-0.23,0.15-0.53,0.25-0.81l0.77-2.27h0.74
			l-1.06,2.76c-0.5,1.33-0.85,2.01-1.33,2.42c-0.34,0.3-0.69,0.42-0.86,0.46l-0.18-0.59c0.18-0.06,0.41-0.17,0.62-0.34
			c0.19-0.15,0.43-0.42,0.59-0.78c0.03-0.07,0.06-0.13,0.06-0.17s-0.02-0.1-0.05-0.18l-1.43-3.57H1542.86z"/>
	</g>
	<g>
		<path className="st8" d="M1548.92,631.26v1.11h1.01v0.54h-1.01V635c0,0.48,0.14,0.75,0.53,0.75c0.18,0,0.32-0.02,0.41-0.05l0.03,0.53
			c-0.14,0.06-0.35,0.1-0.62,0.1c-0.33,0-0.59-0.1-0.76-0.3c-0.2-0.21-0.27-0.55-0.27-1.01v-2.11h-0.6v-0.54h0.6v-0.93
			L1548.92,631.26z"/>
	</g>
	<g>
		<path className="st8" d="M1554.17,634.28c0,1.43-0.99,2.05-1.93,2.05c-1.05,0-1.85-0.77-1.85-1.99c0-1.29,0.85-2.05,1.92-2.05
			C1553.42,632.29,1554.17,633.09,1554.17,634.28z M1551.1,634.32c0,0.85,0.49,1.49,1.17,1.49c0.67,0,1.18-0.63,1.18-1.5
			c0-0.66-0.33-1.49-1.16-1.49C1551.46,632.82,1551.1,633.58,1551.1,634.32z"/>
	</g>
</g>
<g className="st13">
	<g>
		<path className="st14" d="M1447.15,477.44h-0.03l-1.58,0.85l-0.24-0.94l1.99-1.06h1.05v9.1h-1.19V477.44z"/>
	</g>
	<g>
		<path className="st14" d="M1457.71,480.74c0,3.1-1.15,4.8-3.17,4.8c-1.78,0-2.98-1.67-3.01-4.68c0-3.05,1.32-4.73,3.17-4.73
			C1456.62,476.13,1457.71,477.84,1457.71,480.74z M1452.77,480.88c0,2.37,0.73,3.71,1.85,3.71c1.26,0,1.86-1.47,1.86-3.8
			c0-2.24-0.57-3.71-1.85-3.71C1453.55,477.09,1452.77,478.4,1452.77,480.88z"/>
	</g>
	<g>
		<path className="st14" d="M1458.94,479.73c0-0.52,0.35-0.88,0.84-0.88s0.81,0.36,0.83,0.88c0,0.49-0.32,0.87-0.84,0.87
			C1459.28,480.6,1458.94,480.22,1458.94,479.73z M1458.94,484.68c0-0.52,0.35-0.88,0.84-0.88s0.81,0.36,0.83,0.88
			c0,0.49-0.32,0.87-0.84,0.87C1459.28,485.55,1458.94,485.17,1458.94,484.68z"/>
	</g>
	<g>
		<path className="st14" d="M1462.03,483.98c0.35,0.22,1.16,0.57,2.02,0.57c1.58,0,2.07-1.01,2.06-1.76c-0.01-1.27-1.16-1.82-2.35-1.82
			h-0.69v-0.92h0.69c0.9,0,2.03-0.46,2.03-1.54c0-0.73-0.46-1.37-1.6-1.37c-0.73,0-1.43,0.32-1.82,0.6l-0.32-0.9
			c0.48-0.35,1.4-0.7,2.38-0.7c1.79,0,2.61,1.06,2.61,2.17c0,0.94-0.56,1.74-1.68,2.14v0.03c1.12,0.22,2.03,1.06,2.03,2.34
			c0,1.46-1.13,2.73-3.32,2.73c-1.02,0-1.92-0.32-2.37-0.62L1462.03,483.98z"/>
	</g>
	<g>
		<path className="st14" d="M1471.6,477.44h-0.03l-1.58,0.85l-0.24-0.94l1.99-1.06h1.05v9.1h-1.19V477.44z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="880.58" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,958.86h-79.28v-79.28h79.28V958.86z M219.35,956.86h75.28v-75.28h-75.28V956.86z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="880.58" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,958.86H371.9v-79.28h79.28V958.86z M373.9,956.86h75.28v-75.28H373.9V956.86z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="880.58" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,958.86h-79.28v-79.28h79.28V958.86z M451.18,956.86h75.28v-75.28h-75.28V956.86z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="880.58" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,958.86h-79.28v-79.28h79.28V958.86z M528.45,956.86h75.28v-75.28h-75.28V956.86z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="880.58" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,958.86h-79.28v-79.28h79.28V958.86z M605.73,956.86h75.28v-75.28h-75.28V956.86z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="957.85" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,1036.14h-79.28v-79.28h79.28V1036.14z M605.73,1034.14h75.28v-75.28h-75.28V1034.14z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="957.85" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,1036.14h-79.28v-79.28h79.28V1036.14z M451.18,1034.14h75.28v-75.28h-75.28V1034.14z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="957.85" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,1036.14h-79.28v-79.28h79.28V1036.14z M528.45,1034.14h75.28v-75.28h-75.28V1034.14z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="957.85" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,1036.14h-79.28v-79.28h79.28V1036.14z M296.62,1034.14h75.28v-75.28h-75.28V1034.14z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="957.85" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,1036.14h-79.28v-79.28h79.28V1036.14z M219.35,1034.14h75.28v-75.28h-75.28V1034.14z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="957.85" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,1036.14H371.9v-79.28h79.28V1036.14z M373.9,1034.14h75.28v-75.28H373.9V1034.14z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="1035.14" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,1113.41h-79.28v-79.28h79.28V1113.41z M605.73,1111.41h75.28v-75.28h-75.28V1111.41z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="1035.14" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,1113.41h-79.28v-79.28h79.28V1113.41z M451.18,1111.41h75.28v-75.28h-75.28V1111.41z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="1035.14" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,1113.41h-79.28v-79.28h79.28V1113.41z M528.45,1111.41h75.28v-75.28h-75.28V1111.41z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="1035.14" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,1113.41h-79.28v-79.28h79.28V1113.41z M296.62,1111.41h75.28v-75.28h-75.28V1111.41z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="1035.14" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,1113.41h-79.28v-79.28h79.28V1113.41z M219.35,1111.41h75.28v-75.28h-75.28V1111.41z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="1035.14" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,1113.41H371.9v-79.28h79.28V1113.41z M373.9,1111.41h75.28v-75.28H373.9V1111.41z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="1112.41" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,1190.69h-79.28v-79.28h79.28V1190.69z M605.73,1188.69h75.28v-75.28h-75.28V1188.69z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="1112.41" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,1190.69h-79.28v-79.28h79.28V1190.69z M451.18,1188.69h75.28v-75.28h-75.28V1188.69z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="1112.41" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,1190.69h-79.28v-79.28h79.28V1190.69z M528.45,1188.69h75.28v-75.28h-75.28V1188.69z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="1112.41" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,1190.69h-79.28v-79.28h79.28V1190.69z M296.62,1188.69h75.28v-75.28h-75.28V1188.69z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="1112.41" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,1190.69h-79.28v-79.28h79.28V1190.69z M219.35,1188.69h75.28v-75.28h-75.28V1188.69z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="1112.41" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,1190.69H371.9v-79.28h79.28V1190.69z M373.9,1188.69h75.28v-75.28H373.9V1188.69z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="1189.69" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,1267.97h-79.28v-79.28h79.28V1267.97z M605.73,1265.97h75.28v-75.28h-75.28V1265.97z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="1189.69" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,1267.97h-79.28v-79.28h79.28V1267.97z M451.18,1265.97h75.28v-75.28h-75.28V1265.97z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="1189.69" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,1267.97h-79.28v-79.28h79.28V1267.97z M528.45,1265.97h75.28v-75.28h-75.28V1265.97z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="1189.69" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,1267.97h-79.28v-79.28h79.28V1267.97z M296.62,1265.97h75.28v-75.28h-75.28V1265.97z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="1189.69" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,1267.97h-79.28v-79.28h79.28V1267.97z M219.35,1265.97h75.28v-75.28h-75.28V1265.97z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="880.58" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,958.86h-79.28v-79.28h79.28V958.86z M142.35,956.86h75.28v-75.28h-75.28V956.86z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="957.85" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,1036.14h-79.28v-79.28h79.28V1036.14z M142.35,1034.14h75.28v-75.28h-75.28V1034.14z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="1035.14" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,1113.41h-79.28v-79.28h79.28V1113.41z M142.35,1111.41h75.28v-75.28h-75.28V1111.41z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="1112.41" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,1190.69h-79.28v-79.28h79.28V1190.69z M142.35,1188.69h75.28v-75.28h-75.28V1188.69z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="1189.69" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,1267.97h-79.28v-79.28h79.28V1267.97z M142.35,1265.97h75.28v-75.28h-75.28V1265.97z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="1189.69" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,1267.97H371.9v-79.28h79.28V1267.97z M373.9,1265.97h75.28v-75.28H373.9V1265.97z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="880.58" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,958.86h-79.28v-79.28h79.28V958.86z M296.62,956.86h75.28v-75.28h-75.28V956.86z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="1266.96" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,1345.23h-79.28v-79.28h79.28V1345.23z M219.35,1343.23h75.28v-75.28h-75.28V1343.23z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="1266.96" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,1345.23H371.9v-79.28h79.28V1345.23z M373.9,1343.23h75.28v-75.28H373.9V1343.23z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="1266.96" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,1345.23h-79.28v-79.28h79.28V1345.23z M451.18,1343.23h75.28v-75.28h-75.28V1343.23z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="1266.96" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,1345.23h-79.28v-79.28h79.28V1345.23z M528.45,1343.23h75.28v-75.28h-75.28V1343.23z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="1266.96" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,1345.23h-79.28v-79.28h79.28V1345.23z M605.73,1343.23h75.28v-75.28h-75.28V1343.23z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="1344.23" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,1422.52h-79.28v-79.28h79.28V1422.52z M605.73,1420.52h75.28v-75.28h-75.28V1420.52z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="1344.23" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,1422.52h-79.28v-79.28h79.28V1422.52z M451.18,1420.52h75.28v-75.28h-75.28V1420.52z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="1344.23" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,1422.52h-79.28v-79.28h79.28V1422.52z M528.45,1420.52h75.28v-75.28h-75.28V1420.52z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="1344.23" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,1422.52h-79.28v-79.28h79.28V1422.52z M296.62,1420.52h75.28v-75.28h-75.28V1420.52z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="1344.23" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,1422.52h-79.28v-79.28h79.28V1422.52z M219.35,1420.52h75.28v-75.28h-75.28V1420.52z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="1344.23" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,1422.52H371.9v-79.28h79.28V1422.52z M373.9,1420.52h75.28v-75.28H373.9V1420.52z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="1498.78" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,1577.07h-79.28v-79.28h79.28V1577.07z M605.73,1575.07h75.28v-75.28h-75.28V1575.07z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="1498.78" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,1577.07h-79.28v-79.28h79.28V1577.07z M451.18,1575.07h75.28v-75.28h-75.28V1575.07z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="1498.78" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,1577.07h-79.28v-79.28h79.28V1577.07z M528.45,1575.07h75.28v-75.28h-75.28V1575.07z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="1498.78" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,1577.07h-79.28v-79.28h79.28V1577.07z M296.62,1575.07h75.28v-75.28h-75.28V1575.07z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="1498.78" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,1577.07h-79.28v-79.28h79.28V1577.07z M219.35,1575.07h75.28v-75.28h-75.28V1575.07z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="1498.78" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,1577.07H371.9v-79.28h79.28V1577.07z M373.9,1575.07h75.28v-75.28H373.9V1575.07z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="1576.05" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,1654.33h-79.28v-79.28h79.28V1654.33z M605.73,1652.33h75.28v-75.28h-75.28V1652.33z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="1576.05" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,1654.33h-79.28v-79.28h79.28V1654.33z M451.18,1652.33h75.28v-75.28h-75.28V1652.33z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="1576.05" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,1654.33h-79.28v-79.28h79.28V1654.33z M528.45,1652.33h75.28v-75.28h-75.28V1652.33z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="1576.05" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,1654.33h-79.28v-79.28h79.28V1654.33z M296.62,1652.33h75.28v-75.28h-75.28V1652.33z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="1576.05" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,1654.33h-79.28v-79.28h79.28V1654.33z M219.35,1652.33h75.28v-75.28h-75.28V1652.33z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="1576.05" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,1654.33H371.9v-79.28h79.28V1654.33z M373.9,1652.33h75.28v-75.28H373.9V1652.33z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="1266.96" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,1345.23h-79.28v-79.28h79.28V1345.23z M142.35,1343.23h75.28v-75.28h-75.28V1343.23z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="1344.23" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,1422.52h-79.28v-79.28h79.28V1422.52z M142.35,1420.52h75.28v-75.28h-75.28V1420.52z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="1498.78" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,1577.07h-79.28v-79.28h79.28V1577.07z M142.35,1575.07h75.28v-75.28h-75.28V1575.07z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="1576.05" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,1654.33h-79.28v-79.28h79.28V1654.33z M142.35,1652.33h75.28v-75.28h-75.28V1652.33z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="1730.61" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,1808.9h-79.28v-79.28h79.28V1808.9z M605.73,1806.9h75.28v-75.28h-75.28V1806.9z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="1730.61" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,1808.9h-79.28v-79.28h79.28V1808.9z M451.18,1806.9h75.28v-75.28h-75.28V1806.9z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="1730.61" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,1808.9h-79.28v-79.28h79.28V1808.9z M528.45,1806.9h75.28v-75.28h-75.28V1806.9z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="1730.61" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,1808.9h-79.28v-79.28h79.28V1808.9z M296.62,1806.9h75.28v-75.28h-75.28V1806.9z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="1730.61" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,1808.9h-79.28v-79.28h79.28V1808.9z M219.35,1806.9h75.28v-75.28h-75.28V1806.9z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="1730.61" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,1808.9H371.9v-79.28h79.28V1808.9z M373.9,1806.9h75.28v-75.28H373.9V1806.9z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="1807.88" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,1886.16h-79.28v-79.28h79.28V1886.16z M605.73,1884.16h75.28v-75.28h-75.28V1884.16z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="1807.88" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,1886.16h-79.28v-79.28h79.28V1886.16z M451.18,1884.16h75.28v-75.28h-75.28V1884.16z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="1807.88" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,1886.16h-79.28v-79.28h79.28V1886.16z M528.45,1884.16h75.28v-75.28h-75.28V1884.16z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="1807.88" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,1886.16h-79.28v-79.28h79.28V1886.16z M296.62,1884.16h75.28v-75.28h-75.28V1884.16z"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-1352.53" y1="1028.54" x2="-1352.53" y2="1252.89"/>
	</g>
	<g>
		<rect x="-1355.03" y="1028.54" className="st2" width="5" height="224.35"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-1352.53" y1="1417.11" x2="-1352.53" y2="1641.46"/>
	</g>
	<g>
		<rect x="-1355.03" y="1417.11" className="st2" width="5" height="224.35"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-1352.53" y1="1815.37" x2="-1352.53" y2="2039.72"/>
	</g>
	<g>
		<rect x="-1355.03" y="1815.37" className="st2" width="5" height="224.35"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-1352.53" y1="2204.65" x2="-1352.53" y2="2429"/>
	</g>
	<g>
		<rect x="-1355.03" y="2204.65" className="st2" width="5" height="224.35"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="1807.88" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,1886.16h-79.28v-79.28h79.28V1886.16z M219.35,1884.16h75.28v-75.28h-75.28V1884.16z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="1807.88" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,1886.16H371.9v-79.28h79.28V1886.16z M373.9,1884.16h75.28v-75.28H373.9V1884.16z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="1730.61" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,1808.9h-79.28v-79.28h79.28V1808.9z M142.35,1806.9h75.28v-75.28h-75.28V1806.9z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="1807.88" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,1886.16h-79.28v-79.28h79.28V1886.16z M142.35,1884.16h75.28v-75.28h-75.28V1884.16z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="1962.44" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,2040.72h-79.28v-79.28h79.28V2040.72z M605.73,2038.72h75.28v-75.28h-75.28V2038.72z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="1962.44" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,2040.72h-79.28v-79.28h79.28V2040.72z M451.18,2038.72h75.28v-75.28h-75.28V2038.72z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="1962.44" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,2040.72h-79.28v-79.28h79.28V2040.72z M528.45,2038.72h75.28v-75.28h-75.28V2038.72z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="1962.44" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,2040.72h-79.28v-79.28h79.28V2040.72z M296.62,2038.72h75.28v-75.28h-75.28V2038.72z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="1962.44" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,2040.72h-79.28v-79.28h79.28V2040.72z M219.35,2038.72h75.28v-75.28h-75.28V2038.72z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="1962.44" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,2040.72H371.9v-79.28h79.28V2040.72z M373.9,2038.72h75.28v-75.28H373.9V2038.72z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="2039.71" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,2117.99h-79.28v-79.28h79.28V2117.99z M605.73,2115.99h75.28v-75.28h-75.28V2115.99z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="2039.71" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,2117.99h-79.28v-79.28h79.28V2117.99z M451.18,2115.99h75.28v-75.28h-75.28V2115.99z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="2039.71" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,2117.99h-79.28v-79.28h79.28V2117.99z M528.45,2115.99h75.28v-75.28h-75.28V2115.99z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="2039.71" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,2117.99h-79.28v-79.28h79.28V2117.99z M296.62,2115.99h75.28v-75.28h-75.28V2115.99z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="2039.71" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,2117.99h-79.28v-79.28h79.28V2117.99z M219.35,2115.99h75.28v-75.28h-75.28V2115.99z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="2039.71" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,2117.99H371.9v-79.28h79.28V2117.99z M373.9,2115.99h75.28v-75.28H373.9V2115.99z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="1962.44" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,2040.72h-79.28v-79.28h79.28V2040.72z M142.35,2038.72h75.28v-75.28h-75.28V2038.72z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="2039.71" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,2117.99h-79.28v-79.28h79.28V2117.99z M142.35,2115.99h75.28v-75.28h-75.28V2115.99z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="2194.27" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,2272.55h-79.28v-79.28h79.28V2272.55z M605.73,2270.55h75.28v-75.28h-75.28V2270.55z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="2194.27" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,2272.55h-79.28v-79.28h79.28V2272.55z M451.18,2270.55h75.28v-75.28h-75.28V2270.55z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="2194.27" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,2272.55h-79.28v-79.28h79.28V2272.55z M528.45,2270.55h75.28v-75.28h-75.28V2270.55z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="2194.27" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,2272.55h-79.28v-79.28h79.28V2272.55z M296.62,2270.55h75.28v-75.28h-75.28V2270.55z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="2194.27" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,2272.55h-79.28v-79.28h79.28V2272.55z M219.35,2270.55h75.28v-75.28h-75.28V2270.55z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="2194.27" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,2272.55H371.9v-79.28h79.28V2272.55z M373.9,2270.55h75.28v-75.28H373.9V2270.55z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="2194.27" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,2272.55h-79.28v-79.28h79.28V2272.55z M142.35,2270.55h75.28v-75.28h-75.28V2270.55z"/>
	</g>
</g>
<g>
	<g>
		<rect x="604.73" y="2348.83" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M683.01,2427.11h-79.28v-79.28h79.28V2427.11z M605.73,2425.11h75.28v-75.28h-75.28V2425.11z"/>
	</g>
</g>
<g>
	<g>
		<rect x="450.18" y="2348.83" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M528.46,2427.11h-79.28v-79.28h79.28V2427.11z M451.18,2425.11h75.28v-75.28h-75.28V2425.11z"/>
	</g>
</g>
<g>
	<g>
		<rect x="527.45" y="2348.83" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M605.73,2427.11h-79.28v-79.28h79.28V2427.11z M528.45,2425.11h75.28v-75.28h-75.28V2425.11z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="2348.83" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,2427.11h-79.28v-79.28h79.28V2427.11z M296.62,2425.11h75.28v-75.28h-75.28V2425.11z"/>
	</g>
</g>
<g>
	<g>
		<rect x="218.35" y="2348.83" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M296.63,2427.11h-79.28v-79.28h79.28V2427.11z M219.35,2425.11h75.28v-75.28h-75.28V2425.11z"/>
	</g>
</g>
<g>
	<g>
		<rect x="372.9" y="2348.83" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M451.18,2427.11H371.9v-79.28h79.28V2427.11z M373.9,2425.11h75.28v-75.28H373.9V2425.11z"/>
	</g>
</g>
<g>
	<g>
		<rect x="141.35" y="2348.83" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M219.63,2427.11h-79.28v-79.28h79.28V2427.11z M142.35,2425.11h75.28v-75.28h-75.28V2425.11z"/>
	</g>
</g>
<g>
	<g>
		<rect x="295.62" y="1266.96" className="st1" width="77.28" height="77.28"/>
	</g>
	<g>
		<path className="st15" d="M373.9,1345.23h-79.28v-79.28h79.28V1345.23z M296.62,1343.23h75.28v-75.28h-75.28V1343.23z"/>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st4" d="M162.95,833.97c0.41,0.22,0.65,0.54,0.72,0.97c0.07,0.43-0.04,0.84-0.32,1.22
				c-0.22,0.29-0.49,0.45-0.83,0.49c-0.34,0.04-0.67-0.03-1.01-0.2c-0.79-0.48-1.64-0.86-2.56-1.13c-0.91-0.28-1.87-0.41-2.88-0.41
				c-1.42,0-2.71,0.24-3.89,0.72c-1.18,0.48-2.2,1.17-3.06,2.07c-0.86,0.9-1.54,1.96-2.02,3.19c-0.48,1.22-0.72,2.57-0.72,4.03
				c0,1.58,0.25,3,0.76,4.25c0.5,1.25,1.19,2.31,2.07,3.19c0.88,0.88,1.9,1.54,3.06,2c1.16,0.46,2.43,0.68,3.8,0.68
				c0.98,0,1.93-0.13,2.84-0.4c0.91-0.26,1.76-0.65,2.56-1.15c0.34-0.17,0.68-0.23,1.03-0.18c0.35,0.05,0.63,0.22,0.85,0.5
				c0.31,0.38,0.43,0.79,0.34,1.21c-0.08,0.42-0.32,0.74-0.7,0.95c-0.6,0.36-1.28,0.68-2.05,0.97s-1.57,0.52-2.39,0.68
				c-0.83,0.17-1.65,0.25-2.47,0.25c-1.73,0-3.36-0.3-4.9-0.9c-1.54-0.6-2.9-1.46-4.09-2.57s-2.12-2.47-2.79-4.07
				s-1.01-3.4-1.01-5.42c0-1.85,0.32-3.56,0.97-5.13c0.65-1.57,1.55-2.93,2.7-4.09c1.15-1.15,2.5-2.04,4.05-2.68
				c1.55-0.64,3.23-0.95,5.06-0.95c1.25,0,2.46,0.16,3.64,0.49C160.88,832.87,161.96,833.35,162.95,833.97z"/>
			<path className="st4" d="M181.45,838.61c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04v15.66c0,2.04-0.4,3.72-1.19,5.04
				c-0.79,1.32-1.85,2.3-3.19,2.95c-1.33,0.65-2.84,0.97-4.52,0.97c-0.94,0-1.84-0.1-2.7-0.29c-0.86-0.19-1.57-0.44-2.12-0.76
				c-0.46-0.22-0.78-0.49-0.97-0.81c-0.19-0.32-0.22-0.67-0.07-1.03c0.17-0.43,0.41-0.73,0.74-0.9c0.32-0.17,0.67-0.17,1.03,0
				c0.38,0.17,0.94,0.4,1.67,0.7c0.73,0.3,1.55,0.45,2.47,0.45c1.25,0,2.32-0.24,3.2-0.72c0.89-0.48,1.57-1.18,2.05-2.11
				c0.48-0.92,0.72-2.07,0.72-3.44v-2.52l0.4,0.86c-0.36,0.77-0.86,1.43-1.51,1.98c-0.65,0.55-1.4,0.98-2.25,1.28
				c-0.85,0.3-1.77,0.45-2.75,0.45c-1.39,0-2.56-0.29-3.51-0.88c-0.95-0.59-1.66-1.4-2.14-2.45s-0.72-2.24-0.72-3.58v-10.87
				c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.62-0.43,1.03-0.43c0.43,0,0.78,0.14,1.04,0.43c0.26,0.29,0.4,0.64,0.4,1.04v10.19
				c0,1.63,0.36,2.86,1.08,3.69s1.84,1.24,3.35,1.24c0.96,0,1.82-0.22,2.59-0.65c0.77-0.43,1.39-1.03,1.85-1.78
				c0.47-0.76,0.7-1.59,0.7-2.5v-10.19c0-0.41,0.14-0.76,0.41-1.04C180.66,838.76,181.02,838.61,181.45,838.61z"/>
			<path className="st4" d="M196.32,838.43c1.22,0,2.33,0.13,3.31,0.4c0.98,0.26,1.76,0.62,2.34,1.08s0.86,0.97,0.86,1.55
				c0,0.34-0.1,0.65-0.31,0.94c-0.2,0.29-0.5,0.43-0.88,0.43c-0.34,0-0.61-0.07-0.81-0.2c-0.2-0.13-0.4-0.29-0.58-0.47
				c-0.18-0.18-0.43-0.35-0.74-0.52c-0.29-0.14-0.71-0.27-1.26-0.38c-0.55-0.11-1.1-0.16-1.66-0.16c-1.3,0-2.45,0.31-3.46,0.94
				c-1.01,0.62-1.79,1.46-2.36,2.52c-0.56,1.06-0.85,2.26-0.85,3.6c0,1.34,0.28,2.54,0.83,3.6c0.55,1.06,1.32,1.9,2.3,2.52
				c0.98,0.62,2.12,0.94,3.42,0.94c0.82,0,1.48-0.07,1.98-0.22c0.5-0.14,0.92-0.31,1.26-0.5c0.43-0.24,0.76-0.48,0.99-0.72
				c0.23-0.24,0.53-0.36,0.92-0.36c0.43,0,0.76,0.13,0.97,0.4c0.22,0.26,0.32,0.59,0.32,0.97c0,0.46-0.3,0.92-0.9,1.4
				c-0.6,0.48-1.41,0.88-2.43,1.21c-1.02,0.32-2.18,0.49-3.47,0.49c-1.82,0-3.42-0.43-4.79-1.28c-1.37-0.85-2.43-2.02-3.19-3.49
				c-0.76-1.48-1.13-3.13-1.13-4.95c0-1.82,0.39-3.47,1.17-4.93c0.78-1.46,1.87-2.63,3.26-3.49
				C192.85,838.87,194.47,838.43,196.32,838.43z"/>
			<path className="st4" d="M209.89,856.04c0,0.41-0.14,0.76-0.43,1.04s-0.64,0.43-1.04,0.43c-0.41,0-0.75-0.14-1.03-0.43
				c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69c0-0.41,0.14-0.76,0.43-1.04s0.64-0.43,1.04-0.43c0.43,0,0.78,0.14,1.04,0.43
				c0.26,0.29,0.4,0.64,0.4,1.04V856.04z"/>
			<path className="st4" d="M216.77,836.2c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36c0.29,0.24,0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C217.78,836.08,217.34,836.2,216.77,836.2z M218.24,856.04c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V856.04z"/>
			<path className="st4" d="M222.35,854.56c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S223.28,855.79,222.35,854.56z"/>
			<path className="st4" d="M239.77,839.01h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C239.09,839.14,239.41,839.01,239.77,839.01z M243.55,834.11c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C242.79,834.26,243.14,834.11,243.55,834.11z"/>
			<path className="st4" d="M252.48,854.56c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S253.41,855.79,252.48,854.56z"/>
			<path className="st4" d="M302.48,838.58c0.38,0,0.71,0.13,0.99,0.4c0.28,0.26,0.41,0.62,0.41,1.08c0,0.1-0.01,0.2-0.02,0.31
				c-0.01,0.11-0.04,0.2-0.09,0.27l-5.54,15.95c-0.12,0.31-0.32,0.56-0.59,0.74c-0.28,0.18-0.57,0.25-0.88,0.2
				c-0.55-0.02-0.97-0.34-1.26-0.94l-4.54-11.34l0.72,0.11l-4.1,11.23c-0.26,0.6-0.68,0.91-1.26,0.94c-0.31,0.05-0.61-0.02-0.9-0.2
				c-0.29-0.18-0.49-0.43-0.61-0.74l-5.62-15.95c-0.07-0.19-0.11-0.38-0.11-0.58c0-0.41,0.13-0.76,0.4-1.04
				c0.26-0.29,0.62-0.43,1.08-0.43c0.29,0,0.55,0.07,0.79,0.22c0.24,0.14,0.41,0.38,0.5,0.72l4.86,14.15l-0.76-0.04l4.18-10.8
				c0.26-0.6,0.72-0.9,1.37-0.9c0.34,0,0.61,0.08,0.81,0.23c0.2,0.16,0.35,0.38,0.45,0.67l4.39,10.8l-0.9,0.07l4.86-14.18
				C301.31,838.89,301.76,838.58,302.48,838.58z"/>
			<path className="st4" d="M309.07,836.2c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36c0.29,0.24,0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C310.08,836.08,309.65,836.2,309.07,836.2z M310.54,856.04c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V856.04z"/>
			<path className="st4" d="M315.01,839.01h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C314.33,839.14,314.65,839.01,315.01,839.01z M318.79,834.11c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C318.03,834.26,318.38,834.11,318.79,834.11z"/>
			<path className="st4" d="M337.8,838.61c1.58,0,2.84,0.34,3.76,1.03s1.58,1.6,1.98,2.74s0.59,2.41,0.59,3.8v9.86
				c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.7-0.4-2.45c-0.26-0.74-0.7-1.34-1.31-1.78c-0.61-0.44-1.45-0.67-2.5-0.67c-0.98,0-1.88,0.22-2.7,0.67
				c-0.82,0.44-1.46,1.04-1.94,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.62-0.43,1.03-0.43
				c0.43,0,0.78,0.14,1.04,0.43c0.26,0.29,0.4,0.64,0.4,1.04v10.73l-0.72,0.79c0.12-0.62,0.38-1.25,0.79-1.89
				c0.41-0.64,0.92-1.21,1.55-1.71c0.62-0.5,1.32-0.91,2.09-1.21C336.15,838.76,336.96,838.61,337.8,838.61z"/>
			<path className="st4" d="M368.25,838.61c1.63,0,2.96,0.41,3.98,1.24c1.02,0.83,1.7,2,2.03,3.51h-0.54l0.25-0.65
				c0.29-0.67,0.78-1.32,1.48-1.94c0.7-0.62,1.5-1.14,2.41-1.55c0.91-0.41,1.86-0.61,2.84-0.61c1.58,0,2.83,0.34,3.74,1.03
				s1.57,1.6,1.96,2.74s0.59,2.42,0.59,3.83v9.83c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.63,0.43-1.06,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-9.76c0-0.91-0.13-1.75-0.4-2.5c-0.26-0.76-0.71-1.36-1.33-1.82
				c-0.62-0.46-1.46-0.68-2.52-0.68c-0.96,0-1.85,0.23-2.66,0.68s-1.46,1.06-1.94,1.82c-0.48,0.76-0.72,1.59-0.72,2.5v9.76
				c0,0.41-0.13,0.76-0.4,1.04s-0.61,0.43-1.04,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.7-0.4-2.45c-0.26-0.74-0.7-1.34-1.3-1.78c-0.6-0.44-1.42-0.67-2.45-0.67c-0.96,0-1.84,0.22-2.63,0.67
				c-0.79,0.44-1.43,1.04-1.91,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41
				c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v2.7l-0.79,0.86c0.1-0.62,0.34-1.25,0.74-1.87
				c0.4-0.62,0.91-1.2,1.53-1.73c0.62-0.53,1.32-0.95,2.09-1.26S367.39,838.61,368.25,838.61z"/>
			<path className="st4" d="M407.49,838.72c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.62,0.4,1.03v15.88c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.07c0,0.55-0.18,1.13-0.54,1.75
				c-0.36,0.61-0.85,1.19-1.48,1.73s-1.36,0.98-2.21,1.33c-0.85,0.35-1.76,0.52-2.72,0.52c-1.66,0-3.13-0.43-4.43-1.28
				c-1.3-0.85-2.32-2.01-3.08-3.47c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.57,1.13-5.02c0.76-1.45,1.78-2.59,3.08-3.42
				s2.74-1.24,4.32-1.24c1.03,0,1.99,0.17,2.88,0.5c0.89,0.34,1.66,0.79,2.32,1.37c0.66,0.58,1.18,1.21,1.55,1.91
				s0.56,1.39,0.56,2.09l-0.94-0.22v-3.92c0-0.41,0.13-0.75,0.4-1.03C406.71,838.86,407.06,838.72,407.49,838.72z M400.08,855.21
				c1.2,0,2.26-0.31,3.19-0.94c0.92-0.62,1.64-1.47,2.16-2.54c0.52-1.07,0.77-2.27,0.77-3.62c0-1.32-0.26-2.51-0.77-3.56
				c-0.52-1.06-1.24-1.9-2.16-2.52c-0.92-0.62-1.99-0.94-3.19-0.94c-1.18,0-2.23,0.31-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.5
				c-0.53,1.06-0.79,2.26-0.79,3.6c0,1.34,0.26,2.55,0.79,3.62c0.53,1.07,1.25,1.91,2.18,2.54
				C397.85,854.9,398.9,855.21,400.08,855.21z"/>
			<path className="st4" d="M413.18,854.56c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S414.12,855.79,413.18,854.56z"/>
			<path className="st4" d="M433.05,857.51c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69
				c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04v23.69
				c0,0.41-0.14,0.76-0.41,1.04C433.8,857.37,433.46,857.51,433.05,857.51z M445,838.79c0.38,0,0.71,0.15,0.99,0.45
				c0.28,0.3,0.41,0.62,0.41,0.95c0,0.38-0.19,0.74-0.58,1.08l-11.66,10.19l-0.11-3.38l9.9-8.86
				C444.27,838.94,444.62,838.79,445,838.79z M445.4,857.48c-0.43,0-0.79-0.16-1.08-0.47l-7.67-8.17l2.16-1.98l7.6,8.14
				c0.29,0.31,0.43,0.67,0.43,1.08c0,0.43-0.17,0.77-0.5,1.03S445.69,857.48,445.4,857.48z"/>
			<path className="st4" d="M449.94,854.56c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S450.87,855.79,449.94,854.56z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st4" d="M162.95,1456.91c0.41,0.22,0.65,0.54,0.72,0.97c0.07,0.43-0.04,0.84-0.32,1.22
				c-0.22,0.29-0.49,0.45-0.83,0.49c-0.34,0.04-0.67-0.03-1.01-0.2c-0.79-0.48-1.64-0.86-2.56-1.13c-0.91-0.28-1.87-0.41-2.88-0.41
				c-1.42,0-2.71,0.24-3.89,0.72c-1.18,0.48-2.2,1.17-3.06,2.07c-0.86,0.9-1.54,1.96-2.02,3.19c-0.48,1.22-0.72,2.57-0.72,4.03
				c0,1.58,0.25,3,0.76,4.25c0.5,1.25,1.19,2.31,2.07,3.19c0.88,0.88,1.9,1.54,3.06,2c1.16,0.46,2.43,0.68,3.8,0.68
				c0.98,0,1.93-0.13,2.84-0.4c0.91-0.26,1.76-0.65,2.56-1.15c0.34-0.17,0.68-0.23,1.03-0.18c0.35,0.05,0.63,0.22,0.85,0.5
				c0.31,0.38,0.43,0.79,0.34,1.21c-0.08,0.42-0.32,0.74-0.7,0.95c-0.6,0.36-1.28,0.68-2.05,0.97s-1.57,0.52-2.39,0.68
				c-0.83,0.17-1.65,0.25-2.47,0.25c-1.73,0-3.36-0.3-4.9-0.9c-1.54-0.6-2.9-1.46-4.09-2.57s-2.12-2.47-2.79-4.07
				s-1.01-3.4-1.01-5.42c0-1.85,0.32-3.56,0.97-5.13c0.65-1.57,1.55-2.93,2.7-4.09c1.15-1.15,2.5-2.04,4.05-2.68
				c1.55-0.64,3.23-0.95,5.06-0.95c1.25,0,2.46,0.16,3.64,0.49C160.88,1455.81,161.96,1456.28,162.95,1456.91z"/>
			<path className="st4" d="M181.45,1461.55c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04v15.66c0,2.04-0.4,3.72-1.19,5.04
				c-0.79,1.32-1.85,2.3-3.19,2.95c-1.33,0.65-2.84,0.97-4.52,0.97c-0.94,0-1.84-0.1-2.7-0.29c-0.86-0.19-1.57-0.44-2.12-0.76
				c-0.46-0.22-0.78-0.49-0.97-0.81c-0.19-0.32-0.22-0.67-0.07-1.03c0.17-0.43,0.41-0.73,0.74-0.9c0.32-0.17,0.67-0.17,1.03,0
				c0.38,0.17,0.94,0.4,1.67,0.7c0.73,0.3,1.55,0.45,2.47,0.45c1.25,0,2.32-0.24,3.2-0.72c0.89-0.48,1.57-1.18,2.05-2.11
				c0.48-0.92,0.72-2.07,0.72-3.44v-2.52l0.4,0.86c-0.36,0.77-0.86,1.43-1.51,1.98c-0.65,0.55-1.4,0.98-2.25,1.28
				c-0.85,0.3-1.77,0.45-2.75,0.45c-1.39,0-2.56-0.29-3.51-0.88c-0.95-0.59-1.66-1.4-2.14-2.45s-0.72-2.24-0.72-3.58v-10.87
				c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.62-0.43,1.03-0.43c0.43,0,0.78,0.14,1.04,0.43c0.26,0.29,0.4,0.64,0.4,1.04v10.19
				c0,1.63,0.36,2.86,1.08,3.69s1.84,1.24,3.35,1.24c0.96,0,1.82-0.22,2.59-0.65c0.77-0.43,1.39-1.03,1.85-1.78
				c0.47-0.76,0.7-1.59,0.7-2.5v-10.19c0-0.41,0.14-0.76,0.41-1.04C180.66,1461.69,181.02,1461.55,181.45,1461.55z"/>
			<path className="st4" d="M196.32,1461.37c1.22,0,2.33,0.13,3.31,0.4c0.98,0.26,1.76,0.62,2.34,1.08s0.86,0.97,0.86,1.55
				c0,0.34-0.1,0.65-0.31,0.94c-0.2,0.29-0.5,0.43-0.88,0.43c-0.34,0-0.61-0.07-0.81-0.2c-0.2-0.13-0.4-0.29-0.58-0.47
				c-0.18-0.18-0.43-0.35-0.74-0.52c-0.29-0.14-0.71-0.27-1.26-0.38c-0.55-0.11-1.1-0.16-1.66-0.16c-1.3,0-2.45,0.31-3.46,0.94
				c-1.01,0.62-1.79,1.46-2.36,2.52c-0.56,1.06-0.85,2.26-0.85,3.6c0,1.34,0.28,2.54,0.83,3.6c0.55,1.06,1.32,1.9,2.3,2.52
				c0.98,0.62,2.12,0.94,3.42,0.94c0.82,0,1.48-0.07,1.98-0.22c0.5-0.14,0.92-0.31,1.26-0.5c0.43-0.24,0.76-0.48,0.99-0.72
				c0.23-0.24,0.53-0.36,0.92-0.36c0.43,0,0.76,0.13,0.97,0.4c0.22,0.26,0.32,0.59,0.32,0.97c0,0.46-0.3,0.92-0.9,1.4
				c-0.6,0.48-1.41,0.88-2.43,1.21c-1.02,0.32-2.18,0.49-3.47,0.49c-1.82,0-3.42-0.43-4.79-1.28c-1.37-0.85-2.43-2.02-3.19-3.49
				c-0.76-1.48-1.13-3.13-1.13-4.95c0-1.82,0.39-3.47,1.17-4.93c0.78-1.46,1.87-2.63,3.26-3.49
				C192.85,1461.8,194.47,1461.37,196.32,1461.37z"/>
			<path className="st4" d="M209.89,1478.97c0,0.41-0.14,0.76-0.43,1.04s-0.64,0.43-1.04,0.43c-0.41,0-0.75-0.14-1.03-0.43
				c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69c0-0.41,0.14-0.76,0.43-1.04s0.64-0.43,1.04-0.43c0.43,0,0.78,0.14,1.04,0.43
				c0.26,0.29,0.4,0.64,0.4,1.04V1478.97z"/>
			<path className="st4" d="M216.77,1459.14c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36c0.29,0.24,0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C217.78,1459.02,217.34,1459.14,216.77,1459.14z M218.24,1478.97c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V1478.97z"/>
			<path className="st4" d="M222.35,1477.5c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S223.28,1478.72,222.35,1477.5z"/>
			<path className="st4" d="M239.77,1461.95h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C239.09,1462.07,239.41,1461.95,239.77,1461.95z M243.55,1457.05c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C242.79,1457.19,243.14,1457.05,243.55,1457.05z"/>
			<path className="st4" d="M252.48,1477.5c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S253.41,1478.72,252.48,1477.5z"/>
			<path className="st4" d="M302.48,1461.51c0.38,0,0.71,0.13,0.99,0.4c0.28,0.26,0.41,0.62,0.41,1.08c0,0.1-0.01,0.2-0.02,0.31
				c-0.01,0.11-0.04,0.2-0.09,0.27l-5.54,15.95c-0.12,0.31-0.32,0.56-0.59,0.74c-0.28,0.18-0.57,0.25-0.88,0.2
				c-0.55-0.02-0.97-0.34-1.26-0.94l-4.54-11.34l0.72,0.11l-4.1,11.23c-0.26,0.6-0.68,0.91-1.26,0.94c-0.31,0.05-0.61-0.02-0.9-0.2
				c-0.29-0.18-0.49-0.43-0.61-0.74l-5.62-15.95c-0.07-0.19-0.11-0.38-0.11-0.58c0-0.41,0.13-0.76,0.4-1.04
				c0.26-0.29,0.62-0.43,1.08-0.43c0.29,0,0.55,0.07,0.79,0.22c0.24,0.14,0.41,0.38,0.5,0.72l4.86,14.15l-0.76-0.04l4.18-10.8
				c0.26-0.6,0.72-0.9,1.37-0.9c0.34,0,0.61,0.08,0.81,0.23c0.2,0.16,0.35,0.38,0.45,0.67l4.39,10.8l-0.9,0.07l4.86-14.18
				C301.31,1461.83,301.76,1461.51,302.48,1461.51z"/>
			<path className="st4" d="M309.07,1459.14c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36c0.29,0.24,0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C310.08,1459.02,309.65,1459.14,309.07,1459.14z M310.54,1478.97c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V1478.97z"/>
			<path className="st4" d="M315.01,1461.95h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C314.33,1462.07,314.65,1461.95,315.01,1461.95z M318.79,1457.05c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C318.03,1457.19,318.38,1457.05,318.79,1457.05z"/>
			<path className="st4" d="M337.8,1461.55c1.58,0,2.84,0.34,3.76,1.03s1.58,1.6,1.98,2.74s0.59,2.41,0.59,3.8v9.86
				c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.7-0.4-2.45c-0.26-0.74-0.7-1.34-1.31-1.78c-0.61-0.44-1.45-0.67-2.5-0.67c-0.98,0-1.88,0.22-2.7,0.67
				c-0.82,0.44-1.46,1.04-1.94,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.62-0.43,1.03-0.43
				c0.43,0,0.78,0.14,1.04,0.43c0.26,0.29,0.4,0.64,0.4,1.04v10.73l-0.72,0.79c0.12-0.62,0.38-1.25,0.79-1.89
				c0.41-0.64,0.92-1.21,1.55-1.71c0.62-0.5,1.32-0.91,2.09-1.21C336.15,1461.7,336.96,1461.55,337.8,1461.55z"/>
			<path className="st4" d="M366.96,1471.09c0,1.87-0.41,3.54-1.22,5c-0.82,1.46-1.93,2.62-3.33,3.46c-1.4,0.84-2.99,1.26-4.77,1.26
				c-1.75,0-3.34-0.42-4.75-1.26c-1.42-0.84-2.54-1.99-3.37-3.46c-0.83-1.46-1.24-3.13-1.24-5s0.41-3.54,1.24-5
				c0.83-1.46,1.95-2.62,3.37-3.46c1.42-0.84,3-1.26,4.75-1.26c1.78,0,3.37,0.42,4.77,1.26c1.4,0.84,2.51,1.99,3.33,3.46
				C366.55,1467.55,366.96,1469.22,366.96,1471.09z M364.08,1471.09c0-1.39-0.28-2.61-0.85-3.65c-0.56-1.04-1.33-1.87-2.3-2.48
				c-0.97-0.61-2.07-0.92-3.29-0.92c-1.2,0-2.29,0.31-3.28,0.92c-0.98,0.61-1.76,1.44-2.32,2.48s-0.85,2.26-0.85,3.65
				c0,1.37,0.28,2.58,0.85,3.64c0.56,1.06,1.34,1.89,2.32,2.5c0.98,0.61,2.08,0.92,3.28,0.92c1.22,0,2.32-0.31,3.29-0.92
				c0.97-0.61,1.74-1.45,2.3-2.5C363.79,1473.67,364.08,1472.46,364.08,1471.09z"/>
			<path className="st4" d="M385.06,1461.84c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v9.79c0,2.42-0.68,4.3-2.03,5.63
				c-1.36,1.33-3.25,2-5.67,2c-2.4,0-4.28-0.67-5.63-2c-1.36-1.33-2.03-3.21-2.03-5.63v-9.79c0-0.43,0.14-0.79,0.41-1.06
				c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v9.79c0,1.63,0.42,2.87,1.26,3.71
				c0.84,0.84,2.02,1.26,3.53,1.26c1.54,0,2.72-0.42,3.56-1.26c0.84-0.84,1.26-2.08,1.26-3.71v-9.79c0-0.43,0.13-0.79,0.4-1.06
				C384.28,1461.98,384.63,1461.84,385.06,1461.84z"/>
			<path className="st4" d="M391.11,1461.95h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C390.43,1462.07,390.75,1461.95,391.11,1461.95z M394.89,1457.05c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C394.14,1457.19,394.48,1457.05,394.89,1457.05z"/>
			<path className="st4" d="M423.69,1461.55c1.63,0,2.96,0.41,3.98,1.24c1.02,0.83,1.7,2,2.03,3.51h-0.54l0.25-0.65
				c0.29-0.67,0.78-1.32,1.48-1.94c0.7-0.62,1.5-1.14,2.41-1.55c0.91-0.41,1.86-0.61,2.84-0.61c1.58,0,2.83,0.34,3.74,1.03
				s1.57,1.6,1.96,2.74s0.59,2.42,0.59,3.83v9.83c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.63,0.43-1.06,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-9.76c0-0.91-0.13-1.75-0.4-2.5c-0.26-0.76-0.71-1.36-1.33-1.82
				c-0.62-0.46-1.46-0.68-2.52-0.68c-0.96,0-1.85,0.23-2.66,0.68s-1.46,1.06-1.94,1.82c-0.48,0.76-0.72,1.59-0.72,2.5v9.76
				c0,0.41-0.13,0.76-0.4,1.04s-0.61,0.43-1.04,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.7-0.4-2.45c-0.26-0.74-0.7-1.34-1.3-1.78c-0.6-0.44-1.42-0.67-2.45-0.67c-0.96,0-1.84,0.22-2.63,0.67
				c-0.79,0.44-1.43,1.04-1.91,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41
				c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v2.7l-0.79,0.86c0.1-0.62,0.34-1.25,0.74-1.87
				c0.4-0.62,0.91-1.2,1.53-1.73c0.62-0.53,1.32-0.95,2.09-1.26S422.83,1461.55,423.69,1461.55z"/>
			<path className="st4" d="M462.93,1461.66c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.62,0.4,1.03v15.88c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.07c0,0.55-0.18,1.13-0.54,1.75
				c-0.36,0.61-0.85,1.19-1.48,1.73s-1.36,0.98-2.21,1.33c-0.85,0.35-1.76,0.52-2.72,0.52c-1.66,0-3.13-0.43-4.43-1.28
				c-1.3-0.85-2.32-2.01-3.08-3.47c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.57,1.13-5.02c0.76-1.45,1.78-2.59,3.08-3.42
				s2.74-1.24,4.32-1.24c1.03,0,1.99,0.17,2.88,0.5c0.89,0.34,1.66,0.79,2.32,1.37c0.66,0.58,1.18,1.21,1.55,1.91
				s0.56,1.39,0.56,2.09l-0.94-0.22v-3.92c0-0.41,0.13-0.75,0.4-1.03C462.15,1461.8,462.5,1461.66,462.93,1461.66z M455.51,1478.15
				c1.2,0,2.26-0.31,3.19-0.94c0.92-0.62,1.64-1.47,2.16-2.54c0.52-1.07,0.77-2.27,0.77-3.62c0-1.32-0.26-2.51-0.77-3.56
				c-0.52-1.06-1.24-1.9-2.16-2.52c-0.92-0.62-1.99-0.94-3.19-0.94c-1.18,0-2.23,0.31-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.5
				c-0.53,1.06-0.79,2.26-0.79,3.6c0,1.34,0.26,2.55,0.79,3.62c0.53,1.07,1.25,1.91,2.18,2.54
				C453.29,1477.83,454.34,1478.15,455.51,1478.15z"/>
			<path className="st4" d="M468.62,1477.5c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S469.55,1478.72,468.62,1477.5z"/>
			<path className="st4" d="M488.49,1480.45c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69
				c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04v23.69
				c0,0.41-0.14,0.76-0.41,1.04C489.24,1480.31,488.9,1480.45,488.49,1480.45z M500.44,1461.73c0.38,0,0.71,0.15,0.99,0.45
				c0.28,0.3,0.41,0.62,0.41,0.95c0,0.38-0.19,0.74-0.58,1.08l-11.66,10.19l-0.11-3.38l9.9-8.86
				C499.71,1461.87,500.06,1461.73,500.44,1461.73z M500.84,1480.41c-0.43,0-0.79-0.16-1.08-0.47l-7.67-8.17l2.16-1.98l7.6,8.14
				c0.29,0.31,0.43,0.67,0.43,1.08c0,0.43-0.17,0.77-0.5,1.03S501.13,1480.41,500.84,1480.41z"/>
			<path className="st4" d="M505.37,1477.5c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S506.31,1478.72,505.37,1477.5z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st4" d="M154.7,1684.45c1.3,0,2.48,0.32,3.55,0.97c1.07,0.65,1.91,1.54,2.52,2.66c0.61,1.13,0.92,2.41,0.92,3.85
				c0,1.42-0.31,2.7-0.92,3.85c-0.61,1.15-1.45,2.07-2.52,2.75c-1.07,0.68-2.25,1.03-3.55,1.03h-7.31l0.25-0.47v9.07
				c0,0.41-0.13,0.76-0.4,1.04c-0.26,0.29-0.6,0.43-1.01,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-22.25
				c0-0.41,0.14-0.76,0.43-1.04c0.29-0.29,0.64-0.43,1.04-0.43H154.7z M154.7,1696.76c0.77,0,1.46-0.22,2.07-0.65
				c0.61-0.43,1.1-1.01,1.46-1.75c0.36-0.73,0.54-1.54,0.54-2.43s-0.18-1.69-0.54-2.39c-0.36-0.71-0.85-1.27-1.46-1.67
				c-0.61-0.41-1.3-0.61-2.07-0.61h-7.31l0.25-0.43v10.3l-0.25-0.36H154.7z"/>
			<path className="st4" d="M174.32,1710.01c-1.92,0-3.6-0.41-5.04-1.22c-1.44-0.82-2.56-1.94-3.37-3.37c-0.8-1.43-1.21-3.08-1.21-4.95
				c0-2.09,0.41-3.87,1.24-5.35c0.83-1.48,1.91-2.6,3.24-3.38c1.33-0.78,2.74-1.17,4.23-1.17c1.13,0,2.2,0.2,3.22,0.61
				c1.02,0.41,1.93,1.01,2.74,1.8c0.8,0.79,1.45,1.73,1.93,2.81s0.73,2.3,0.76,3.67c-0.02,0.38-0.18,0.7-0.47,0.95
				s-0.62,0.38-1.01,0.38h-14.22l-0.65-2.48h13.86l-0.58,0.5v-0.79c-0.1-0.98-0.43-1.83-0.99-2.54s-1.25-1.25-2.05-1.64
				c-0.8-0.38-1.65-0.58-2.54-0.58c-0.72,0-1.43,0.13-2.14,0.4c-0.71,0.26-1.34,0.67-1.91,1.22c-0.56,0.55-1.01,1.27-1.35,2.16
				c-0.34,0.89-0.5,1.96-0.5,3.2c0,1.39,0.28,2.62,0.85,3.67c0.56,1.06,1.35,1.89,2.36,2.5c1.01,0.61,2.17,0.92,3.49,0.92
				c0.86,0,1.6-0.11,2.21-0.32c0.61-0.22,1.15-0.49,1.6-0.81c0.46-0.32,0.84-0.65,1.15-0.99c0.31-0.22,0.61-0.32,0.9-0.32
				c0.36,0,0.66,0.12,0.9,0.36c0.24,0.24,0.36,0.53,0.36,0.86c0,0.41-0.2,0.78-0.61,1.12c-0.67,0.74-1.58,1.39-2.74,1.94
				C176.84,1709.73,175.62,1710.01,174.32,1710.01z"/>
			<path className="st4" d="M201.36,1683.01c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v23.69c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.22c0,0.55-0.18,1.15-0.54,1.78
				c-0.36,0.64-0.85,1.24-1.48,1.8c-0.62,0.56-1.36,1.02-2.21,1.37c-0.85,0.35-1.76,0.52-2.72,0.52c-1.63,0-3.1-0.42-4.41-1.26
				c-1.31-0.84-2.34-1.99-3.1-3.46c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.58,1.13-5.04c0.76-1.46,1.78-2.61,3.08-3.44
				s2.74-1.24,4.32-1.24c1.01,0,1.96,0.17,2.84,0.5c0.89,0.34,1.66,0.79,2.32,1.37s1.18,1.21,1.57,1.91
				c0.38,0.7,0.58,1.39,0.58,2.09l-0.94-0.22v-11.74c0-0.41,0.13-0.76,0.4-1.04S200.93,1683.01,201.36,1683.01z M193.94,1707.34
				c1.22,0,2.29-0.31,3.2-0.92c0.91-0.61,1.63-1.45,2.14-2.52c0.52-1.07,0.77-2.27,0.77-3.62c0-1.34-0.26-2.55-0.77-3.62
				c-0.52-1.07-1.24-1.91-2.16-2.52s-1.99-0.92-3.19-0.92c-1.18,0-2.23,0.31-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.52
				c-0.53,1.07-0.79,2.27-0.79,3.62c0,1.32,0.26,2.51,0.79,3.58c0.53,1.07,1.25,1.91,2.18,2.54
				C191.72,1707.03,192.77,1707.34,193.94,1707.34z"/>
			<path className="st4" d="M216.55,1710.01c-1.92,0-3.6-0.41-5.04-1.22c-1.44-0.82-2.56-1.94-3.37-3.37c-0.8-1.43-1.21-3.08-1.21-4.95
				c0-2.09,0.41-3.87,1.24-5.35c0.83-1.48,1.91-2.6,3.24-3.38c1.33-0.78,2.74-1.17,4.23-1.17c1.13,0,2.2,0.2,3.22,0.61
				c1.02,0.41,1.93,1.01,2.74,1.8c0.8,0.79,1.45,1.73,1.93,2.81s0.73,2.3,0.76,3.67c-0.02,0.38-0.18,0.7-0.47,0.95
				s-0.62,0.38-1.01,0.38h-14.22l-0.65-2.48h13.86l-0.58,0.5v-0.79c-0.1-0.98-0.43-1.83-0.99-2.54s-1.25-1.25-2.05-1.64
				c-0.8-0.38-1.65-0.58-2.54-0.58c-0.72,0-1.43,0.13-2.14,0.4c-0.71,0.26-1.34,0.67-1.91,1.22c-0.56,0.55-1.01,1.27-1.35,2.16
				c-0.34,0.89-0.5,1.96-0.5,3.2c0,1.39,0.28,2.62,0.85,3.67c0.56,1.06,1.35,1.89,2.36,2.5c1.01,0.61,2.17,0.92,3.49,0.92
				c0.86,0,1.6-0.11,2.21-0.32c0.61-0.22,1.15-0.49,1.6-0.81c0.46-0.32,0.84-0.65,1.15-0.99c0.31-0.22,0.61-0.32,0.9-0.32
				c0.36,0,0.66,0.12,0.9,0.36c0.24,0.24,0.36,0.53,0.36,0.86c0,0.41-0.2,0.78-0.61,1.12c-0.67,0.74-1.58,1.39-2.74,1.94
				C219.07,1709.73,217.85,1710.01,216.55,1710.01z"/>
			<path className="st4" d="M227.35,1706.69c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S228.29,1707.92,227.35,1706.69z"/>
			<path className="st4" d="M244.77,1691.14h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C244.1,1691.27,244.41,1691.14,244.77,1691.14z M248.55,1686.25c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C247.8,1686.39,248.15,1686.25,248.55,1686.25z"/>
			<path className="st4" d="M260,1709.65c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66
				c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v4.72
				l-0.43-0.76c0.14-0.74,0.4-1.47,0.77-2.18c0.37-0.71,0.85-1.34,1.42-1.91c0.58-0.56,1.24-1.01,1.98-1.33
				c0.74-0.32,1.56-0.49,2.45-0.49c0.53,0,1.01,0.13,1.46,0.38c0.44,0.25,0.67,0.61,0.67,1.06c0,0.5-0.13,0.88-0.4,1.13
				s-0.56,0.38-0.9,0.38c-0.31,0-0.61-0.07-0.9-0.22c-0.29-0.14-0.65-0.22-1.08-0.22c-0.6,0-1.19,0.17-1.78,0.5s-1.13,0.8-1.62,1.39
				c-0.49,0.59-0.89,1.26-1.19,2.02c-0.3,0.76-0.45,1.57-0.45,2.43v8.75c0,0.41-0.14,0.76-0.41,1.04S260.41,1709.65,260,1709.65z"/>
			<path className="st4" d="M274.29,1688.33c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36c0.29,0.24,0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C275.31,1688.21,274.87,1688.33,274.29,1688.33z M275.77,1708.17c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V1708.17z"/>
			<path className="st4" d="M296.11,1690.85c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.62,0.4,1.03v15.88c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.07c0,0.55-0.18,1.13-0.54,1.75
				c-0.36,0.61-0.85,1.19-1.48,1.73s-1.36,0.98-2.21,1.33c-0.85,0.35-1.76,0.52-2.72,0.52c-1.66,0-3.13-0.43-4.43-1.28
				c-1.3-0.85-2.32-2.01-3.08-3.47c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.57,1.13-5.02c0.76-1.45,1.78-2.59,3.08-3.42
				s2.74-1.24,4.32-1.24c1.03,0,1.99,0.17,2.88,0.5c0.89,0.34,1.66,0.79,2.32,1.37c0.66,0.58,1.18,1.21,1.55,1.91
				s0.56,1.39,0.56,2.09l-0.94-0.22v-3.92c0-0.41,0.13-0.75,0.4-1.03C295.33,1690.99,295.68,1690.85,296.11,1690.85z
				 M288.69,1707.34c1.2,0,2.26-0.31,3.19-0.94c0.92-0.62,1.64-1.47,2.16-2.54c0.52-1.07,0.77-2.27,0.77-3.62
				c0-1.32-0.26-2.51-0.77-3.56c-0.52-1.06-1.24-1.9-2.16-2.52c-0.92-0.62-1.99-0.94-3.19-0.94c-1.18,0-2.23,0.31-3.15,0.92
				c-0.92,0.61-1.65,1.45-2.18,2.5c-0.53,1.06-0.79,2.26-0.79,3.6c0,1.34,0.26,2.55,0.79,3.62c0.53,1.07,1.25,1.91,2.18,2.54
				C286.47,1707.03,287.52,1707.34,288.69,1707.34z"/>
			<path className="st4" d="M312.13,1690.57c1.63,0,2.92,0.34,3.85,1.01c0.94,0.67,1.6,1.57,2,2.7c0.4,1.13,0.59,2.4,0.59,3.82v10.08
				c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-10.01
				c0-0.91-0.14-1.74-0.41-2.48s-0.74-1.34-1.39-1.78c-0.65-0.44-1.51-0.67-2.59-0.67c-1.01,0-1.93,0.22-2.77,0.67
				c-0.84,0.44-1.51,1.04-2.02,1.78c-0.5,0.74-0.76,1.57-0.76,2.48v10.01c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41
				c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v2.52l-0.72,0.79c0.12-0.62,0.4-1.25,0.83-1.89
				c0.43-0.64,0.97-1.21,1.62-1.71s1.37-0.91,2.16-1.21S311.26,1690.57,312.13,1690.57z"/>
			<path className="st4" d="M322.82,1706.69c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S323.76,1707.92,322.82,1706.69z"/>
			<path className="st4" d="M372.82,1690.71c0.38,0,0.71,0.13,0.99,0.4c0.28,0.26,0.41,0.62,0.41,1.08c0,0.1-0.01,0.2-0.02,0.31
				c-0.01,0.11-0.04,0.2-0.09,0.27l-5.54,15.95c-0.12,0.31-0.32,0.56-0.59,0.74c-0.28,0.18-0.57,0.25-0.88,0.2
				c-0.55-0.02-0.97-0.34-1.26-0.94l-4.54-11.34l0.72,0.11l-4.1,11.23c-0.26,0.6-0.68,0.91-1.26,0.94c-0.31,0.05-0.61-0.02-0.9-0.2
				c-0.29-0.18-0.49-0.43-0.61-0.74l-5.62-15.95c-0.07-0.19-0.11-0.38-0.11-0.58c0-0.41,0.13-0.76,0.4-1.04
				c0.26-0.29,0.62-0.43,1.08-0.43c0.29,0,0.55,0.07,0.79,0.22c0.24,0.14,0.41,0.38,0.5,0.72l4.86,14.15l-0.76-0.04l4.18-10.8
				c0.26-0.6,0.72-0.9,1.37-0.9c0.34,0,0.61,0.08,0.81,0.23c0.2,0.16,0.35,0.38,0.45,0.67l4.39,10.8l-0.9,0.07l4.86-14.18
				C371.65,1691.02,372.1,1690.71,372.82,1690.71z"/>
			<path className="st4" d="M379.41,1688.33c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36c0.29,0.24,0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C380.43,1688.21,379.99,1688.33,379.41,1688.33z M380.89,1708.17c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V1708.17z"/>
			<path className="st4" d="M385.35,1691.14h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C384.67,1691.27,384.99,1691.14,385.35,1691.14z M389.13,1686.25c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C388.38,1686.39,388.72,1686.25,389.13,1686.25z"/>
			<path className="st4" d="M408.14,1690.75c1.58,0,2.84,0.34,3.76,1.03s1.58,1.6,1.98,2.74s0.59,2.41,0.59,3.8v9.86
				c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.7-0.4-2.45c-0.26-0.74-0.7-1.34-1.31-1.78c-0.61-0.44-1.45-0.67-2.5-0.67c-0.98,0-1.88,0.22-2.7,0.67
				c-0.82,0.44-1.46,1.04-1.94,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.62-0.43,1.03-0.43
				c0.43,0,0.78,0.14,1.04,0.43c0.26,0.29,0.4,0.64,0.4,1.04v10.73l-0.72,0.79c0.12-0.62,0.38-1.25,0.79-1.89
				c0.41-0.64,0.92-1.21,1.55-1.71c0.62-0.5,1.32-0.91,2.09-1.21C406.5,1690.9,407.3,1690.75,408.14,1690.75z"/>
			<path className="st4" d="M438.59,1690.75c1.63,0,2.96,0.41,3.98,1.24c1.02,0.83,1.7,2,2.03,3.51h-0.54l0.25-0.65
				c0.29-0.67,0.78-1.32,1.48-1.94c0.7-0.62,1.5-1.14,2.41-1.55c0.91-0.41,1.86-0.61,2.84-0.61c1.58,0,2.83,0.34,3.74,1.03
				s1.57,1.6,1.96,2.74s0.59,2.42,0.59,3.83v9.83c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.63,0.43-1.06,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-9.76c0-0.91-0.13-1.75-0.4-2.5c-0.26-0.76-0.71-1.36-1.33-1.82
				c-0.62-0.46-1.46-0.68-2.52-0.68c-0.96,0-1.85,0.23-2.66,0.68s-1.46,1.06-1.94,1.82c-0.48,0.76-0.72,1.59-0.72,2.5v9.76
				c0,0.41-0.13,0.76-0.4,1.04s-0.61,0.43-1.04,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.7-0.4-2.45c-0.26-0.74-0.7-1.34-1.3-1.78c-0.6-0.44-1.42-0.67-2.45-0.67c-0.96,0-1.84,0.22-2.63,0.67
				c-0.79,0.44-1.43,1.04-1.91,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41
				c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v2.7l-0.79,0.86c0.1-0.62,0.34-1.25,0.74-1.87
				c0.4-0.62,0.91-1.2,1.53-1.73c0.62-0.53,1.32-0.95,2.09-1.26S437.73,1690.75,438.59,1690.75z"/>
			<path className="st4" d="M477.83,1690.85c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.62,0.4,1.03v15.88c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.07c0,0.55-0.18,1.13-0.54,1.75
				c-0.36,0.61-0.85,1.19-1.48,1.73s-1.36,0.98-2.21,1.33c-0.85,0.35-1.76,0.52-2.72,0.52c-1.66,0-3.13-0.43-4.43-1.28
				c-1.3-0.85-2.32-2.01-3.08-3.47c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.57,1.13-5.02c0.76-1.45,1.78-2.59,3.08-3.42
				s2.74-1.24,4.32-1.24c1.03,0,1.99,0.17,2.88,0.5c0.89,0.34,1.66,0.79,2.32,1.37c0.66,0.58,1.18,1.21,1.55,1.91
				s0.56,1.39,0.56,2.09l-0.94-0.22v-3.92c0-0.41,0.13-0.75,0.4-1.03C477.05,1690.99,477.4,1690.85,477.83,1690.85z M470.42,1707.34
				c1.2,0,2.26-0.31,3.19-0.94c0.92-0.62,1.64-1.47,2.16-2.54c0.52-1.07,0.77-2.27,0.77-3.62c0-1.32-0.26-2.51-0.77-3.56
				c-0.52-1.06-1.24-1.9-2.16-2.52c-0.92-0.62-1.99-0.94-3.19-0.94c-1.18,0-2.23,0.31-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.5
				c-0.53,1.06-0.79,2.26-0.79,3.6c0,1.34,0.26,2.55,0.79,3.62c0.53,1.07,1.25,1.91,2.18,2.54
				C468.19,1707.03,469.24,1707.34,470.42,1707.34z"/>
			<path className="st4" d="M483.52,1706.69c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S484.46,1707.92,483.52,1706.69z"/>
			<path className="st4" d="M503.39,1709.65c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69
				c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04v23.69
				c0,0.41-0.14,0.76-0.41,1.04C504.14,1709.5,503.8,1709.65,503.39,1709.65z M515.35,1690.93c0.38,0,0.71,0.15,0.99,0.45
				c0.28,0.3,0.41,0.62,0.41,0.95c0,0.38-0.19,0.74-0.58,1.08l-11.66,10.19l-0.11-3.38l9.9-8.86
				C514.61,1691.07,514.96,1690.93,515.35,1690.93z M515.74,1709.61c-0.43,0-0.79-0.16-1.08-0.47l-7.67-8.17l2.16-1.98l7.6,8.14
				c0.29,0.31,0.43,0.67,0.43,1.08c0,0.43-0.17,0.77-0.5,1.03S516.03,1709.61,515.74,1709.61z"/>
			<path className="st4" d="M520.28,1706.69c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S521.21,1707.92,520.28,1706.69z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st4" d="M154.7,1919.31c1.3,0,2.48,0.32,3.55,0.97c1.07,0.65,1.91,1.54,2.52,2.66c0.61,1.13,0.92,2.41,0.92,3.85
				c0,1.42-0.31,2.7-0.92,3.85c-0.61,1.15-1.45,2.07-2.52,2.75c-1.07,0.68-2.25,1.03-3.55,1.03h-7.31l0.25-0.47v9.07
				c0,0.41-0.13,0.76-0.4,1.04c-0.26,0.29-0.6,0.43-1.01,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-22.25
				c0-0.41,0.14-0.76,0.43-1.04c0.29-0.29,0.64-0.43,1.04-0.43H154.7z M154.7,1931.62c0.77,0,1.46-0.22,2.07-0.65
				c0.61-0.43,1.1-1.01,1.46-1.75c0.36-0.73,0.54-1.54,0.54-2.43s-0.18-1.69-0.54-2.39c-0.36-0.71-0.85-1.27-1.46-1.67
				c-0.61-0.41-1.3-0.61-2.07-0.61h-7.31l0.25-0.43v10.3l-0.25-0.36H154.7z"/>
			<path className="st4" d="M174.32,1944.87c-1.92,0-3.6-0.41-5.04-1.22c-1.44-0.82-2.56-1.94-3.37-3.37c-0.8-1.43-1.21-3.08-1.21-4.95
				c0-2.09,0.41-3.87,1.24-5.35c0.83-1.48,1.91-2.6,3.24-3.38c1.33-0.78,2.74-1.17,4.23-1.17c1.13,0,2.2,0.2,3.22,0.61
				c1.02,0.41,1.93,1.01,2.74,1.8c0.8,0.79,1.45,1.73,1.93,2.81s0.73,2.3,0.76,3.67c-0.02,0.38-0.18,0.7-0.47,0.95
				s-0.62,0.38-1.01,0.38h-14.22l-0.65-2.48h13.86l-0.58,0.5v-0.79c-0.1-0.98-0.43-1.83-0.99-2.54s-1.25-1.25-2.05-1.64
				c-0.8-0.38-1.65-0.58-2.54-0.58c-0.72,0-1.43,0.13-2.14,0.4c-0.71,0.26-1.34,0.67-1.91,1.22c-0.56,0.55-1.01,1.27-1.35,2.16
				c-0.34,0.89-0.5,1.96-0.5,3.2c0,1.39,0.28,2.62,0.85,3.67c0.56,1.06,1.35,1.89,2.36,2.5c1.01,0.61,2.17,0.92,3.49,0.92
				c0.86,0,1.6-0.11,2.21-0.32c0.61-0.22,1.15-0.49,1.6-0.81c0.46-0.32,0.84-0.65,1.15-0.99c0.31-0.22,0.61-0.32,0.9-0.32
				c0.36,0,0.66,0.12,0.9,0.36c0.24,0.24,0.36,0.53,0.36,0.86c0,0.41-0.2,0.78-0.61,1.12c-0.67,0.74-1.58,1.39-2.74,1.94
				C176.84,1944.59,175.62,1944.87,174.32,1944.87z"/>
			<path className="st4" d="M201.36,1917.87c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v23.69c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.22c0,0.55-0.18,1.15-0.54,1.78
				c-0.36,0.64-0.85,1.24-1.48,1.8c-0.62,0.56-1.36,1.02-2.21,1.37c-0.85,0.35-1.76,0.52-2.72,0.52c-1.63,0-3.1-0.42-4.41-1.26
				c-1.31-0.84-2.34-1.99-3.1-3.46c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.58,1.13-5.04c0.76-1.46,1.78-2.61,3.08-3.44
				s2.74-1.24,4.32-1.24c1.01,0,1.96,0.17,2.84,0.5c0.89,0.34,1.66,0.79,2.32,1.37s1.18,1.21,1.57,1.91
				c0.38,0.7,0.58,1.39,0.58,2.09l-0.94-0.22v-11.74c0-0.41,0.13-0.76,0.4-1.04S200.93,1917.87,201.36,1917.87z M193.94,1942.2
				c1.22,0,2.29-0.31,3.2-0.92c0.91-0.61,1.63-1.45,2.14-2.52c0.52-1.07,0.77-2.27,0.77-3.62c0-1.34-0.26-2.55-0.77-3.62
				c-0.52-1.07-1.24-1.91-2.16-2.52s-1.99-0.92-3.19-0.92c-1.18,0-2.23,0.31-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.52
				c-0.53,1.07-0.79,2.27-0.79,3.62c0,1.32,0.26,2.51,0.79,3.58c0.53,1.07,1.25,1.91,2.18,2.54
				C191.72,1941.89,192.77,1942.2,193.94,1942.2z"/>
			<path className="st4" d="M216.55,1944.87c-1.92,0-3.6-0.41-5.04-1.22c-1.44-0.82-2.56-1.94-3.37-3.37c-0.8-1.43-1.21-3.08-1.21-4.95
				c0-2.09,0.41-3.87,1.24-5.35c0.83-1.48,1.91-2.6,3.24-3.38c1.33-0.78,2.74-1.17,4.23-1.17c1.13,0,2.2,0.2,3.22,0.61
				c1.02,0.41,1.93,1.01,2.74,1.8c0.8,0.79,1.45,1.73,1.93,2.81s0.73,2.3,0.76,3.67c-0.02,0.38-0.18,0.7-0.47,0.95
				s-0.62,0.38-1.01,0.38h-14.22l-0.65-2.48h13.86l-0.58,0.5v-0.79c-0.1-0.98-0.43-1.83-0.99-2.54s-1.25-1.25-2.05-1.64
				c-0.8-0.38-1.65-0.58-2.54-0.58c-0.72,0-1.43,0.13-2.14,0.4c-0.71,0.26-1.34,0.67-1.91,1.22c-0.56,0.55-1.01,1.27-1.35,2.16
				c-0.34,0.89-0.5,1.96-0.5,3.2c0,1.39,0.28,2.62,0.85,3.67c0.56,1.06,1.35,1.89,2.36,2.5c1.01,0.61,2.17,0.92,3.49,0.92
				c0.86,0,1.6-0.11,2.21-0.32c0.61-0.22,1.15-0.49,1.6-0.81c0.46-0.32,0.84-0.65,1.15-0.99c0.31-0.22,0.61-0.32,0.9-0.32
				c0.36,0,0.66,0.12,0.9,0.36c0.24,0.24,0.36,0.53,0.36,0.86c0,0.41-0.2,0.78-0.61,1.12c-0.67,0.74-1.58,1.39-2.74,1.94
				C219.07,1944.59,217.85,1944.87,216.55,1944.87z"/>
			<path className="st4" d="M227.35,1941.55c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S228.29,1942.78,227.35,1941.55z"/>
			<path className="st4" d="M244.77,1926h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C244.1,1926.13,244.41,1926,244.77,1926z M248.55,1921.11c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C247.8,1921.25,248.15,1921.11,248.55,1921.11z"/>
			<path className="st4" d="M260,1944.51c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66
				c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v4.72
				l-0.43-0.76c0.14-0.74,0.4-1.47,0.77-2.18c0.37-0.71,0.85-1.34,1.42-1.91c0.58-0.56,1.24-1.01,1.98-1.33
				c0.74-0.32,1.56-0.49,2.45-0.49c0.53,0,1.01,0.13,1.46,0.38c0.44,0.25,0.67,0.61,0.67,1.06c0,0.5-0.13,0.88-0.4,1.13
				s-0.56,0.38-0.9,0.38c-0.31,0-0.61-0.07-0.9-0.22c-0.29-0.14-0.65-0.22-1.08-0.22c-0.6,0-1.19,0.17-1.78,0.5s-1.13,0.8-1.62,1.39
				c-0.49,0.59-0.89,1.26-1.19,2.02c-0.3,0.76-0.45,1.57-0.45,2.43v8.75c0,0.41-0.14,0.76-0.41,1.04S260.41,1944.51,260,1944.51z"/>
			<path className="st4" d="M274.29,1923.19c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36c0.29,0.24,0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C275.31,1923.07,274.87,1923.19,274.29,1923.19z M275.77,1943.03c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V1943.03z"/>
			<path className="st4" d="M296.11,1925.71c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.62,0.4,1.03v15.88c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.07c0,0.55-0.18,1.13-0.54,1.75
				c-0.36,0.61-0.85,1.19-1.48,1.73s-1.36,0.98-2.21,1.33c-0.85,0.35-1.76,0.52-2.72,0.52c-1.66,0-3.13-0.43-4.43-1.28
				c-1.3-0.85-2.32-2.01-3.08-3.47c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.57,1.13-5.02c0.76-1.45,1.78-2.59,3.08-3.42
				s2.74-1.24,4.32-1.24c1.03,0,1.99,0.17,2.88,0.5c0.89,0.34,1.66,0.79,2.32,1.37c0.66,0.58,1.18,1.21,1.55,1.91
				s0.56,1.39,0.56,2.09l-0.94-0.22v-3.92c0-0.41,0.13-0.75,0.4-1.03C295.33,1925.85,295.68,1925.71,296.11,1925.71z M288.69,1942.2
				c1.2,0,2.26-0.31,3.19-0.94c0.92-0.62,1.64-1.47,2.16-2.54c0.52-1.07,0.77-2.27,0.77-3.62c0-1.32-0.26-2.51-0.77-3.56
				c-0.52-1.06-1.24-1.9-2.16-2.52c-0.92-0.62-1.99-0.94-3.19-0.94c-1.18,0-2.23,0.31-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.5
				c-0.53,1.06-0.79,2.26-0.79,3.6c0,1.34,0.26,2.55,0.79,3.62c0.53,1.07,1.25,1.91,2.18,2.54
				C286.47,1941.89,287.52,1942.2,288.69,1942.2z"/>
			<path className="st4" d="M312.13,1925.43c1.63,0,2.92,0.34,3.85,1.01c0.94,0.67,1.6,1.57,2,2.7c0.4,1.13,0.59,2.4,0.59,3.82v10.08
				c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-10.01
				c0-0.91-0.14-1.74-0.41-2.48s-0.74-1.34-1.39-1.78c-0.65-0.44-1.51-0.67-2.59-0.67c-1.01,0-1.93,0.22-2.77,0.67
				c-0.84,0.44-1.51,1.04-2.02,1.78c-0.5,0.74-0.76,1.57-0.76,2.48v10.01c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41
				c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v2.52l-0.72,0.79c0.12-0.62,0.4-1.25,0.83-1.89
				c0.43-0.64,0.97-1.21,1.62-1.71s1.37-0.91,2.16-1.21S311.26,1925.43,312.13,1925.43z"/>
			<path className="st4" d="M322.82,1941.55c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S323.76,1942.78,322.82,1941.55z"/>
			<path className="st4" d="M372.82,1925.57c0.38,0,0.71,0.13,0.99,0.4c0.28,0.26,0.41,0.62,0.41,1.08c0,0.1-0.01,0.2-0.02,0.31
				c-0.01,0.11-0.04,0.2-0.09,0.27l-5.54,15.95c-0.12,0.31-0.32,0.56-0.59,0.74c-0.28,0.18-0.57,0.25-0.88,0.2
				c-0.55-0.02-0.97-0.34-1.26-0.94l-4.54-11.34l0.72,0.11l-4.1,11.23c-0.26,0.6-0.68,0.91-1.26,0.94c-0.31,0.05-0.61-0.02-0.9-0.2
				c-0.29-0.18-0.49-0.43-0.61-0.74l-5.62-15.95c-0.07-0.19-0.11-0.38-0.11-0.58c0-0.41,0.13-0.76,0.4-1.04
				c0.26-0.29,0.62-0.43,1.08-0.43c0.29,0,0.55,0.07,0.79,0.22c0.24,0.14,0.41,0.38,0.5,0.72l4.86,14.15l-0.76-0.04l4.18-10.8
				c0.26-0.6,0.72-0.9,1.37-0.9c0.34,0,0.61,0.08,0.81,0.23c0.2,0.16,0.35,0.38,0.45,0.67l4.39,10.8l-0.9,0.07l4.86-14.18
				C371.65,1925.88,372.1,1925.57,372.82,1925.57z"/>
			<path className="st4" d="M379.41,1923.19c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36c0.29,0.24,0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C380.43,1923.07,379.99,1923.19,379.41,1923.19z M380.89,1943.03c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V1943.03z"/>
			<path className="st4" d="M385.35,1926h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C384.67,1926.13,384.99,1926,385.35,1926z M389.13,1921.11c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C388.38,1921.25,388.72,1921.11,389.13,1921.11z"/>
			<path className="st4" d="M408.14,1925.61c1.58,0,2.84,0.34,3.76,1.03s1.58,1.6,1.98,2.74s0.59,2.41,0.59,3.8v9.86
				c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.7-0.4-2.45c-0.26-0.74-0.7-1.34-1.31-1.78c-0.61-0.44-1.45-0.67-2.5-0.67c-0.98,0-1.88,0.22-2.7,0.67
				c-0.82,0.44-1.46,1.04-1.94,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.62-0.43,1.03-0.43
				c0.43,0,0.78,0.14,1.04,0.43c0.26,0.29,0.4,0.64,0.4,1.04v10.73l-0.72,0.79c0.12-0.62,0.38-1.25,0.79-1.89
				c0.41-0.64,0.92-1.21,1.55-1.71c0.62-0.5,1.32-0.91,2.09-1.21C406.5,1925.76,407.3,1925.61,408.14,1925.61z"/>
			<path className="st4" d="M437.3,1935.15c0,1.87-0.41,3.54-1.22,5c-0.82,1.46-1.93,2.62-3.33,3.46c-1.4,0.84-2.99,1.26-4.77,1.26
				c-1.75,0-3.34-0.42-4.75-1.26c-1.42-0.84-2.54-1.99-3.37-3.46c-0.83-1.46-1.24-3.13-1.24-5s0.41-3.54,1.24-5
				c0.83-1.46,1.95-2.62,3.37-3.46c1.42-0.84,3-1.26,4.75-1.26c1.78,0,3.37,0.42,4.77,1.26c1.4,0.84,2.51,1.99,3.33,3.46
				C436.89,1931.61,437.3,1933.27,437.3,1935.15z M434.42,1935.15c0-1.39-0.28-2.61-0.85-3.65c-0.56-1.04-1.33-1.87-2.3-2.48
				c-0.97-0.61-2.07-0.92-3.29-0.92c-1.2,0-2.29,0.31-3.28,0.92c-0.98,0.61-1.76,1.44-2.32,2.48s-0.85,2.26-0.85,3.65
				c0,1.37,0.28,2.58,0.85,3.64c0.56,1.06,1.34,1.89,2.32,2.5c0.98,0.61,2.08,0.92,3.28,0.92c1.22,0,2.32-0.31,3.29-0.92
				c0.97-0.61,1.74-1.45,2.3-2.5C434.14,1937.73,434.42,1936.51,434.42,1935.15z"/>
			<path className="st4" d="M455.41,1925.89c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v9.79c0,2.42-0.68,4.3-2.03,5.63
				c-1.36,1.33-3.25,2-5.67,2c-2.4,0-4.28-0.67-5.63-2c-1.36-1.33-2.03-3.21-2.03-5.63v-9.79c0-0.43,0.14-0.79,0.41-1.06
				c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v9.79c0,1.63,0.42,2.87,1.26,3.71
				c0.84,0.84,2.02,1.26,3.53,1.26c1.54,0,2.72-0.42,3.56-1.26c0.84-0.84,1.26-2.08,1.26-3.71v-9.79c0-0.43,0.13-0.79,0.4-1.06
				C454.63,1926.03,454.97,1925.89,455.41,1925.89z"/>
			<path className="st4" d="M461.45,1926h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C460.78,1926.13,461.09,1926,461.45,1926z M465.23,1921.11c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C464.48,1921.25,464.83,1921.11,465.23,1921.11z"/>
			<path className="st4" d="M494.03,1925.61c1.63,0,2.96,0.41,3.98,1.24c1.02,0.83,1.7,2,2.03,3.51h-0.54l0.25-0.65
				c0.29-0.67,0.78-1.32,1.48-1.94c0.7-0.62,1.5-1.14,2.41-1.55c0.91-0.41,1.86-0.61,2.84-0.61c1.58,0,2.83,0.34,3.74,1.03
				s1.57,1.6,1.96,2.74s0.59,2.42,0.59,3.83v9.83c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.63,0.43-1.06,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-9.76c0-0.91-0.13-1.75-0.4-2.5c-0.26-0.76-0.71-1.36-1.33-1.82
				c-0.62-0.46-1.46-0.68-2.52-0.68c-0.96,0-1.85,0.23-2.66,0.68s-1.46,1.06-1.94,1.82c-0.48,0.76-0.72,1.59-0.72,2.5v9.76
				c0,0.41-0.13,0.76-0.4,1.04s-0.61,0.43-1.04,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.7-0.4-2.45c-0.26-0.74-0.7-1.34-1.3-1.78c-0.6-0.44-1.42-0.67-2.45-0.67c-0.96,0-1.84,0.22-2.63,0.67
				c-0.79,0.44-1.43,1.04-1.91,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41
				c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v2.7l-0.79,0.86c0.1-0.62,0.34-1.25,0.74-1.87
				c0.4-0.62,0.91-1.2,1.53-1.73c0.62-0.53,1.32-0.95,2.09-1.26S493.17,1925.61,494.03,1925.61z"/>
			<path className="st4" d="M533.27,1925.71c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.62,0.4,1.03v15.88c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.07c0,0.55-0.18,1.13-0.54,1.75
				c-0.36,0.61-0.85,1.19-1.48,1.73s-1.36,0.98-2.21,1.33c-0.85,0.35-1.76,0.52-2.72,0.52c-1.66,0-3.13-0.43-4.43-1.28
				c-1.3-0.85-2.32-2.01-3.08-3.47c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.57,1.13-5.02c0.76-1.45,1.78-2.59,3.08-3.42
				s2.74-1.24,4.32-1.24c1.03,0,1.99,0.17,2.88,0.5c0.89,0.34,1.66,0.79,2.32,1.37c0.66,0.58,1.18,1.21,1.55,1.91
				s0.56,1.39,0.56,2.09l-0.94-0.22v-3.92c0-0.41,0.13-0.75,0.4-1.03C532.49,1925.85,532.84,1925.71,533.27,1925.71z M525.86,1942.2
				c1.2,0,2.26-0.31,3.19-0.94c0.92-0.62,1.64-1.47,2.16-2.54c0.52-1.07,0.77-2.27,0.77-3.62c0-1.32-0.26-2.51-0.77-3.56
				c-0.52-1.06-1.24-1.9-2.16-2.52c-0.92-0.62-1.99-0.94-3.19-0.94c-1.18,0-2.23,0.31-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.5
				c-0.53,1.06-0.79,2.26-0.79,3.6c0,1.34,0.26,2.55,0.79,3.62c0.53,1.07,1.25,1.91,2.18,2.54
				C523.63,1941.89,524.68,1942.2,525.86,1942.2z"/>
			<path className="st4" d="M538.96,1941.55c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S539.9,1942.78,538.96,1941.55z"/>
			<path className="st4" d="M558.83,1944.51c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69
				c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04v23.69
				c0,0.41-0.14,0.76-0.41,1.04C559.58,1944.36,559.24,1944.51,558.83,1944.51z M570.79,1925.79c0.38,0,0.71,0.15,0.99,0.45
				c0.28,0.3,0.41,0.62,0.41,0.95c0,0.38-0.19,0.74-0.58,1.08l-11.66,10.19l-0.11-3.38l9.9-8.86
				C570.05,1925.93,570.4,1925.79,570.79,1925.79z M571.18,1944.47c-0.43,0-0.79-0.16-1.08-0.47l-7.67-8.17l2.16-1.98l7.6,8.14
				c0.29,0.31,0.43,0.67,0.43,1.08c0,0.43-0.17,0.77-0.5,1.03S571.47,1944.47,571.18,1944.47z"/>
			<path className="st4" d="M575.72,1941.55c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S576.65,1942.78,575.72,1941.55z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st4" d="M146.31,2154.13c0.22,0,0.45,0.06,0.7,0.18c0.25,0.12,0.45,0.29,0.59,0.5l9.54,14.4l-1.3-0.04l9.65-14.36
				c0.34-0.46,0.74-0.68,1.22-0.68c0.38,0.02,0.73,0.17,1.03,0.45c0.3,0.28,0.45,0.62,0.45,1.03v22.28c0,0.41-0.14,0.76-0.43,1.04
				c-0.29,0.29-0.65,0.43-1.08,0.43c-0.46,0-0.82-0.14-1.1-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-19.51l0.9,0.14l-8.5,12.92
				c-0.14,0.19-0.32,0.35-0.52,0.47c-0.2,0.12-0.43,0.17-0.67,0.14c-0.22,0.02-0.43-0.02-0.65-0.14c-0.22-0.12-0.38-0.28-0.5-0.47
				l-8.39-12.89l0.76-0.97v20.3c0,0.41-0.13,0.76-0.4,1.04c-0.26,0.29-0.6,0.43-1.01,0.43c-0.41,0-0.74-0.14-1.01-0.43
				c-0.26-0.29-0.4-0.64-0.4-1.04v-22.28c0-0.38,0.14-0.73,0.43-1.03C145.52,2154.28,145.88,2154.13,146.31,2154.13z"/>
			<path className="st4" d="M191.49,2170c0,1.87-0.41,3.54-1.22,5c-0.82,1.46-1.93,2.62-3.33,3.46s-2.99,1.26-4.77,1.26
				c-1.75,0-3.34-0.42-4.75-1.26c-1.42-0.84-2.54-1.99-3.37-3.46c-0.83-1.46-1.24-3.13-1.24-5c0-1.87,0.41-3.54,1.24-5
				c0.83-1.46,1.95-2.62,3.37-3.46c1.42-0.84,3-1.26,4.75-1.26c1.78,0,3.37,0.42,4.77,1.26s2.51,1.99,3.33,3.46
				C191.09,2166.47,191.49,2168.13,191.49,2170z M188.61,2170c0-1.39-0.28-2.61-0.85-3.65c-0.56-1.04-1.33-1.87-2.3-2.48
				c-0.97-0.61-2.07-0.92-3.29-0.92c-1.2,0-2.29,0.3-3.28,0.92c-0.98,0.61-1.76,1.44-2.32,2.48c-0.56,1.04-0.85,2.26-0.85,3.65
				c0,1.37,0.28,2.58,0.85,3.64s1.34,1.89,2.32,2.5c0.98,0.61,2.08,0.92,3.28,0.92c1.22,0,2.32-0.31,3.29-0.92
				c0.97-0.61,1.74-1.45,2.3-2.5C188.33,2172.58,188.61,2171.37,188.61,2170z"/>
			<path className="st4" d="M204.85,2160.47c1.63,0,3.1,0.41,4.39,1.22c1.3,0.82,2.32,1.94,3.08,3.38c0.76,1.44,1.13,3.1,1.13,4.97
				c0,1.85-0.38,3.5-1.13,4.95c-0.76,1.45-1.78,2.59-3.06,3.42c-1.28,0.83-2.73,1.24-4.34,1.24c-0.89,0-1.72-0.14-2.5-0.41
				c-0.78-0.28-1.49-0.63-2.12-1.08c-0.64-0.44-1.17-0.94-1.6-1.49c-0.43-0.55-0.74-1.12-0.94-1.69l0.79-0.47v10.58
				c0,0.41-0.13,0.76-0.4,1.04c-0.26,0.29-0.61,0.43-1.04,0.43c-0.41,0-0.75-0.14-1.03-0.41c-0.28-0.28-0.41-0.63-0.41-1.06v-22.97
				c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v3.17
				l-0.54-0.29c0.17-0.6,0.46-1.18,0.88-1.73c0.42-0.55,0.94-1.04,1.55-1.46c0.61-0.42,1.3-0.75,2.05-0.99
				C203.25,2160.59,204.03,2160.47,204.85,2160.47z M204.53,2163.13c-1.2,0-2.26,0.3-3.19,0.9c-0.92,0.6-1.64,1.42-2.16,2.45
				c-0.52,1.03-0.77,2.22-0.77,3.56c0,1.32,0.26,2.51,0.77,3.56c0.52,1.05,1.24,1.88,2.16,2.48c0.92,0.6,1.99,0.9,3.19,0.9
				c1.2,0,2.26-0.3,3.17-0.9c0.91-0.6,1.63-1.43,2.16-2.48c0.53-1.06,0.79-2.24,0.79-3.56c0-1.34-0.26-2.53-0.79-3.56
				c-0.53-1.03-1.25-1.85-2.16-2.45C206.78,2163.43,205.73,2163.13,204.53,2163.13z"/>
			<path className="st4" d="M226.02,2179.73c-1.92,0-3.6-0.41-5.04-1.22c-1.44-0.81-2.56-1.94-3.37-3.37c-0.8-1.43-1.21-3.08-1.21-4.95
				c0-2.09,0.41-3.87,1.24-5.35c0.83-1.47,1.91-2.6,3.24-3.38s2.74-1.17,4.23-1.17c1.13,0,2.2,0.2,3.22,0.61
				c1.02,0.41,1.93,1.01,2.74,1.8c0.8,0.79,1.45,1.73,1.93,2.81s0.73,2.3,0.76,3.67c-0.02,0.38-0.18,0.7-0.47,0.96
				s-0.62,0.38-1.01,0.38h-14.22l-0.65-2.48h13.86l-0.58,0.5v-0.79c-0.1-0.98-0.43-1.83-0.99-2.54c-0.56-0.71-1.25-1.25-2.05-1.64
				c-0.8-0.38-1.65-0.58-2.54-0.58c-0.72,0-1.43,0.13-2.14,0.4c-0.71,0.26-1.34,0.67-1.91,1.22c-0.56,0.55-1.01,1.27-1.35,2.16
				c-0.34,0.89-0.5,1.96-0.5,3.2c0,1.39,0.28,2.62,0.85,3.67s1.35,1.89,2.36,2.5c1.01,0.61,2.17,0.92,3.49,0.92
				c0.86,0,1.6-0.11,2.21-0.32c0.61-0.21,1.15-0.49,1.6-0.81c0.46-0.32,0.84-0.65,1.15-0.99c0.31-0.22,0.61-0.32,0.9-0.32
				c0.36,0,0.66,0.12,0.9,0.36c0.24,0.24,0.36,0.53,0.36,0.86c0,0.41-0.2,0.78-0.61,1.12c-0.67,0.74-1.58,1.39-2.74,1.94
				C228.54,2179.45,227.31,2179.73,226.02,2179.73z"/>
			<path className="st4" d="M253.05,2152.73c0.43,0,0.78,0.14,1.04,0.41s0.4,0.63,0.4,1.06v23.69c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-3.42l0.68-0.22
				c0,0.55-0.18,1.15-0.54,1.78s-0.85,1.24-1.48,1.8c-0.62,0.56-1.36,1.02-2.21,1.37c-0.85,0.35-1.76,0.52-2.72,0.52
				c-1.63,0-3.1-0.42-4.41-1.26c-1.31-0.84-2.34-1.99-3.1-3.46c-0.76-1.46-1.13-3.13-1.13-5c0-1.89,0.38-3.57,1.13-5.04
				c0.76-1.46,1.78-2.61,3.08-3.44s2.74-1.24,4.32-1.24c1.01,0,1.96,0.17,2.84,0.5c0.89,0.34,1.66,0.79,2.32,1.37
				s1.18,1.21,1.57,1.91c0.38,0.7,0.58,1.39,0.58,2.09l-0.94-0.21v-11.74c0-0.41,0.13-0.76,0.4-1.04
				C252.27,2152.87,252.62,2152.73,253.05,2152.73z M245.64,2177.06c1.22,0,2.29-0.31,3.2-0.92s1.63-1.45,2.14-2.52
				c0.52-1.07,0.77-2.27,0.77-3.62c0-1.34-0.26-2.55-0.77-3.62c-0.52-1.07-1.24-1.91-2.16-2.52c-0.92-0.61-1.99-0.92-3.19-0.92
				c-1.18,0-2.23,0.3-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.52c-0.53,1.07-0.79,2.27-0.79,3.62c0,1.32,0.26,2.52,0.79,3.58
				c0.53,1.07,1.25,1.91,2.18,2.54C243.41,2176.75,244.46,2177.06,245.64,2177.06z"/>
			<path className="st4" d="M284.88,2152.73c0.43,0,0.78,0.14,1.04,0.41s0.4,0.63,0.4,1.06v23.69c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-3.42l0.68-0.22
				c0,0.55-0.18,1.15-0.54,1.78s-0.85,1.24-1.48,1.8c-0.62,0.56-1.36,1.02-2.21,1.37c-0.85,0.35-1.76,0.52-2.72,0.52
				c-1.63,0-3.1-0.42-4.41-1.26c-1.31-0.84-2.34-1.99-3.1-3.46c-0.76-1.46-1.13-3.13-1.13-5c0-1.89,0.38-3.57,1.13-5.04
				c0.76-1.46,1.78-2.61,3.08-3.44s2.74-1.24,4.32-1.24c1.01,0,1.96,0.17,2.84,0.5c0.89,0.34,1.66,0.79,2.32,1.37
				s1.18,1.21,1.57,1.91c0.38,0.7,0.58,1.39,0.58,2.09l-0.94-0.21v-11.74c0-0.41,0.13-0.76,0.4-1.04
				C284.1,2152.87,284.45,2152.73,284.88,2152.73z M277.46,2177.06c1.22,0,2.29-0.31,3.2-0.92s1.63-1.45,2.14-2.52
				c0.52-1.07,0.77-2.27,0.77-3.62c0-1.34-0.26-2.55-0.77-3.62c-0.52-1.07-1.24-1.91-2.16-2.52c-0.92-0.61-1.99-0.92-3.19-0.92
				c-1.18,0-2.23,0.3-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.52c-0.53,1.07-0.79,2.27-0.79,3.62c0,1.32,0.26,2.52,0.79,3.58
				c0.53,1.07,1.25,1.91,2.18,2.54C275.23,2176.75,276.29,2177.06,277.46,2177.06z"/>
			<path className="st4" d="M293.08,2179.37c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66
				c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v4.72
				l-0.43-0.76c0.14-0.74,0.4-1.47,0.77-2.18c0.37-0.71,0.85-1.35,1.42-1.91c0.58-0.56,1.24-1.01,1.98-1.33
				c0.74-0.32,1.56-0.49,2.45-0.49c0.53,0,1.01,0.12,1.46,0.38c0.44,0.25,0.67,0.61,0.67,1.06c0,0.5-0.13,0.88-0.4,1.13
				s-0.56,0.38-0.9,0.38c-0.31,0-0.61-0.07-0.9-0.21c-0.29-0.14-0.65-0.22-1.08-0.22c-0.6,0-1.19,0.17-1.78,0.5s-1.13,0.8-1.62,1.39
				c-0.49,0.59-0.89,1.26-1.19,2.02c-0.3,0.76-0.45,1.57-0.45,2.43v8.75c0,0.41-0.14,0.76-0.41,1.04
				C293.83,2179.22,293.49,2179.37,293.08,2179.37z"/>
			<path className="st4" d="M307.38,2158.05c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36s0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C308.39,2157.93,307.95,2158.05,307.38,2158.05z M308.85,2177.89c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V2177.89z"/>
			<path className="st4" d="M314.04,2160.43c0.29,0,0.56,0.08,0.83,0.23c0.26,0.16,0.46,0.39,0.58,0.7l5.98,14l-0.58,0.29l6.05-14.29
				c0.26-0.65,0.72-0.96,1.37-0.94c0.36,0,0.67,0.12,0.94,0.36s0.4,0.55,0.4,0.94c0,0.14-0.02,0.28-0.05,0.4
				c-0.04,0.12-0.08,0.24-0.13,0.36l-6.95,15.95c-0.26,0.6-0.68,0.91-1.26,0.94c-0.31,0.05-0.61-0.01-0.88-0.18
				s-0.49-0.42-0.63-0.76l-6.95-15.95c-0.02-0.07-0.05-0.17-0.09-0.31c-0.04-0.13-0.05-0.27-0.05-0.41c0-0.31,0.13-0.61,0.38-0.9
				C313.23,2160.57,313.58,2160.43,314.04,2160.43z"/>
			<path className="st4" d="M341.9,2179.73c-1.92,0-3.6-0.41-5.04-1.22c-1.44-0.81-2.56-1.94-3.37-3.37c-0.8-1.43-1.21-3.08-1.21-4.95
				c0-2.09,0.41-3.87,1.24-5.35c0.83-1.47,1.91-2.6,3.24-3.38s2.74-1.17,4.23-1.17c1.13,0,2.2,0.2,3.22,0.61
				c1.02,0.41,1.93,1.01,2.74,1.8c0.8,0.79,1.45,1.73,1.93,2.81s0.73,2.3,0.76,3.67c-0.02,0.38-0.18,0.7-0.47,0.96
				s-0.62,0.38-1.01,0.38h-14.22l-0.65-2.48h13.86l-0.58,0.5v-0.79c-0.1-0.98-0.43-1.83-0.99-2.54c-0.56-0.71-1.25-1.25-2.05-1.64
				c-0.8-0.38-1.65-0.58-2.54-0.58c-0.72,0-1.43,0.13-2.14,0.4c-0.71,0.26-1.34,0.67-1.91,1.22c-0.56,0.55-1.01,1.27-1.35,2.16
				c-0.34,0.89-0.5,1.96-0.5,3.2c0,1.39,0.28,2.62,0.85,3.67s1.35,1.89,2.36,2.5c1.01,0.61,2.17,0.92,3.49,0.92
				c0.86,0,1.6-0.11,2.21-0.32c0.61-0.21,1.15-0.49,1.6-0.81c0.46-0.32,0.84-0.65,1.15-0.99c0.31-0.22,0.61-0.32,0.9-0.32
				c0.36,0,0.66,0.12,0.9,0.36c0.24,0.24,0.36,0.53,0.36,0.86c0,0.41-0.2,0.78-0.61,1.12c-0.67,0.74-1.58,1.39-2.74,1.94
				C344.42,2179.45,343.2,2179.73,341.9,2179.73z"/>
			<path className="st4" d="M355.22,2179.37c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66
				c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v4.72
				l-0.43-0.76c0.14-0.74,0.4-1.47,0.77-2.18c0.37-0.71,0.85-1.35,1.42-1.91c0.58-0.56,1.24-1.01,1.98-1.33
				c0.74-0.32,1.56-0.49,2.45-0.49c0.53,0,1.01,0.12,1.46,0.38c0.44,0.25,0.67,0.61,0.67,1.06c0,0.5-0.13,0.88-0.4,1.13
				s-0.56,0.38-0.9,0.38c-0.31,0-0.61-0.07-0.9-0.21c-0.29-0.14-0.65-0.22-1.08-0.22c-0.6,0-1.19,0.17-1.78,0.5s-1.13,0.8-1.62,1.39
				c-0.49,0.59-0.89,1.26-1.19,2.02c-0.3,0.76-0.45,1.57-0.45,2.43v8.75c0,0.41-0.14,0.76-0.41,1.04
				C355.97,2179.22,355.63,2179.37,355.22,2179.37z"/>
			<path className="st4" d="M367.14,2176.41c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.21c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.03,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.68c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58c-0.37-0.64-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.12-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.56c0.34,0.64,0.5,1.44,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				C369.19,2178.5,368.07,2177.64,367.14,2176.41z"/>
			<path className="st4" d="M417.14,2160.43c0.38,0,0.71,0.13,0.99,0.39c0.28,0.27,0.41,0.62,0.41,1.08c0,0.1-0.01,0.2-0.02,0.31
				s-0.04,0.2-0.09,0.27l-5.54,15.95c-0.12,0.31-0.32,0.56-0.59,0.74c-0.28,0.18-0.57,0.25-0.88,0.2c-0.55-0.02-0.97-0.34-1.26-0.94
				l-4.54-11.34l0.72,0.11l-4.1,11.23c-0.26,0.6-0.68,0.91-1.26,0.94c-0.31,0.05-0.61-0.02-0.9-0.2c-0.29-0.18-0.49-0.43-0.61-0.74
				l-5.62-15.95c-0.07-0.19-0.11-0.38-0.11-0.58c0-0.41,0.13-0.76,0.4-1.04c0.26-0.29,0.62-0.43,1.08-0.43
				c0.29,0,0.55,0.07,0.79,0.21c0.24,0.14,0.41,0.38,0.5,0.72l4.86,14.15l-0.76-0.04l4.18-10.8c0.26-0.6,0.72-0.9,1.37-0.9
				c0.34,0,0.61,0.08,0.81,0.23c0.2,0.16,0.35,0.38,0.45,0.66l4.39,10.8l-0.9,0.07l4.86-14.18
				C415.96,2160.74,416.42,2160.43,417.14,2160.43z"/>
			<path className="st4" d="M423.73,2158.05c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36s0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C424.74,2157.93,424.3,2158.05,423.73,2158.05z M425.2,2177.89c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V2177.89z"/>
			<path className="st4" d="M429.67,2160.86h8.46c0.38,0,0.7,0.13,0.95,0.39c0.25,0.27,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.96
				C428.99,2160.99,429.31,2160.86,429.67,2160.86z M433.45,2155.97c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.29c0.17,0.29,0.39,0.49,0.67,0.6c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.12,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C432.69,2156.11,433.04,2155.97,433.45,2155.97z"/>
			<path className="st4" d="M452.45,2160.47c1.58,0,2.84,0.34,3.76,1.03s1.58,1.6,1.98,2.74c0.4,1.14,0.59,2.41,0.59,3.8v9.86
				c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.71-0.4-2.45c-0.26-0.74-0.7-1.34-1.31-1.78c-0.61-0.44-1.45-0.67-2.5-0.67c-0.98,0-1.88,0.22-2.7,0.67
				c-0.82,0.44-1.46,1.04-1.94,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69c0-0.41,0.14-0.76,0.41-1.04
				c0.28-0.29,0.62-0.43,1.03-0.43c0.43,0,0.78,0.14,1.04,0.43c0.26,0.29,0.4,0.64,0.4,1.04v10.73l-0.72,0.79
				c0.12-0.62,0.38-1.25,0.79-1.89c0.41-0.63,0.92-1.21,1.55-1.71c0.62-0.5,1.32-0.91,2.09-1.21
				C450.81,2160.62,451.61,2160.47,452.45,2160.47z"/>
			<path className="st4" d="M482.91,2160.47c1.63,0,2.96,0.41,3.98,1.24c1.02,0.83,1.7,2,2.03,3.51h-0.54l0.25-0.65
				c0.29-0.67,0.78-1.32,1.48-1.94c0.7-0.62,1.5-1.14,2.41-1.55c0.91-0.41,1.86-0.61,2.84-0.61c1.58,0,2.83,0.34,3.74,1.03
				s1.57,1.6,1.96,2.74c0.4,1.14,0.59,2.42,0.59,3.83v9.83c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.63,0.43-1.06,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-9.76c0-0.91-0.13-1.75-0.4-2.5c-0.26-0.76-0.71-1.36-1.33-1.82
				c-0.62-0.46-1.46-0.68-2.52-0.68c-0.96,0-1.85,0.23-2.66,0.68c-0.82,0.46-1.46,1.06-1.94,1.82c-0.48,0.76-0.72,1.59-0.72,2.5
				v9.76c0,0.41-0.13,0.76-0.4,1.04c-0.26,0.29-0.61,0.43-1.04,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04
				v-9.86c0-0.89-0.13-1.71-0.4-2.45c-0.26-0.74-0.7-1.34-1.3-1.78c-0.6-0.44-1.42-0.67-2.45-0.67c-0.96,0-1.84,0.22-2.63,0.67
				s-1.43,1.04-1.91,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41
				c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v2.7l-0.79,0.86c0.1-0.62,0.34-1.25,0.74-1.87
				c0.4-0.62,0.91-1.2,1.53-1.73c0.62-0.53,1.32-0.95,2.09-1.26C481.23,2160.62,482.05,2160.47,482.91,2160.47z"/>
			<path className="st4" d="M522.15,2160.57c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.62,0.4,1.03v15.88c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-3.42l0.68-0.07
				c0,0.55-0.18,1.13-0.54,1.75s-0.85,1.19-1.48,1.73c-0.62,0.54-1.36,0.98-2.21,1.33c-0.85,0.35-1.76,0.52-2.72,0.52
				c-1.66,0-3.13-0.43-4.43-1.28s-2.32-2.01-3.08-3.47c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.57,1.13-5.02
				c0.76-1.45,1.78-2.59,3.08-3.42s2.74-1.24,4.32-1.24c1.03,0,1.99,0.17,2.88,0.5c0.89,0.34,1.66,0.79,2.32,1.37
				c0.66,0.58,1.18,1.21,1.55,1.91c0.37,0.7,0.56,1.39,0.56,2.09l-0.94-0.21v-3.92c0-0.41,0.13-0.75,0.4-1.03
				C521.37,2160.71,521.72,2160.57,522.15,2160.57z M514.73,2177.06c1.2,0,2.26-0.31,3.19-0.94s1.64-1.47,2.16-2.54
				c0.52-1.07,0.77-2.27,0.77-3.62c0-1.32-0.26-2.51-0.77-3.56c-0.52-1.05-1.24-1.89-2.16-2.52c-0.92-0.62-1.99-0.94-3.19-0.94
				c-1.18,0-2.23,0.3-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.5c-0.53,1.06-0.79,2.26-0.79,3.6s0.26,2.55,0.79,3.62
				c0.53,1.07,1.25,1.91,2.18,2.54C512.51,2176.75,513.56,2177.06,514.73,2177.06z"/>
			<path className="st4" d="M527.84,2176.41c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.21c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.03,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.68c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58c-0.37-0.64-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.12-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.56c0.34,0.64,0.5,1.44,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				C529.89,2178.5,528.77,2177.64,527.84,2176.41z"/>
			<path className="st4" d="M547.71,2179.37c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69
				c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04v23.69
				c0,0.41-0.14,0.76-0.41,1.04C548.46,2179.22,548.12,2179.37,547.71,2179.37z M559.66,2160.65c0.38,0,0.71,0.15,0.99,0.45
				c0.28,0.3,0.41,0.62,0.41,0.95c0,0.38-0.19,0.74-0.58,1.08l-11.66,10.19l-0.11-3.38l9.9-8.86
				C558.93,2160.79,559.28,2160.65,559.66,2160.65z M560.06,2179.33c-0.43,0-0.79-0.15-1.08-0.47l-7.67-8.17l2.16-1.98l7.6,8.14
				c0.29,0.31,0.43,0.67,0.43,1.08c0,0.43-0.17,0.78-0.5,1.03S560.34,2179.33,560.06,2179.33z"/>
			<path className="st4" d="M564.59,2176.41c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.21c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.03,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.68c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58c-0.37-0.64-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.12-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.56c0.34,0.64,0.5,1.44,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				C566.65,2178.5,565.53,2177.64,564.59,2176.41z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st4" d="M146.31,2307.85c0.22,0,0.45,0.06,0.7,0.18s0.45,0.29,0.59,0.5l9.54,14.4l-1.3-0.04l9.65-14.36
				c0.34-0.46,0.74-0.68,1.22-0.68c0.38,0.02,0.73,0.17,1.03,0.45c0.3,0.28,0.45,0.62,0.45,1.03v22.28c0,0.41-0.14,0.76-0.43,1.04
				s-0.65,0.43-1.08,0.43c-0.46,0-0.82-0.14-1.1-0.43s-0.41-0.64-0.41-1.04v-19.51l0.9,0.14l-8.5,12.92
				c-0.14,0.19-0.32,0.35-0.52,0.47c-0.2,0.12-0.43,0.17-0.67,0.14c-0.22,0.02-0.43-0.02-0.65-0.14c-0.22-0.12-0.38-0.28-0.5-0.47
				l-8.39-12.89l0.76-0.97v20.3c0,0.41-0.13,0.76-0.4,1.04c-0.26,0.29-0.6,0.43-1.01,0.43c-0.41,0-0.74-0.14-1.01-0.43
				s-0.4-0.64-0.4-1.04v-22.28c0-0.38,0.14-0.73,0.43-1.03C145.52,2308,145.88,2307.85,146.31,2307.85z"/>
			<path className="st4" d="M191.49,2323.72c0,1.87-0.41,3.54-1.22,5c-0.82,1.46-1.93,2.62-3.33,3.46c-1.4,0.84-2.99,1.26-4.77,1.26
				c-1.75,0-3.34-0.42-4.75-1.26c-1.42-0.84-2.54-1.99-3.37-3.46c-0.83-1.46-1.24-3.13-1.24-5s0.41-3.54,1.24-5
				c0.83-1.46,1.95-2.62,3.37-3.46c1.42-0.84,3-1.26,4.75-1.26c1.78,0,3.37,0.42,4.77,1.26c1.4,0.84,2.51,1.99,3.33,3.46
				C191.09,2320.18,191.49,2321.85,191.49,2323.72z M188.61,2323.72c0-1.39-0.28-2.61-0.85-3.65c-0.56-1.04-1.33-1.87-2.3-2.48
				c-0.97-0.61-2.07-0.92-3.29-0.92c-1.2,0-2.29,0.31-3.28,0.92c-0.98,0.61-1.76,1.44-2.32,2.48s-0.85,2.26-0.85,3.65
				c0,1.37,0.28,2.58,0.85,3.64c0.56,1.06,1.34,1.89,2.32,2.5c0.98,0.61,2.08,0.92,3.28,0.92c1.22,0,2.32-0.31,3.29-0.92
				c0.97-0.61,1.74-1.45,2.3-2.5C188.33,2326.3,188.61,2325.09,188.61,2323.72z"/>
			<path className="st4" d="M204.85,2314.18c1.63,0,3.1,0.41,4.39,1.22c1.3,0.82,2.32,1.94,3.08,3.38s1.13,3.1,1.13,4.97
				c0,1.85-0.38,3.5-1.13,4.95s-1.78,2.59-3.06,3.42c-1.28,0.83-2.73,1.24-4.34,1.24c-0.89,0-1.72-0.14-2.5-0.41
				c-0.78-0.28-1.49-0.64-2.12-1.08c-0.64-0.44-1.17-0.94-1.6-1.49c-0.43-0.55-0.74-1.12-0.94-1.69l0.79-0.47v10.58
				c0,0.41-0.13,0.76-0.4,1.04c-0.26,0.29-0.61,0.43-1.04,0.43c-0.41,0-0.75-0.14-1.03-0.41c-0.28-0.28-0.41-0.63-0.41-1.06v-22.97
				c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v3.17
				l-0.54-0.29c0.17-0.6,0.46-1.18,0.88-1.73c0.42-0.55,0.94-1.04,1.55-1.46c0.61-0.42,1.3-0.75,2.05-0.99
				C203.25,2314.3,204.03,2314.18,204.85,2314.18z M204.53,2316.85c-1.2,0-2.26,0.3-3.19,0.9c-0.92,0.6-1.64,1.42-2.16,2.45
				s-0.77,2.22-0.77,3.56c0,1.32,0.26,2.51,0.77,3.56s1.24,1.88,2.16,2.48c0.92,0.6,1.99,0.9,3.19,0.9c1.2,0,2.26-0.3,3.17-0.9
				c0.91-0.6,1.63-1.43,2.16-2.48c0.53-1.06,0.79-2.24,0.79-3.56c0-1.34-0.26-2.53-0.79-3.56c-0.53-1.03-1.25-1.85-2.16-2.45
				C206.78,2317.15,205.73,2316.85,204.53,2316.85z"/>
			<path className="st4" d="M226.02,2333.44c-1.92,0-3.6-0.41-5.04-1.22c-1.44-0.82-2.56-1.94-3.37-3.37c-0.8-1.43-1.21-3.08-1.21-4.95
				c0-2.09,0.41-3.87,1.24-5.35c0.83-1.48,1.91-2.6,3.24-3.38c1.33-0.78,2.74-1.17,4.23-1.17c1.13,0,2.2,0.2,3.22,0.61
				c1.02,0.41,1.93,1.01,2.74,1.8c0.8,0.79,1.45,1.73,1.93,2.81s0.73,2.3,0.76,3.67c-0.02,0.38-0.18,0.7-0.47,0.95
				s-0.62,0.38-1.01,0.38h-14.22l-0.65-2.48h13.86l-0.58,0.5v-0.79c-0.1-0.98-0.43-1.83-0.99-2.54s-1.25-1.25-2.05-1.64
				c-0.8-0.38-1.65-0.58-2.54-0.58c-0.72,0-1.43,0.13-2.14,0.4c-0.71,0.26-1.34,0.67-1.91,1.22c-0.56,0.55-1.01,1.27-1.35,2.16
				c-0.34,0.89-0.5,1.96-0.5,3.2c0,1.39,0.28,2.62,0.85,3.67c0.56,1.06,1.35,1.89,2.36,2.5c1.01,0.61,2.17,0.92,3.49,0.92
				c0.86,0,1.6-0.11,2.21-0.32c0.61-0.22,1.15-0.49,1.6-0.81c0.46-0.32,0.84-0.65,1.15-0.99c0.31-0.22,0.61-0.32,0.9-0.32
				c0.36,0,0.66,0.12,0.9,0.36c0.24,0.24,0.36,0.53,0.36,0.86c0,0.41-0.2,0.78-0.61,1.12c-0.67,0.74-1.58,1.39-2.74,1.94
				C228.54,2333.17,227.31,2333.44,226.02,2333.44z"/>
			<path className="st4" d="M253.05,2306.44c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v23.69c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.22c0,0.55-0.18,1.15-0.54,1.78
				c-0.36,0.64-0.85,1.24-1.48,1.8c-0.62,0.56-1.36,1.02-2.21,1.37c-0.85,0.35-1.76,0.52-2.72,0.52c-1.63,0-3.1-0.42-4.41-1.26
				c-1.31-0.84-2.34-1.99-3.1-3.46c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.58,1.13-5.04c0.76-1.46,1.78-2.61,3.08-3.44
				s2.74-1.24,4.32-1.24c1.01,0,1.96,0.17,2.84,0.5c0.89,0.34,1.66,0.79,2.32,1.37s1.18,1.21,1.57,1.91
				c0.38,0.7,0.58,1.39,0.58,2.09l-0.94-0.22v-11.74c0-0.41,0.13-0.76,0.4-1.04S252.62,2306.44,253.05,2306.44z M245.64,2330.78
				c1.22,0,2.29-0.31,3.2-0.92c0.91-0.61,1.63-1.45,2.14-2.52c0.52-1.07,0.77-2.27,0.77-3.62c0-1.34-0.26-2.55-0.77-3.62
				c-0.52-1.07-1.24-1.91-2.16-2.52s-1.99-0.92-3.19-0.92c-1.18,0-2.23,0.31-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.52
				c-0.53,1.07-0.79,2.27-0.79,3.62c0,1.32,0.26,2.51,0.79,3.58c0.53,1.07,1.25,1.91,2.18,2.54
				C243.41,2330.47,244.46,2330.78,245.64,2330.78z"/>
			<path className="st4" d="M284.88,2306.44c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v23.69c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.22c0,0.55-0.18,1.15-0.54,1.78
				c-0.36,0.64-0.85,1.24-1.48,1.8c-0.62,0.56-1.36,1.02-2.21,1.37c-0.85,0.35-1.76,0.52-2.72,0.52c-1.63,0-3.1-0.42-4.41-1.26
				c-1.31-0.84-2.34-1.99-3.1-3.46c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.58,1.13-5.04c0.76-1.46,1.78-2.61,3.08-3.44
				s2.74-1.24,4.32-1.24c1.01,0,1.96,0.17,2.84,0.5c0.89,0.34,1.66,0.79,2.32,1.37s1.18,1.21,1.57,1.91
				c0.38,0.7,0.58,1.39,0.58,2.09l-0.94-0.22v-11.74c0-0.41,0.13-0.76,0.4-1.04S284.45,2306.44,284.88,2306.44z M277.46,2330.78
				c1.22,0,2.29-0.31,3.2-0.92c0.91-0.61,1.63-1.45,2.14-2.52c0.52-1.07,0.77-2.27,0.77-3.62c0-1.34-0.26-2.55-0.77-3.62
				c-0.52-1.07-1.24-1.91-2.16-2.52s-1.99-0.92-3.19-0.92c-1.18,0-2.23,0.31-3.15,0.92c-0.92,0.61-1.65,1.45-2.18,2.52
				c-0.53,1.07-0.79,2.27-0.79,3.62c0,1.32,0.26,2.51,0.79,3.58c0.53,1.07,1.25,1.91,2.18,2.54
				C275.23,2330.47,276.29,2330.78,277.46,2330.78z"/>
			<path className="st4" d="M293.08,2333.08c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66
				c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v4.72
				l-0.43-0.76c0.14-0.74,0.4-1.47,0.77-2.18c0.37-0.71,0.85-1.34,1.42-1.91c0.58-0.56,1.24-1.01,1.98-1.33
				c0.74-0.32,1.56-0.49,2.45-0.49c0.53,0,1.01,0.13,1.46,0.38c0.44,0.25,0.67,0.61,0.67,1.06c0,0.5-0.13,0.88-0.4,1.13
				s-0.56,0.38-0.9,0.38c-0.31,0-0.61-0.07-0.9-0.22c-0.29-0.14-0.65-0.22-1.08-0.22c-0.6,0-1.19,0.17-1.78,0.5s-1.13,0.8-1.62,1.39
				c-0.49,0.59-0.89,1.26-1.19,2.02c-0.3,0.76-0.45,1.57-0.45,2.43v8.75c0,0.41-0.14,0.76-0.41,1.04S293.49,2333.08,293.08,2333.08z
				"/>
			<path className="st4" d="M307.38,2311.77c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36c0.29,0.24,0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C308.39,2311.65,307.95,2311.77,307.38,2311.77z M308.85,2331.61c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V2331.61z"/>
			<path className="st4" d="M314.04,2314.15c0.29,0,0.56,0.08,0.83,0.23c0.26,0.16,0.46,0.39,0.58,0.7l5.98,14l-0.58,0.29l6.05-14.29
				c0.26-0.65,0.72-0.96,1.37-0.94c0.36,0,0.67,0.12,0.94,0.36c0.26,0.24,0.4,0.55,0.4,0.94c0,0.14-0.02,0.28-0.05,0.4
				s-0.08,0.24-0.13,0.36l-6.95,15.95c-0.26,0.6-0.68,0.91-1.26,0.94c-0.31,0.05-0.61-0.01-0.88-0.18s-0.49-0.42-0.63-0.76
				l-6.95-15.95c-0.02-0.07-0.05-0.17-0.09-0.31c-0.04-0.13-0.05-0.27-0.05-0.41c0-0.31,0.13-0.61,0.38-0.9
				S313.58,2314.15,314.04,2314.15z"/>
			<path className="st4" d="M341.9,2333.44c-1.92,0-3.6-0.41-5.04-1.22c-1.44-0.82-2.56-1.94-3.37-3.37c-0.8-1.43-1.21-3.08-1.21-4.95
				c0-2.09,0.41-3.87,1.24-5.35c0.83-1.48,1.91-2.6,3.24-3.38c1.33-0.78,2.74-1.17,4.23-1.17c1.13,0,2.2,0.2,3.22,0.61
				c1.02,0.41,1.93,1.01,2.74,1.8c0.8,0.79,1.45,1.73,1.93,2.81s0.73,2.3,0.76,3.67c-0.02,0.38-0.18,0.7-0.47,0.95
				s-0.62,0.38-1.01,0.38h-14.22l-0.65-2.48h13.86l-0.58,0.5v-0.79c-0.1-0.98-0.43-1.83-0.99-2.54s-1.25-1.25-2.05-1.64
				c-0.8-0.38-1.65-0.58-2.54-0.58c-0.72,0-1.43,0.13-2.14,0.4c-0.71,0.26-1.34,0.67-1.91,1.22c-0.56,0.55-1.01,1.27-1.35,2.16
				c-0.34,0.89-0.5,1.96-0.5,3.2c0,1.39,0.28,2.62,0.85,3.67c0.56,1.06,1.35,1.89,2.36,2.5c1.01,0.61,2.17,0.92,3.49,0.92
				c0.86,0,1.6-0.11,2.21-0.32c0.61-0.22,1.15-0.49,1.6-0.81c0.46-0.32,0.84-0.65,1.15-0.99c0.31-0.22,0.61-0.32,0.9-0.32
				c0.36,0,0.66,0.12,0.9,0.36c0.24,0.24,0.36,0.53,0.36,0.86c0,0.41-0.2,0.78-0.61,1.12c-0.67,0.74-1.58,1.39-2.74,1.94
				C344.42,2333.17,343.2,2333.44,341.9,2333.44z"/>
			<path className="st4" d="M355.22,2333.08c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66
				c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v4.72
				l-0.43-0.76c0.14-0.74,0.4-1.47,0.77-2.18c0.37-0.71,0.85-1.34,1.42-1.91c0.58-0.56,1.24-1.01,1.98-1.33
				c0.74-0.32,1.56-0.49,2.45-0.49c0.53,0,1.01,0.13,1.46,0.38c0.44,0.25,0.67,0.61,0.67,1.06c0,0.5-0.13,0.88-0.4,1.13
				s-0.56,0.38-0.9,0.38c-0.31,0-0.61-0.07-0.9-0.22c-0.29-0.14-0.65-0.22-1.08-0.22c-0.6,0-1.19,0.17-1.78,0.5s-1.13,0.8-1.62,1.39
				c-0.49,0.59-0.89,1.26-1.19,2.02c-0.3,0.76-0.45,1.57-0.45,2.43v8.75c0,0.41-0.14,0.76-0.41,1.04S355.63,2333.08,355.22,2333.08z
				"/>
			<path className="st4" d="M367.14,2330.13c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S368.07,2331.35,367.14,2330.13z"/>
			<path className="st4" d="M417.14,2314.15c0.38,0,0.71,0.13,0.99,0.4c0.28,0.26,0.41,0.62,0.41,1.08c0,0.1-0.01,0.2-0.02,0.31
				c-0.01,0.11-0.04,0.2-0.09,0.27l-5.54,15.95c-0.12,0.31-0.32,0.56-0.59,0.74c-0.28,0.18-0.57,0.25-0.88,0.2
				c-0.55-0.02-0.97-0.34-1.26-0.94l-4.54-11.34l0.72,0.11l-4.1,11.23c-0.26,0.6-0.68,0.91-1.26,0.94c-0.31,0.05-0.61-0.02-0.9-0.2
				c-0.29-0.18-0.49-0.43-0.61-0.74l-5.62-15.95c-0.07-0.19-0.11-0.38-0.11-0.58c0-0.41,0.13-0.76,0.4-1.04
				c0.26-0.29,0.62-0.43,1.08-0.43c0.29,0,0.55,0.07,0.79,0.22c0.24,0.14,0.41,0.38,0.5,0.72l4.86,14.15l-0.76-0.04l4.18-10.8
				c0.26-0.6,0.72-0.9,1.37-0.9c0.34,0,0.61,0.08,0.81,0.23c0.2,0.16,0.35,0.38,0.45,0.67l4.39,10.8l-0.9,0.07l4.86-14.18
				C415.96,2314.46,416.42,2314.15,417.14,2314.15z"/>
			<path className="st4" d="M423.73,2311.77c-0.6,0-1.04-0.12-1.33-0.36s-0.43-0.61-0.43-1.12v-0.5c0-0.5,0.16-0.88,0.47-1.12
				c0.31-0.24,0.76-0.36,1.33-0.36c0.58,0,1.01,0.12,1.3,0.36c0.29,0.24,0.43,0.61,0.43,1.12v0.5c0,0.5-0.15,0.88-0.45,1.12
				C424.74,2311.65,424.3,2311.77,423.73,2311.77z M425.2,2331.61c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43
				c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.95c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43
				c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04V2331.61z"/>
			<path className="st4" d="M429.67,2314.58h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C428.99,2314.7,429.31,2314.58,429.67,2314.58z M433.45,2309.68c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C432.69,2309.83,433.04,2309.68,433.45,2309.68z"/>
			<path className="st4" d="M452.45,2314.18c1.58,0,2.84,0.34,3.76,1.03s1.58,1.6,1.98,2.74s0.59,2.41,0.59,3.8v9.86
				c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.7-0.4-2.45c-0.26-0.74-0.7-1.34-1.31-1.78c-0.61-0.44-1.45-0.67-2.5-0.67c-0.98,0-1.88,0.22-2.7,0.67
				c-0.82,0.44-1.46,1.04-1.94,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.62-0.43,1.03-0.43
				c0.43,0,0.78,0.14,1.04,0.43c0.26,0.29,0.4,0.64,0.4,1.04v10.73l-0.72,0.79c0.12-0.62,0.38-1.25,0.79-1.89
				c0.41-0.64,0.92-1.21,1.55-1.71c0.62-0.5,1.32-0.91,2.09-1.21C450.81,2314.33,451.61,2314.18,452.45,2314.18z"/>
			<path className="st4" d="M481.61,2323.72c0,1.87-0.41,3.54-1.22,5c-0.82,1.46-1.93,2.62-3.33,3.46c-1.4,0.84-2.99,1.26-4.77,1.26
				c-1.75,0-3.34-0.42-4.75-1.26c-1.42-0.84-2.54-1.99-3.37-3.46c-0.83-1.46-1.24-3.13-1.24-5s0.41-3.54,1.24-5
				c0.83-1.46,1.95-2.62,3.37-3.46c1.42-0.84,3-1.26,4.75-1.26c1.78,0,3.37,0.42,4.77,1.26c1.4,0.84,2.51,1.99,3.33,3.46
				C481.21,2320.18,481.61,2321.85,481.61,2323.72z M478.73,2323.72c0-1.39-0.28-2.61-0.85-3.65c-0.56-1.04-1.33-1.87-2.3-2.48
				c-0.97-0.61-2.07-0.92-3.29-0.92c-1.2,0-2.29,0.31-3.28,0.92c-0.98,0.61-1.76,1.44-2.32,2.48s-0.85,2.26-0.85,3.65
				c0,1.37,0.28,2.58,0.85,3.64c0.56,1.06,1.34,1.89,2.32,2.5c0.98,0.61,2.08,0.92,3.28,0.92c1.22,0,2.32-0.31,3.29-0.92
				c0.97-0.61,1.74-1.45,2.3-2.5C478.45,2326.3,478.73,2325.09,478.73,2323.72z"/>
			<path className="st4" d="M499.72,2314.47c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v9.79c0,2.42-0.68,4.3-2.03,5.63
				c-1.36,1.33-3.25,2-5.67,2c-2.4,0-4.28-0.67-5.63-2c-1.36-1.33-2.03-3.21-2.03-5.63v-9.79c0-0.43,0.14-0.79,0.41-1.06
				c0.28-0.28,0.62-0.41,1.03-0.41c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v9.79c0,1.63,0.42,2.87,1.26,3.71
				c0.84,0.84,2.02,1.26,3.53,1.26c1.54,0,2.72-0.42,3.56-1.26c0.84-0.84,1.26-2.08,1.26-3.71v-9.79c0-0.43,0.13-0.79,0.4-1.06
				C498.94,2314.61,499.29,2314.47,499.72,2314.47z"/>
			<path className="st4" d="M505.77,2314.58h8.46c0.38,0,0.7,0.13,0.95,0.4c0.25,0.26,0.38,0.59,0.38,0.97c0,0.36-0.13,0.67-0.38,0.92
				s-0.57,0.38-0.95,0.38h-8.46c-0.36,0-0.68-0.13-0.95-0.4c-0.28-0.26-0.41-0.58-0.41-0.94c0-0.38,0.14-0.7,0.41-0.95
				C505.09,2314.7,505.41,2314.58,505.77,2314.58z M509.55,2309.68c0.41,0,0.74,0.14,1.01,0.43c0.26,0.29,0.4,0.64,0.4,1.04v17.35
				c0,0.58,0.08,1.01,0.25,1.3s0.39,0.49,0.67,0.59c0.28,0.11,0.55,0.16,0.81,0.16c0.24,0,0.45-0.04,0.63-0.13
				c0.18-0.08,0.39-0.13,0.63-0.13c0.24,0,0.46,0.11,0.67,0.34c0.2,0.23,0.31,0.52,0.31,0.88c0,0.43-0.25,0.8-0.76,1.1
				c-0.5,0.3-1.07,0.45-1.69,0.45c-0.34,0-0.75-0.02-1.24-0.07c-0.49-0.05-0.98-0.2-1.46-0.47c-0.48-0.26-0.88-0.7-1.21-1.31
				c-0.32-0.61-0.49-1.47-0.49-2.57v-17.5c0-0.41,0.14-0.76,0.43-1.04C508.79,2309.83,509.14,2309.68,509.55,2309.68z"/>
			<path className="st4" d="M538.35,2314.18c1.63,0,2.96,0.41,3.98,1.24c1.02,0.83,1.7,2,2.03,3.51h-0.54l0.25-0.65
				c0.29-0.67,0.78-1.32,1.48-1.94c0.7-0.62,1.5-1.14,2.41-1.55c0.91-0.41,1.86-0.61,2.84-0.61c1.58,0,2.83,0.34,3.74,1.03
				s1.57,1.6,1.96,2.74s0.59,2.42,0.59,3.83v9.83c0,0.41-0.14,0.76-0.41,1.04c-0.28,0.29-0.63,0.43-1.06,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-9.76c0-0.91-0.13-1.75-0.4-2.5c-0.26-0.76-0.71-1.36-1.33-1.82
				c-0.62-0.46-1.46-0.68-2.52-0.68c-0.96,0-1.85,0.23-2.66,0.68s-1.46,1.06-1.94,1.82c-0.48,0.76-0.72,1.59-0.72,2.5v9.76
				c0,0.41-0.13,0.76-0.4,1.04s-0.61,0.43-1.04,0.43c-0.43,0-0.78-0.14-1.04-0.43c-0.26-0.29-0.4-0.64-0.4-1.04v-9.86
				c0-0.89-0.13-1.7-0.4-2.45c-0.26-0.74-0.7-1.34-1.3-1.78c-0.6-0.44-1.42-0.67-2.45-0.67c-0.96,0-1.84,0.22-2.63,0.67
				c-0.79,0.44-1.43,1.04-1.91,1.78c-0.48,0.74-0.72,1.56-0.72,2.45v9.86c0,0.41-0.14,0.76-0.41,1.04s-0.62,0.43-1.03,0.43
				c-0.41,0-0.75-0.14-1.03-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-15.66c0-0.43,0.14-0.79,0.41-1.06c0.28-0.28,0.62-0.41,1.03-0.41
				c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.63,0.4,1.06v2.7l-0.79,0.86c0.1-0.62,0.34-1.25,0.74-1.87
				c0.4-0.62,0.91-1.2,1.53-1.73c0.62-0.53,1.32-0.95,2.09-1.26S537.48,2314.18,538.35,2314.18z"/>
			<path className="st4" d="M577.59,2314.29c0.43,0,0.78,0.14,1.04,0.41c0.26,0.28,0.4,0.62,0.4,1.03v15.88c0,0.41-0.14,0.76-0.41,1.04
				c-0.28,0.29-0.62,0.43-1.03,0.43c-0.43,0-0.78-0.14-1.04-0.43s-0.4-0.64-0.4-1.04v-3.42l0.68-0.07c0,0.55-0.18,1.13-0.54,1.75
				c-0.36,0.61-0.85,1.19-1.48,1.73s-1.36,0.98-2.21,1.33c-0.85,0.35-1.76,0.52-2.72,0.52c-1.66,0-3.13-0.43-4.43-1.28
				c-1.3-0.85-2.32-2.01-3.08-3.47c-0.76-1.46-1.13-3.13-1.13-5c0-1.9,0.38-3.57,1.13-5.02c0.76-1.45,1.78-2.59,3.08-3.42
				s2.74-1.24,4.32-1.24c1.03,0,1.99,0.17,2.88,0.5c0.89,0.34,1.66,0.79,2.32,1.37c0.66,0.58,1.18,1.21,1.55,1.91
				s0.56,1.39,0.56,2.09l-0.94-0.22v-3.92c0-0.41,0.13-0.75,0.4-1.03C576.81,2314.43,577.16,2314.29,577.59,2314.29z
				 M570.17,2330.78c1.2,0,2.26-0.31,3.19-0.94c0.92-0.62,1.64-1.47,2.16-2.54c0.52-1.07,0.77-2.27,0.77-3.62
				c0-1.32-0.26-2.51-0.77-3.56c-0.52-1.06-1.24-1.9-2.16-2.52c-0.92-0.62-1.99-0.94-3.19-0.94c-1.18,0-2.23,0.31-3.15,0.92
				c-0.92,0.61-1.65,1.45-2.18,2.5c-0.53,1.06-0.79,2.26-0.79,3.6c0,1.34,0.26,2.55,0.79,3.62c0.53,1.07,1.25,1.91,2.18,2.54
				C567.95,2330.47,569,2330.78,570.17,2330.78z"/>
			<path className="st4" d="M583.28,2330.13c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S584.21,2331.35,583.28,2330.13z"/>
			<path className="st4" d="M603.15,2333.08c-0.43,0-0.79-0.14-1.06-0.43c-0.28-0.29-0.41-0.64-0.41-1.04v-23.69
				c0-0.41,0.14-0.76,0.41-1.04c0.28-0.29,0.63-0.43,1.06-0.43c0.41,0,0.75,0.14,1.03,0.43c0.28,0.29,0.41,0.64,0.41,1.04v23.69
				c0,0.41-0.14,0.76-0.41,1.04C603.9,2332.94,603.56,2333.08,603.15,2333.08z M615.1,2314.36c0.38,0,0.71,0.15,0.99,0.45
				c0.28,0.3,0.41,0.62,0.41,0.95c0,0.38-0.19,0.74-0.58,1.08l-11.66,10.19l-0.11-3.38l9.9-8.86
				C614.37,2314.51,614.72,2314.36,615.1,2314.36z M615.5,2333.05c-0.43,0-0.79-0.16-1.08-0.47l-7.67-8.17l2.16-1.98l7.6,8.14
				c0.29,0.31,0.43,0.67,0.43,1.08c0,0.43-0.17,0.77-0.5,1.03S615.78,2333.05,615.5,2333.05z"/>
			<path className="st4" d="M620.03,2330.13c-0.19-0.31-0.28-0.64-0.27-0.99c0.01-0.35,0.21-0.65,0.59-0.92
				c0.26-0.17,0.56-0.24,0.88-0.22c0.32,0.02,0.62,0.18,0.88,0.47c0.67,0.79,1.44,1.42,2.3,1.89c0.86,0.47,1.92,0.7,3.17,0.7
				c0.55-0.02,1.12-0.12,1.71-0.29c0.59-0.17,1.08-0.46,1.48-0.88s0.59-0.98,0.59-1.67c0-0.67-0.2-1.21-0.61-1.6
				c-0.41-0.4-0.94-0.72-1.6-0.97c-0.66-0.25-1.36-0.47-2.11-0.67c-0.79-0.22-1.57-0.46-2.34-0.72c-0.77-0.26-1.46-0.61-2.07-1.03
				c-0.61-0.42-1.1-0.95-1.48-1.58s-0.56-1.42-0.56-2.36c0-1.08,0.29-2.02,0.88-2.81c0.59-0.79,1.37-1.4,2.36-1.84
				c0.98-0.43,2.08-0.65,3.28-0.65c0.67,0,1.37,0.08,2.11,0.23c0.73,0.16,1.45,0.42,2.14,0.79c0.7,0.37,1.31,0.88,1.84,1.53
				c0.22,0.24,0.34,0.54,0.36,0.9c0.02,0.36-0.13,0.68-0.47,0.97c-0.26,0.19-0.56,0.28-0.88,0.27c-0.32-0.01-0.59-0.13-0.81-0.34
				c-0.53-0.62-1.17-1.1-1.93-1.42c-0.76-0.32-1.59-0.49-2.5-0.49c-0.55,0-1.1,0.09-1.66,0.27c-0.55,0.18-1.01,0.46-1.39,0.85
				c-0.37,0.38-0.56,0.92-0.56,1.62c0.02,0.65,0.24,1.18,0.65,1.58c0.41,0.41,0.96,0.74,1.66,0.99c0.7,0.25,1.46,0.5,2.3,0.74
				c0.77,0.19,1.51,0.41,2.21,0.67c0.71,0.25,1.35,0.58,1.93,0.99c0.58,0.41,1.03,0.93,1.37,1.57c0.34,0.64,0.5,1.43,0.5,2.39
				c0,1.1-0.31,2.06-0.94,2.86c-0.62,0.8-1.45,1.42-2.47,1.84c-1.02,0.42-2.12,0.63-3.29,0.63c-1.32,0-2.63-0.25-3.92-0.74
				S620.97,2331.35,620.03,2330.13z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<rect x="1327.3" y="2582.13" className="st4" width="433.58" height="37.15"/>
	</g>
	<g>
		<path className="st4" d="M1761,2619.41h-433.83v-37.4H1761V2619.41z M1327.42,2619.16h433.33v-36.9h-433.33V2619.16z"/>
	</g>
</g>
<g>
	<g>
		<rect x="1327.3" y="2665.09" className="st4" width="433.58" height="37.15"/>
	</g>
	<g>
		<path className="st4" d="M1761,2702.36h-433.83v-37.4H1761V2702.36z M1327.42,2702.11h433.33v-36.9h-433.33V2702.11z"/>
	</g>
</g>
<g>
	<g>
		<rect x="1327.3" y="2748.04" className="st4" width="433.58" height="37.15"/>
	</g>
	<g>
		<path className="st4" d="M1761,2785.32h-433.83v-37.4H1761V2785.32z M1327.42,2785.07h433.33v-36.9h-433.33V2785.07z"/>
	</g>
</g>
<g>
	<g>
		<rect x="1326.51" y="2830.31" className="st4" width="433.58" height="37.15"/>
	</g>
	<g>
		<path className="st4" d="M1760.21,2867.58h-433.83v-37.4h433.83V2867.58z M1326.63,2867.33h433.33v-36.9h-433.33V2867.33z"/>
	</g>
</g>
<g className="st16">
	<g>
		<rect x="-1373.02" y="1382.91" className="st17" width="126.49" height="292.76"/>
	</g>
</g>
<g className="st16">
	<g>
		<polygon className="st4" points="-1246.53,1470.23 -1373.02,1547.5 -1373.02,1619.11 -1246.53,1547.51 		"/>
	</g>
</g>
<g className="st16">
	<g>
		<rect x="-1373.02" y="994.33" className="st17" width="126.49" height="292.76"/>
	</g>
</g>
<g className="st16">
	<g>
		<polygon className="st4" points="-1246.53,1081.65 -1373.02,1158.92 -1373.02,1230.53 -1246.53,1158.93 		"/>
	</g>
</g>
<g className="st16">
	<g>
		<rect x="-1373.02" y="1771.49" className="st17" width="126.49" height="292.76"/>
	</g>
</g>
<g className="st16">
	<g>
		<polygon className="st4" points="-1246.53,1858.8 -1373.02,1936.07 -1373.02,2007.68 -1246.53,1936.08 		"/>
	</g>
</g>
<g className="st16">
	<g>
		<rect x="-1373.02" y="2160.06" className="st17" width="126.49" height="292.76"/>
	</g>
</g>
<g className="st16">
	<g>
		<polygon className="st4" points="-1246.53,2247.38 -1373.02,2324.65 -1373.02,2396.26 -1246.53,2324.66 		"/>
	</g>
</g>
<g>
	<g>
		<rect x="-967.86" y="1121.55" className="st18" width="866.39" height="1122.91"/>
	</g>
	<g>
		<path className="st4" d="M-99.46,2246.46h-870.39V1119.55h870.39V2246.46z M-965.86,2242.46h862.39V1123.55h-862.39V2242.46z"/>
	</g>
</g>
<g>
	<g>
		<circle className="st18" cx="-534.66" cy="1682.5" r="161.34"/>
	</g>
	<g>
		<path className="st4" d="M-534.66,1845.85c-90.07,0-163.34-73.28-163.34-163.34c0-90.07,73.28-163.34,163.34-163.34
			s163.34,73.28,163.34,163.34C-371.32,1772.57-444.59,1845.85-534.66,1845.85z M-534.66,1523.16
			c-87.86,0-159.34,71.48-159.34,159.34s71.48,159.34,159.34,159.34s159.34-71.48,159.34-159.34S-446.8,1523.16-534.66,1523.16z"/>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M-537.22,1323.6c-0.81,0-1.62-0.01-2.43-0.02c-43.47-0.64-85.73-18.47-122.21-51.57
			c-38.6-35.03-70.19-87.04-91.35-150.43l3.79-1.27c20.94,62.74,52.15,114.17,90.24,148.73c35.75,32.44,77.09,49.91,119.58,50.54
			c43.29,0.64,86.08-16.17,123.79-48.6c40.15-34.52,73.71-86.42,97.07-150.08l3.75,1.38c-23.59,64.3-57.55,116.76-98.21,151.73
			C-450.96,1306.49-493.8,1323.6-537.22,1323.6z"/>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M-318.96,2245.74c-22.89-63.82-56.08-115.96-95.97-150.78c-37.13-32.4-79.37-49.5-122.23-49.5
			c-0.4,0-0.8,0-1.2,0c-42.49,0.32-83.96,17.49-119.94,49.67c-38.34,34.29-69.92,85.49-91.32,148.08l-3.79-1.29
			c21.62-63.23,53.58-115.02,92.44-149.76c36.72-32.83,79.1-50.36,122.58-50.68c44.29-0.29,87.87,17.13,126.09,50.49
			c40.41,35.26,73.98,87.98,97.11,152.44L-318.96,2245.74z"/>
	</g>
</g>
<g>
	<g>
		<line className="st18" x1="-373.32" y1="1682.5" x2="-101.46" y2="1682.5"/>
	</g>
	<g>
		<rect x="-373.32" y="1680.5" className="st4" width="271.85" height="4"/>
	</g>
</g>
<g>
	<g>
		<line className="st18" x1="-967.86" y1="1682.5" x2="-696" y2="1682.5"/>
	</g>
	<g>
		<rect x="-967.86" y="1680.5" className="st4" width="271.85" height="4"/>
	</g>
</g>
<g>
	<g>
		<path className="st19" d="M-315.87,1080.15h-437.58V999.7c0-12.56,10.22-22.78,22.78-22.78h397.8c9.37,0,17,7.63,17,17V1080.15z
			 M-751.45,1078.15h433.58v-84.24c0-8.27-6.73-15-15-15h-397.8c-11.46,0-20.78,9.32-20.78,20.78V1078.15z"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-712.44" y1="977.92" x2="-712.44" y2="1079.15"/>
	</g>
	<g>
		<rect x="-712.94" y="977.92" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-316.87" y1="1012.9" x2="-751.32" y2="1012.9"/>
	</g>
	<g>
		<rect x="-751.32" y="1012.4" className="st19" width="434.45" height="1"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-316.87" y1="991.58" x2="-751.32" y2="991.58"/>
	</g>
	<g>
		<rect x="-751.32" y="991.08" className="st19" width="434.45" height="1"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-316.87" y1="1034.21" x2="-751.32" y2="1034.21"/>
	</g>
	<g>
		<rect x="-751.32" y="1033.71" className="st19" width="434.45" height="1"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-316.87" y1="1059.53" x2="-751.32" y2="1059.53"/>
	</g>
	<g>
		<rect x="-751.32" y="1059.03" className="st19" width="434.45" height="1"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-656" y1="977.92" x2="-656" y2="1079.15"/>
	</g>
	<g>
		<rect x="-656.5" y="977.92" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-608" y1="977.92" x2="-608" y2="1079.15"/>
	</g>
	<g>
		<rect x="-608.5" y="977.92" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-568.97" y1="977.92" x2="-568.97" y2="1079.15"/>
	</g>
	<g>
		<rect x="-569.47" y="977.92" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-529.27" y1="977.92" x2="-529.27" y2="1079.15"/>
	</g>
	<g>
		<rect x="-529.77" y="977.92" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-481.8" y1="977.92" x2="-481.8" y2="1079.15"/>
	</g>
	<g>
		<rect x="-482.3" y="977.92" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-447.26" y1="977.92" x2="-447.26" y2="1079.15"/>
	</g>
	<g>
		<rect x="-447.76" y="977.92" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-398.33" y1="977.92" x2="-398.33" y2="1079.15"/>
	</g>
	<g>
		<rect x="-398.83" y="977.92" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-351.25" y1="977.92" x2="-351.25" y2="1079.15"/>
	</g>
	<g>
		<rect x="-351.75" y="977.92" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<path className="st19" d="M-332.3,2384.45h-397.8c-12.56,0-22.78-10.22-22.78-22.78v-80.46h437.58v86.24
			C-315.3,2376.82-322.93,2384.45-332.3,2384.45z M-750.88,2283.21v78.46c0,11.46,9.32,20.78,20.78,20.78h397.8
			c8.27,0,15-6.73,15-15v-84.24H-750.88z"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-711.87" y1="2383.45" x2="-711.87" y2="2282.21"/>
	</g>
	<g>
		<rect x="-712.37" y="2282.21" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-316.3" y1="2348.47" x2="-750.75" y2="2348.47"/>
	</g>
	<g>
		<rect x="-750.75" y="2347.97" className="st19" width="434.45" height="1"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-316.3" y1="2369.79" x2="-750.75" y2="2369.79"/>
	</g>
	<g>
		<rect x="-750.75" y="2369.29" className="st19" width="434.45" height="1"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-316.3" y1="2327.15" x2="-750.75" y2="2327.15"/>
	</g>
	<g>
		<rect x="-750.75" y="2326.65" className="st19" width="434.45" height="1"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-316.3" y1="2301.83" x2="-750.75" y2="2301.83"/>
	</g>
	<g>
		<rect x="-750.75" y="2301.33" className="st19" width="434.45" height="1"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-655.43" y1="2383.45" x2="-655.43" y2="2282.21"/>
	</g>
	<g>
		<rect x="-655.94" y="2282.21" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-607.43" y1="2383.45" x2="-607.43" y2="2282.21"/>
	</g>
	<g>
		<rect x="-607.94" y="2282.21" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-568.4" y1="2383.45" x2="-568.4" y2="2282.21"/>
	</g>
	<g>
		<rect x="-568.9" y="2282.21" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-528.71" y1="2383.45" x2="-528.71" y2="2282.21"/>
	</g>
	<g>
		<rect x="-529.21" y="2282.21" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-481.24" y1="2383.45" x2="-481.24" y2="2282.21"/>
	</g>
	<g>
		<rect x="-481.74" y="2282.21" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-446.7" y1="2383.45" x2="-446.7" y2="2282.21"/>
	</g>
	<g>
		<rect x="-447.2" y="2282.21" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-397.76" y1="2383.45" x2="-397.76" y2="2282.21"/>
	</g>
	<g>
		<rect x="-398.26" y="2282.21" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<line className="st1" x1="-350.69" y1="2383.45" x2="-350.69" y2="2282.21"/>
	</g>
	<g>
		<rect x="-351.19" y="2282.21" className="st19" width="1" height="101.24"/>
	</g>
</g>
<g>
	<g>
		<circle className="st4" cx="-464.04" cy="1606.96" r="17.27"/>
	</g>
</g>
<g>
	<g>
		
			<ellipse transform="matrix(0.8747 -0.4846 0.4846 0.8747 -831.2931 -28.5739)" className="st20" cx="-470.92" cy="1593.78" rx="6.49" ry="2.6"/>
	</g>
</g>
<g>
	<g>
		
			<ellipse transform="matrix(0.8747 -0.4846 0.4846 0.8747 -842.1448 -18.2843)" className="st20" cx="-456.44" cy="1619.92" rx="6.49" ry="2.76"/>
	</g>
</g>
<g>
	<g>
		
			<ellipse transform="matrix(0.8747 -0.4846 0.4846 0.8747 -831.8063 -18.0165)" className="st20" cx="-450.75" cy="1600.05" rx="2.71" ry="6.49"/>
	</g>
</g>
<g>
	<g>
		
			<ellipse transform="matrix(0.8747 -0.4846 0.4846 0.8747 -842.0959 -28.8681)" className="st20" cx="-476.89" cy="1614.53" rx="2.66" ry="6.49"/>
	</g>
</g>
<g>
	<g>
		<circle className="st20" cx="-464" cy="1606.28" r="6.02"/>
	</g>
</g>
<g>
	<g>
		<ellipse className="st20" cx="-462.34" cy="1609.08" rx="0.49" ry="0.08"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="1870.07" y1="2742.49" x2="1960.26" y2="2742.49"/>
	</g>
	<g>
		<rect x="1870.07" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="2115.34" y1="2742.49" x2="2205.54" y2="2742.49"/>
	</g>
	<g>
		<rect x="2115.34" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="2360.62" y1="2742.49" x2="2450.81" y2="2742.49"/>
	</g>
	<g>
		<rect x="2360.62" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="2602.73" y1="2742.49" x2="2692.92" y2="2742.49"/>
	</g>
	<g>
		<rect x="2602.73" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="2829.01" y1="2742.49" x2="2919.21" y2="2742.49"/>
	</g>
	<g>
		<rect x="2829.01" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="3066.37" y1="2742.49" x2="3156.57" y2="2742.49"/>
	</g>
	<g>
		<rect x="3066.37" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="3317.98" y1="2742.49" x2="3408.18" y2="2742.49"/>
	</g>
	<g>
		<rect x="3317.98" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="-294.68" y1="2742.49" x2="-204.48" y2="2742.49"/>
	</g>
	<g>
		<rect x="-294.68" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="-49.41" y1="2742.49" x2="40.79" y2="2742.49"/>
	</g>
	<g>
		<rect x="-49.41" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="195.87" y1="2742.49" x2="286.07" y2="2742.49"/>
	</g>
	<g>
		<rect x="195.87" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="437.98" y1="2742.49" x2="528.18" y2="2742.49"/>
	</g>
	<g>
		<rect x="437.98" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="664.26" y1="2742.49" x2="754.46" y2="2742.49"/>
	</g>
	<g>
		<rect x="664.26" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="901.63" y1="2742.49" x2="991.82" y2="2742.49"/>
	</g>
	<g>
		<rect x="901.63" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="1153.23" y1="2742.49" x2="1243.43" y2="2742.49"/>
	</g>
	<g>
		<rect x="1153.23" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="-1502.83" y1="2742.49" x2="-1412.63" y2="2742.49"/>
	</g>
	<g>
		<rect x="-1502.83" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="-1260.72" y1="2742.49" x2="-1170.52" y2="2742.49"/>
	</g>
	<g>
		<rect x="-1260.72" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="-1034.43" y1="2742.49" x2="-944.23" y2="2742.49"/>
	</g>
	<g>
		<rect x="-1034.43" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="-797.07" y1="2742.49" x2="-706.87" y2="2742.49"/>
	</g>
	<g>
		<rect x="-797.07" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<line className="st4" x1="-545.46" y1="2742.49" x2="-455.27" y2="2742.49"/>
	</g>
	<g>
		<rect x="-545.46" y="2736.99" className="st4" width="90.2" height="11"/>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st1" d="M1208.91,818.43c7.72,0,7.73-12,0-12C1201.19,806.43,1201.18,818.43,1208.91,818.43L1208.91,818.43z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<path className="st21" d="M1201.15,807.37"/>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M685.18,828.98h-28.81c-3.16,0-5.73-2.56-5.73-5.73v-13.5c0-3.16,2.56-5.73,5.73-5.73h28.81
				c3.16,0,5.73,2.56,5.73,5.73v13.5C690.9,826.42,688.34,828.98,685.18,828.98z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M665.18,820.1l-2.87,2.81c-0.56,0.55-1.46,0.54-2.01-0.02l-1.08-1.11c-0.55-0.56-0.54-1.46,0.02-2.01
				l2.87-2.81c0.56-0.55,1.46-0.54,2.01,0.02l1.08,1.11C665.75,818.65,665.74,819.55,665.18,820.1z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M676.82,815.61l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18c-0.78,0.09-1.48-0.47-1.57-1.25
				l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C676.03,814.27,676.73,814.83,676.82,815.61z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M680.95,811.5l0.09,0.78l0.37,3.21c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18
				c-0.78,0.09-1.48-0.47-1.57-1.25l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C680.16,810.16,680.86,810.72,680.95,811.5
				z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M685.88,814.86l-2.7,5.28c-0.36,0.7-1.21,0.97-1.91,0.62l-1.38-0.71c-0.7-0.36-0.97-1.21-0.62-1.91l2.7-5.28
				c0.36-0.7,1.21-0.97,1.91-0.62l1.38,0.71C685.96,813.31,686.24,814.17,685.88,814.86z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M681.71,818.2c0.12-0.56,0.4-1.02,0.77-1.46c0.27-0.32,0.75-1.04,1.2-1.04c-0.09-0.05-0.17-0.1-0.26-0.15
					c0.2,0.28-0.49,1.31-0.62,1.58c-0.22,0.47-0.38,0.95-0.47,1.46c-0.07,0.38,0.51,0.54,0.58,0.16c0.16-0.85,0.58-1.54,0.9-2.33
					c0.13-0.33,0.48-1.18-0.09-1.32c-0.55-0.14-1.16,0.64-1.46,0.98c-0.51,0.58-0.96,1.19-1.13,1.95
					C681.05,818.41,681.63,818.57,681.71,818.2L681.71,818.2z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M682.64,814.87c-0.63,0.06-1,0.63-1.41,1.07c-0.22,0.23-0.46,0.46-0.65,0.72
					c-0.21,0.29-0.32,0.62-0.54,0.9c-0.24,0.3,0.18,0.73,0.42,0.42c0.3-0.37,0.46-0.82,0.77-1.17c0.18-0.2,0.37-0.4,0.55-0.6
					c0.19-0.2,0.54-0.71,0.84-0.74C683.02,815.43,683.02,814.83,682.64,814.87L682.64,814.87z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M668.18,814.32l4.78,3.87c0.63,0.51,0.73,1.44,0.22,2.08l-1.01,1.25c-0.51,0.63-1.44,0.73-2.07,0.22l-4.78-3.87
				c-0.63-0.51-0.73-1.44-0.22-2.07l1.01-1.25C666.62,813.9,667.55,813.8,668.18,814.32z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M670.68,819.28c-0.52-0.23-0.92-0.6-1.28-1.04c-0.19-0.23-0.37-0.48-0.54-0.73
					c-0.08-0.11-0.15-0.22-0.21-0.34c-0.41-0.27-0.42-0.31-0.03-0.12c0.47,0.23,0.86,0.6,1.27,0.92c0.42,0.32,0.88,0.56,1.37,0.76
					c0.36,0.15,0.51-0.43,0.16-0.58c-0.86-0.35-1.47-0.99-2.24-1.47c-0.31-0.19-0.99-0.6-1.22-0.09c-0.25,0.54,0.45,1.34,0.73,1.71
					c0.46,0.62,0.97,1.18,1.69,1.5C670.72,819.96,671.03,819.44,670.68,819.28L670.68,819.28z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M667.5,817.68c-0.05,0.69,0.59,1.31,0.96,1.83c0.37,0.52,0.86,0.87,1.26,1.36
					c0.24,0.3,0.67-0.13,0.42-0.42c-0.32-0.39-0.74-0.65-1.04-1.06c-0.3-0.42-1.04-1.16-1-1.7
					C668.13,817.29,667.53,817.29,667.5,817.68L667.5,817.68z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M663.19,816.71l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1L655,815.9c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C664.41,815.66,663.97,816.48,663.19,816.71z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M657.71,815.93c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16c-0.03-0.1-0.05-0.19-0.08-0.29
					c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52c0.8-0.51,1.67-0.66,2.52-1.04
					c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C657.07,815.61,657.37,816.13,657.71,815.93L657.71,815.93z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M660.85,814.27c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C660.73,814.94,661.15,814.52,660.85,814.27L660.85,814.27z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M681.75,824.36l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C682.98,823.31,682.53,824.13,681.75,824.36z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M676.27,823.58c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16c-0.03-0.1-0.05-0.19-0.08-0.29
					c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52c0.8-0.51,1.67-0.66,2.52-1.04
					c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C675.63,823.26,675.94,823.78,676.27,823.58L676.27,823.58z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M679.41,821.92c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C679.29,822.59,679.72,822.17,679.41,821.92L679.41,821.92z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="661.21,817.68 662.31,822.9 663.87,821.38 662.54,816.67 			"/>
		</g>
	</g>
	<g id="XMLID_1_">
		<g>
			<g>
				<polygon className="st24" points="676.73,816.57 677.19,818.67 672.7,817.96 672.54,816.28 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_43_">
		<g>
			<g>
				<polygon className="st24" points="680.96,812.71 681.42,814.81 676.93,814.1 676.76,812.43 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M683.12,827h-24.81c-3.16,0-5.73-2.56-5.73-5.73v-8.49c0-3.16,2.56-5.73,5.73-5.73h24.81
				c3.16,0,5.73,2.56,5.73,5.73v8.49C688.85,824.44,686.28,827,683.12,827z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M686.45,809.44h-31.62c-2.31,0-4.19-1.87-4.19-4.19v-2.24c0-0.22,0.18-0.4,0.4-0.4h38.79
				c0.22,0,0.4,0.18,0.4,0.4v2.65C690.23,807.75,688.54,809.44,686.45,809.44z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M36.23,828.98H7.42c-3.16,0-5.73-2.56-5.73-5.73v-13.5c0-3.16,2.56-5.73,5.73-5.73h28.81
				c3.16,0,5.73,2.56,5.73,5.73v13.5C41.95,826.42,39.39,828.98,36.23,828.98z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M16.23,820.1l-2.87,2.81c-0.56,0.55-1.46,0.54-2.01-0.02l-1.08-1.11c-0.55-0.56-0.54-1.46,0.02-2.01
				l2.87-2.81c0.56-0.55,1.46-0.54,2.01,0.02l1.08,1.11C16.8,818.65,16.79,819.55,16.23,820.1z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M27.87,815.61l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18c-0.78,0.09-1.48-0.47-1.57-1.25
				l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C27.07,814.27,27.78,814.83,27.87,815.61z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M32,811.5l0.09,0.78l0.37,3.21c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18c-0.78,0.09-1.48-0.47-1.57-1.25
				L27.64,812c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C31.21,810.16,31.91,810.72,32,811.5z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M36.93,814.86l-2.7,5.28c-0.36,0.7-1.21,0.97-1.91,0.62l-1.38-0.71c-0.7-0.36-0.97-1.21-0.62-1.91l2.7-5.28
				c0.36-0.7,1.21-0.97,1.91-0.62l1.38,0.71C37.01,813.31,37.28,814.17,36.93,814.86z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M32.76,818.2c0.12-0.56,0.4-1.02,0.77-1.46c0.27-0.32,0.75-1.04,1.2-1.04c-0.09-0.05-0.17-0.1-0.26-0.15
					c0.2,0.28-0.49,1.31-0.62,1.58c-0.22,0.47-0.38,0.95-0.47,1.46c-0.07,0.38,0.51,0.54,0.58,0.16c0.16-0.85,0.58-1.54,0.9-2.33
					c0.13-0.33,0.48-1.18-0.09-1.32c-0.55-0.14-1.16,0.64-1.46,0.98c-0.51,0.58-0.96,1.19-1.13,1.95
					C32.1,818.41,32.68,818.57,32.76,818.2L32.76,818.2z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M33.69,814.87c-0.63,0.06-1,0.63-1.41,1.07c-0.22,0.23-0.46,0.46-0.65,0.72c-0.21,0.29-0.32,0.62-0.54,0.9
					c-0.24,0.3,0.18,0.73,0.42,0.42c0.3-0.37,0.46-0.82,0.77-1.17c0.18-0.2,0.37-0.4,0.55-0.6c0.19-0.2,0.54-0.71,0.84-0.74
					C34.07,815.43,34.07,814.83,33.69,814.87L33.69,814.87z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M19.23,814.32l4.78,3.87c0.63,0.51,0.73,1.44,0.22,2.08l-1.01,1.25c-0.51,0.63-1.44,0.73-2.07,0.22l-4.78-3.87
				c-0.63-0.51-0.73-1.44-0.22-2.07l1.01-1.25C17.67,813.9,18.59,813.8,19.23,814.32z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M21.73,819.28c-0.52-0.23-0.92-0.6-1.28-1.04c-0.19-0.23-0.37-0.48-0.54-0.73
					c-0.08-0.11-0.15-0.22-0.21-0.34c-0.41-0.27-0.42-0.31-0.03-0.12c0.47,0.23,0.86,0.6,1.27,0.92c0.42,0.32,0.88,0.56,1.37,0.76
					c0.36,0.15,0.51-0.43,0.16-0.58c-0.86-0.35-1.47-0.99-2.24-1.47c-0.31-0.19-0.99-0.6-1.22-0.09c-0.25,0.54,0.45,1.34,0.73,1.71
					c0.46,0.62,0.97,1.18,1.69,1.5C21.77,819.96,22.08,819.44,21.73,819.28L21.73,819.28z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M18.54,817.68c-0.05,0.69,0.59,1.31,0.96,1.83c0.37,0.52,0.86,0.87,1.26,1.36
					c0.24,0.3,0.67-0.13,0.42-0.42c-0.32-0.39-0.74-0.65-1.04-1.06c-0.3-0.42-1.04-1.16-1-1.7
					C19.17,817.29,18.57,817.29,18.54,817.68L18.54,817.68z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M14.24,816.71l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C15.46,815.66,15.02,816.48,14.24,816.71z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M8.75,815.93c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16c-0.03-0.1-0.05-0.19-0.08-0.29
					c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52c0.8-0.51,1.67-0.66,2.52-1.04
					c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C8.12,815.61,8.42,816.13,8.75,815.93L8.75,815.93z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M11.9,814.27c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11C11.78,814.94,12.2,814.52,11.9,814.27
					L11.9,814.27z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M32.8,824.36l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C34.02,823.31,33.58,824.13,32.8,824.36z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M27.31,823.58c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16c-0.03-0.1-0.05-0.19-0.08-0.29
					c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52c0.8-0.51,1.67-0.66,2.52-1.04
					c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C26.68,823.26,26.98,823.78,27.31,823.58L27.31,823.58z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M30.46,821.92c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C30.34,822.59,30.76,822.17,30.46,821.92L30.46,821.92z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="12.26,817.68 13.35,822.9 14.92,821.38 13.59,816.67 			"/>
		</g>
	</g>
	<g id="XMLID_50_">
		<g>
			<g>
				<polygon className="st24" points="27.78,816.57 28.24,818.67 23.75,817.96 23.58,816.28 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_49_">
		<g>
			<g>
				<polygon className="st24" points="32.01,812.71 32.47,814.81 27.98,814.1 27.81,812.43 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M34.17,827H9.36c-3.16,0-5.73-2.56-5.73-5.73v-8.49c0-3.16,2.56-5.73,5.73-5.73h24.81
				c3.16,0,5.73,2.56,5.73,5.73v8.49C39.89,824.44,37.33,827,34.17,827z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M37.5,809.44H5.88c-2.31,0-4.19-1.87-4.19-4.19v-2.24c0-0.22,0.18-0.4,0.4-0.4h38.79
				c0.22,0,0.4,0.18,0.4,0.4v2.65C41.28,807.75,39.59,809.44,37.5,809.44z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M-698.04,828.98h-28.81c-3.16,0-5.73-2.56-5.73-5.73v-13.5c0-3.16,2.56-5.73,5.73-5.73h28.81
				c3.16,0,5.73,2.56,5.73,5.73v13.5C-692.31,826.42-694.87,828.98-698.04,828.98z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-718.03,820.1l-2.87,2.81c-0.56,0.55-1.46,0.54-2.01-0.02l-1.08-1.11c-0.55-0.56-0.54-1.46,0.02-2.01
				l2.87-2.81c0.56-0.55,1.46-0.54,2.01,0.02l1.08,1.11C-717.46,818.65-717.47,819.55-718.03,820.1z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-706.39,815.61l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18c-0.78,0.09-1.48-0.47-1.57-1.25
				l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C-707.19,814.27-706.48,814.83-706.39,815.61z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-702.26,811.5l0.09,0.78l0.37,3.21c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18
				c-0.78,0.09-1.48-0.47-1.57-1.25l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18
				C-703.06,810.16-702.35,810.72-702.26,811.5z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M-697.33,814.86l-2.7,5.28c-0.36,0.7-1.21,0.97-1.91,0.62l-1.38-0.71c-0.7-0.36-0.97-1.21-0.62-1.91l2.7-5.28
				c0.36-0.7,1.21-0.97,1.91-0.62l1.38,0.71C-697.25,813.31-696.98,814.17-697.33,814.86z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-701.5,818.2c0.12-0.56,0.4-1.02,0.77-1.46c0.27-0.32,0.75-1.04,1.2-1.04c-0.09-0.05-0.17-0.1-0.26-0.15
					c0.2,0.28-0.49,1.31-0.62,1.58c-0.22,0.47-0.38,0.95-0.47,1.46c-0.07,0.38,0.51,0.54,0.58,0.16c0.16-0.85,0.58-1.54,0.9-2.33
					c0.13-0.33,0.48-1.18-0.09-1.32c-0.55-0.14-1.16,0.64-1.46,0.98c-0.51,0.58-0.96,1.19-1.13,1.95
					C-702.16,818.41-701.59,818.57-701.5,818.2L-701.5,818.2z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-700.58,814.87c-0.63,0.06-1,0.63-1.41,1.07c-0.22,0.23-0.46,0.46-0.65,0.72
					c-0.21,0.29-0.32,0.62-0.54,0.9c-0.24,0.3,0.18,0.73,0.42,0.42c0.3-0.37,0.46-0.82,0.77-1.17c0.18-0.2,0.37-0.4,0.55-0.6
					c0.19-0.2,0.54-0.71,0.84-0.74C-700.19,815.43-700.19,814.83-700.58,814.87L-700.58,814.87z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-715.04,814.32l4.78,3.87c0.63,0.51,0.73,1.44,0.22,2.08l-1.01,1.25c-0.51,0.63-1.44,0.73-2.07,0.22l-4.78-3.87
				c-0.63-0.51-0.73-1.44-0.22-2.07l1.01-1.25C-716.59,813.9-715.67,813.8-715.04,814.32z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-712.54,819.28c-0.52-0.23-0.92-0.6-1.28-1.04c-0.19-0.23-0.37-0.48-0.54-0.73
					c-0.08-0.11-0.15-0.22-0.21-0.34c-0.41-0.27-0.42-0.31-0.03-0.12c0.47,0.23,0.86,0.6,1.27,0.92c0.42,0.32,0.88,0.56,1.37,0.76
					c0.36,0.15,0.51-0.43,0.16-0.58c-0.86-0.35-1.47-0.99-2.24-1.47c-0.31-0.19-0.99-0.6-1.22-0.09c-0.25,0.54,0.45,1.34,0.73,1.71
					c0.46,0.62,0.97,1.18,1.69,1.5C-712.49,819.96-712.18,819.44-712.54,819.28L-712.54,819.28z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-715.72,817.68c-0.05,0.69,0.59,1.31,0.96,1.83c0.37,0.52,0.86,0.87,1.26,1.36
					c0.24,0.3,0.67-0.13,0.42-0.42c-0.32-0.39-0.74-0.65-1.04-1.06c-0.3-0.42-1.04-1.16-1-1.7
					C-715.09,817.29-715.69,817.29-715.72,817.68L-715.72,817.68z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-720.03,816.71l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C-718.8,815.66-719.24,816.48-720.03,816.71z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-725.51,815.93c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C-726.14,815.61-725.84,816.13-725.51,815.93L-725.51,815.93z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-722.36,814.27c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C-722.49,814.94-722.06,814.52-722.36,814.27L-722.36,814.27z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-701.46,824.36l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C-700.24,823.31-700.68,824.13-701.46,824.36z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-706.95,823.58c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C-707.58,823.26-707.28,823.78-706.95,823.58L-706.95,823.58z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-703.8,821.92c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C-703.93,822.59-703.5,822.17-703.8,821.92L-703.8,821.92z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="-722,817.68 -720.91,822.9 -719.35,821.38 -720.67,816.67 			"/>
		</g>
	</g>
	<g id="XMLID_108_">
		<g>
			<g>
				<polygon className="st24" points="-706.48,816.57 -706.02,818.67 -710.51,817.96 -710.68,816.28 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_107_">
		<g>
			<g>
				<polygon className="st24" points="-702.25,812.71 -701.79,814.81 -706.28,814.1 -706.45,812.43 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M-700.09,827h-24.81c-3.16,0-5.73-2.56-5.73-5.73v-8.49c0-3.16,2.56-5.73,5.73-5.73h24.81
				c3.16,0,5.73,2.56,5.73,5.73v8.49C-694.37,824.44-696.93,827-700.09,827z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M-696.76,809.44h-31.62c-2.31,0-4.19-1.87-4.19-4.19v-2.24c0-0.22,0.18-0.4,0.4-0.4h38.79
				c0.22,0,0.4,0.18,0.4,0.4v2.65C-692.98,807.75-694.67,809.44-696.76,809.44z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M-1233.34,1320.39v28.81c0,3.16-2.56,5.73-5.73,5.73h-13.5c-3.16,0-5.73-2.56-5.73-5.73v-28.81
				c0-3.16,2.56-5.73,5.73-5.73h13.5C-1235.91,1314.66-1233.34,1317.22-1233.34,1320.39z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-1242.23,1340.38l2.81,2.87c0.55,0.56,0.54,1.46-0.02,2.01l-1.11,1.08c-0.56,0.55-1.46,0.54-2.01-0.02
				l-2.81-2.87c-0.55-0.56-0.54-1.46,0.02-2.01l1.11-1.08C-1243.67,1339.81-1242.77,1339.82-1242.23,1340.38z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-1246.72,1328.74l3.99-0.46c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54c0.09,0.78-0.47,1.48-1.25,1.57
				l-3.99,0.46c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54C-1248.06,1329.54-1247.5,1328.83-1246.72,1328.74z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-1250.82,1324.61l0.78-0.09l3.21-0.37c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54
				c0.09,0.78-0.47,1.48-1.25,1.57l-3.99,0.46c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54
				C-1252.16,1325.4-1251.6,1324.7-1250.82,1324.61z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1247.46,1319.68l5.28,2.7c0.7,0.36,0.97,1.21,0.62,1.91l-0.71,1.38c-0.36,0.7-1.21,0.97-1.91,0.62l-5.28-2.7
				c-0.7-0.36-0.97-1.21-0.62-1.91l0.71-1.38C-1249.01,1319.6-1248.16,1319.33-1247.46,1319.68z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1244.13,1323.85c-0.56-0.12-1.02-0.4-1.46-0.77c-0.32-0.27-1.04-0.75-1.04-1.2
					c-0.05,0.09-0.1,0.17-0.15,0.26c0.28-0.2,1.31,0.49,1.58,0.62c0.47,0.22,0.95,0.38,1.46,0.47c0.38,0.07,0.54-0.51,0.16-0.58
					c-0.85-0.16-1.54-0.58-2.33-0.9c-0.33-0.13-1.18-0.48-1.32,0.09c-0.14,0.55,0.64,1.16,0.98,1.46c0.58,0.51,1.19,0.96,1.95,1.13
					C-1243.91,1324.51-1243.75,1323.94-1244.13,1323.85L-1244.13,1323.85z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1247.46,1322.92c0.06,0.63,0.63,1,1.07,1.41c0.23,0.22,0.46,0.46,0.72,0.65
					c0.29,0.21,0.62,0.32,0.9,0.54c0.3,0.24,0.73-0.18,0.42-0.42c-0.37-0.3-0.82-0.46-1.17-0.77c-0.2-0.18-0.4-0.37-0.6-0.55
					c-0.2-0.19-0.71-0.54-0.74-0.84C-1246.89,1322.54-1247.49,1322.54-1247.46,1322.92L-1247.46,1322.92z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1248.01,1337.39l3.87-4.78c0.51-0.63,1.44-0.73,2.07-0.22l1.25,1.01c0.63,0.51,0.73,1.44,0.22,2.07l-3.87,4.78
				c-0.51,0.63-1.44,0.73-2.07,0.22l-1.25-1.01C-1248.42,1338.94-1248.52,1338.02-1248.01,1337.39z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1243.04,1334.89c-0.23,0.52-0.6,0.92-1.04,1.28c-0.23,0.19-0.48,0.37-0.73,0.54
					c-0.11,0.08-0.22,0.15-0.34,0.21c-0.27,0.41-0.31,0.42-0.12,0.03c0.23-0.47,0.6-0.86,0.92-1.27c0.32-0.42,0.56-0.88,0.76-1.37
					c0.15-0.36-0.43-0.51-0.58-0.16c-0.35,0.86-0.99,1.47-1.47,2.24c-0.19,0.31-0.6,0.99-0.09,1.22c0.54,0.25,1.34-0.45,1.71-0.73
					c0.62-0.46,1.18-0.97,1.5-1.69C-1242.37,1334.84-1242.89,1334.53-1243.04,1334.89L-1243.04,1334.89z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1244.65,1338.07c0.69,0.05,1.31-0.59,1.83-0.96c0.52-0.37,0.87-0.86,1.36-1.26
					c0.3-0.24-0.13-0.67-0.42-0.42c-0.39,0.32-0.65,0.74-1.06,1.04c-0.42,0.3-1.16,1.04-1.7,1
					C-1245.03,1337.44-1245.03,1338.04-1244.65,1338.07L-1244.65,1338.07z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1245.61,1342.37l1.73,5.9c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46c-0.78,0.23-1.6-0.21-1.83-0.99l-1.73-5.9
				c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46C-1246.66,1341.15-1245.84,1341.59-1245.61,1342.37z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1246.39,1347.86c-0.3-0.49-0.41-1.02-0.45-1.59c-0.03-0.41-0.16-1.39,0.16-1.7
					c-0.1,0.03-0.19,0.05-0.29,0.08c0.34,0.06,0.56,1.31,0.66,1.63c0.17,0.52,0.4,0.99,0.69,1.45c0.21,0.32,0.73,0.02,0.52-0.3
					c-0.51-0.8-0.66-1.67-1.04-2.52c-0.15-0.34-0.46-1.04-0.94-0.78c-0.52,0.28-0.4,1.35-0.39,1.8c0.03,0.79,0.13,1.55,0.55,2.24
					C-1246.71,1348.49-1246.19,1348.19-1246.39,1347.86L-1246.39,1347.86z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1248.05,1344.71c-0.4,0.49-0.3,1.1-0.29,1.7c0,0.35-0.02,0.72,0.03,1.07c0.05,0.38,0.2,0.72,0.24,1.11
					c0.04,0.38,0.64,0.39,0.6,0c-0.05-0.53-0.25-1.02-0.26-1.56c-0.01-0.47-0.21-1.5,0.11-1.89
					C-1247.39,1344.84-1247.81,1344.41-1248.05,1344.71L-1248.05,1344.71z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1237.96,1323.81l1.73,5.9c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46c-0.78,0.23-1.6-0.21-1.83-0.99l-1.73-5.9
				c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46C-1239.01,1322.59-1238.19,1323.03-1237.96,1323.81z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1238.74,1329.3c-0.3-0.49-0.41-1.02-0.45-1.59c-0.03-0.41-0.16-1.39,0.16-1.7
					c-0.1,0.03-0.19,0.05-0.29,0.08c0.34,0.06,0.56,1.31,0.66,1.63c0.17,0.52,0.4,0.99,0.69,1.45c0.21,0.32,0.73,0.02,0.52-0.3
					c-0.51-0.8-0.66-1.67-1.04-2.52c-0.15-0.34-0.46-1.04-0.94-0.78c-0.52,0.28-0.4,1.35-0.39,1.8c0.03,0.79,0.13,1.55,0.55,2.24
					C-1239.06,1329.93-1238.54,1329.63-1238.74,1329.3L-1238.74,1329.3z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1240.4,1326.15c-0.4,0.49-0.3,1.1-0.29,1.7c0,0.35-0.02,0.72,0.03,1.07c0.05,0.38,0.2,0.72,0.24,1.11
					c0.04,0.38,0.64,0.39,0.6,0c-0.05-0.53-0.25-1.02-0.26-1.56c-0.01-0.47-0.21-1.5,0.11-1.89
					C-1239.74,1326.28-1240.16,1325.85-1240.4,1326.15L-1240.4,1326.15z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="-1244.65,1344.35 -1239.42,1343.26 -1240.95,1341.7 -1245.65,1343.02 			"/>
		</g>
	</g>
	<g id="XMLID_76_">
		<g>
			<g>
				<polygon className="st24" points="-1245.76,1328.83 -1243.66,1328.37 -1244.37,1332.86 -1246.04,1333.03 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_75_">
		<g>
			<g>
				<polygon className="st24" points="-1249.62,1324.6 -1247.51,1324.14 -1248.22,1328.63 -1249.9,1328.8 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M-1235.32,1322.44v24.81c0,3.16-2.56,5.73-5.73,5.73h-8.49c-3.16,0-5.73-2.56-5.73-5.73v-24.81
				c0-3.16,2.56-5.73,5.73-5.73h8.49C-1237.89,1316.72-1235.32,1319.28-1235.32,1322.44z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M-1252.89,1319.11v31.62c0,2.31-1.87,4.19-4.19,4.19h-2.24c-0.22,0-0.4-0.18-0.4-0.4v-38.79
				c0-0.22,0.18-0.4,0.4-0.4h2.65C-1254.58,1315.33-1252.89,1317.02-1252.89,1319.11z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M-1249.03,2102.59v28.81c0,3.16-2.56,5.73-5.73,5.73h-13.5c-3.16,0-5.73-2.56-5.73-5.73v-28.81
				c0-3.16,2.56-5.73,5.73-5.73h13.5C-1251.6,2096.86-1249.03,2099.43-1249.03,2102.59z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-1257.92,2122.59l2.81,2.87c0.55,0.56,0.54,1.46-0.02,2.01l-1.11,1.08c-0.56,0.55-1.46,0.54-2.01-0.02
				l-2.81-2.87c-0.55-0.56-0.54-1.46,0.02-2.01l1.11-1.08C-1259.36,2122.02-1258.46,2122.03-1257.92,2122.59z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-1262.41,2110.95l3.99-0.46c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54c0.09,0.78-0.47,1.48-1.25,1.57
				l-3.99,0.46c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54C-1263.75,2111.74-1263.19,2111.04-1262.41,2110.95z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-1266.51,2106.82l0.78-0.09l3.21-0.37c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54
				c0.09,0.78-0.47,1.48-1.25,1.57l-3.99,0.46c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54
				C-1267.85,2107.61-1267.29,2106.91-1266.51,2106.82z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1263.15,2101.89l5.28,2.7c0.7,0.36,0.97,1.21,0.62,1.91l-0.71,1.38c-0.36,0.7-1.21,0.97-1.91,0.62l-5.28-2.7
				c-0.7-0.36-0.97-1.21-0.62-1.91l0.71-1.38C-1264.7,2101.81-1263.85,2101.53-1263.15,2101.89z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1259.82,2106.06c-0.56-0.12-1.02-0.4-1.46-0.77c-0.32-0.27-1.04-0.75-1.04-1.2
					c-0.05,0.09-0.1,0.17-0.15,0.26c0.28-0.2,1.31,0.49,1.58,0.62c0.47,0.22,0.95,0.38,1.46,0.47c0.38,0.07,0.54-0.51,0.16-0.58
					c-0.85-0.16-1.54-0.58-2.33-0.9c-0.33-0.13-1.18-0.48-1.32,0.09c-0.14,0.55,0.64,1.16,0.98,1.46c0.58,0.51,1.19,0.96,1.95,1.13
					C-1259.6,2106.72-1259.44,2106.14-1259.82,2106.06L-1259.82,2106.06z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1263.15,2105.13c0.06,0.63,0.63,1,1.07,1.41c0.23,0.22,0.46,0.46,0.72,0.65
					c0.29,0.21,0.62,0.32,0.9,0.54c0.3,0.24,0.73-0.18,0.42-0.42c-0.37-0.3-0.82-0.46-1.17-0.77c-0.2-0.18-0.4-0.37-0.6-0.55
					c-0.2-0.19-0.71-0.54-0.74-0.84C-1262.58,2104.75-1263.18,2104.75-1263.15,2105.13L-1263.15,2105.13z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1263.7,2119.59l3.87-4.78c0.51-0.63,1.44-0.73,2.07-0.22l1.25,1.01c0.63,0.51,0.73,1.44,0.22,2.07l-3.87,4.78
				c-0.51,0.63-1.44,0.73-2.07,0.22l-1.25-1.01C-1264.11,2121.15-1264.21,2120.22-1263.7,2119.59z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1258.73,2117.09c-0.23,0.52-0.6,0.92-1.04,1.28c-0.23,0.19-0.48,0.37-0.73,0.54
					c-0.11,0.08-0.22,0.15-0.34,0.21c-0.27,0.41-0.31,0.42-0.12,0.03c0.23-0.47,0.6-0.86,0.92-1.27c0.32-0.42,0.56-0.88,0.76-1.37
					c0.15-0.36-0.43-0.51-0.58-0.16c-0.35,0.86-0.99,1.47-1.47,2.24c-0.19,0.31-0.6,0.99-0.09,1.22c0.54,0.25,1.34-0.45,1.71-0.73
					c0.62-0.46,1.18-0.97,1.5-1.69C-1258.06,2117.04-1258.58,2116.74-1258.73,2117.09L-1258.73,2117.09z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1260.34,2120.27c0.69,0.05,1.31-0.59,1.83-0.96c0.52-0.37,0.87-0.86,1.36-1.26
					c0.3-0.24-0.13-0.67-0.42-0.42c-0.39,0.32-0.65,0.74-1.06,1.04c-0.42,0.3-1.16,1.04-1.7,1
					C-1260.72,2119.64-1260.72,2120.24-1260.34,2120.27L-1260.34,2120.27z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1261.3,2124.58l1.73,5.9c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46c-0.78,0.23-1.6-0.21-1.83-0.99l-1.73-5.9
				c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46C-1262.35,2123.35-1261.53,2123.8-1261.3,2124.58z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1262.08,2130.06c-0.3-0.49-0.41-1.02-0.45-1.59c-0.03-0.41-0.16-1.39,0.16-1.7
					c-0.1,0.03-0.19,0.05-0.29,0.08c0.34,0.06,0.56,1.31,0.66,1.63c0.17,0.52,0.4,0.99,0.69,1.45c0.21,0.32,0.73,0.02,0.52-0.3
					c-0.51-0.8-0.66-1.67-1.04-2.52c-0.15-0.34-0.46-1.04-0.94-0.78c-0.52,0.28-0.4,1.35-0.39,1.8c0.03,0.79,0.13,1.55,0.55,2.24
					C-1262.4,2130.7-1261.88,2130.4-1262.08,2130.06L-1262.08,2130.06z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1263.74,2126.92c-0.4,0.49-0.3,1.1-0.29,1.7c0,0.35-0.02,0.72,0.03,1.07c0.05,0.38,0.2,0.72,0.24,1.11
					c0.03,0.38,0.64,0.39,0.6,0c-0.05-0.53-0.25-1.02-0.26-1.56c-0.01-0.47-0.21-1.5,0.11-1.89
					C-1263.08,2127.04-1263.5,2126.61-1263.74,2126.92L-1263.74,2126.92z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1253.65,2106.02l1.73,5.9c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46c-0.78,0.23-1.6-0.21-1.83-0.99l-1.73-5.9
				c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46C-1254.7,2104.79-1253.88,2105.24-1253.65,2106.02z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1254.43,2111.5c-0.3-0.49-0.41-1.02-0.45-1.59c-0.03-0.41-0.16-1.39,0.16-1.7
					c-0.1,0.03-0.19,0.05-0.29,0.08c0.34,0.06,0.56,1.31,0.66,1.63c0.17,0.52,0.4,0.99,0.69,1.45c0.21,0.32,0.73,0.02,0.52-0.3
					c-0.51-0.8-0.66-1.67-1.04-2.52c-0.15-0.34-0.46-1.04-0.94-0.78c-0.52,0.28-0.4,1.35-0.39,1.8c0.03,0.79,0.13,1.55,0.55,2.24
					C-1254.75,2112.14-1254.23,2111.83-1254.43,2111.5L-1254.43,2111.5z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1256.09,2108.35c-0.4,0.49-0.3,1.1-0.29,1.7c0,0.35-0.02,0.72,0.03,1.07c0.05,0.38,0.2,0.72,0.24,1.11
					c0.03,0.38,0.64,0.39,0.6,0c-0.05-0.53-0.25-1.02-0.26-1.56c-0.01-0.47-0.21-1.5,0.11-1.89
					C-1255.43,2108.48-1255.85,2108.05-1256.09,2108.35L-1256.09,2108.35z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="-1260.34,2126.56 -1255.11,2125.46 -1256.64,2123.9 -1261.34,2125.23 			"/>
		</g>
	</g>
	<g id="XMLID_48_">
		<g>
			<g>
				<polygon className="st24" points="-1261.45,2111.04 -1259.35,2110.57 -1260.06,2115.07 -1261.73,2115.23 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_47_">
		<g>
			<g>
				<polygon className="st24" points="-1265.31,2106.81 -1263.2,2106.35 -1263.91,2110.84 -1265.59,2111 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M-1251.01,2104.65v24.81c0,3.16-2.56,5.73-5.73,5.73h-8.49c-3.16,0-5.73-2.56-5.73-5.73v-24.81
				c0-3.16,2.56-5.73,5.73-5.73h8.49C-1253.58,2098.92-1251.01,2101.49-1251.01,2104.65z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M-1268.58,2101.32v31.62c0,2.31-1.87,4.19-4.19,4.19h-2.24c-0.22,0-0.4-0.18-0.4-0.4v-38.79
				c0-0.22,0.18-0.4,0.4-0.4h2.65C-1270.27,2097.54-1268.58,2099.23-1268.58,2101.32z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M-1249.03,1715.2V1744c0,3.16-2.56,5.73-5.73,5.73h-13.5c-3.16,0-5.73-2.56-5.73-5.73v-28.81
				c0-3.16,2.56-5.73,5.73-5.73h13.5C-1251.6,1709.47-1249.03,1712.03-1249.03,1715.2z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-1257.92,1735.2l2.81,2.87c0.55,0.56,0.54,1.46-0.02,2.01l-1.11,1.08c-0.56,0.55-1.46,0.54-2.01-0.02
				l-2.81-2.87c-0.55-0.56-0.54-1.46,0.02-2.01l1.11-1.08C-1259.36,1734.62-1258.46,1734.63-1257.92,1735.2z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-1262.41,1723.55l3.99-0.46c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54c0.09,0.78-0.47,1.48-1.25,1.57
				l-3.99,0.46c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54C-1263.75,1724.35-1263.19,1723.64-1262.41,1723.55z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M-1266.51,1719.42l0.78-0.09l3.21-0.37c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54
				c0.09,0.78-0.47,1.48-1.25,1.57l-3.99,0.46c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54
				C-1267.85,1720.22-1267.29,1719.51-1266.51,1719.42z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1263.15,1714.5l5.28,2.7c0.7,0.36,0.97,1.21,0.62,1.91l-0.71,1.38c-0.36,0.7-1.21,0.97-1.91,0.62l-5.28-2.7
				c-0.7-0.36-0.97-1.21-0.62-1.91l0.71-1.38C-1264.7,1714.41-1263.85,1714.14-1263.15,1714.5z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1259.82,1718.67c-0.56-0.12-1.02-0.4-1.46-0.77c-0.32-0.27-1.04-0.75-1.04-1.2
					c-0.05,0.09-0.1,0.17-0.15,0.26c0.28-0.2,1.31,0.49,1.58,0.62c0.47,0.22,0.95,0.38,1.46,0.47c0.38,0.07,0.54-0.51,0.16-0.58
					c-0.85-0.16-1.54-0.58-2.33-0.9c-0.33-0.13-1.18-0.48-1.32,0.09c-0.14,0.55,0.64,1.16,0.98,1.46c0.58,0.51,1.19,0.96,1.95,1.13
					C-1259.6,1719.33-1259.44,1718.75-1259.82,1718.67L-1259.82,1718.67z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1263.15,1717.74c0.06,0.63,0.63,1,1.07,1.41c0.23,0.22,0.46,0.46,0.72,0.65
					c0.29,0.21,0.62,0.32,0.9,0.54c0.3,0.24,0.73-0.18,0.42-0.42c-0.37-0.3-0.82-0.46-1.17-0.77c-0.2-0.18-0.4-0.37-0.6-0.55
					c-0.2-0.19-0.71-0.54-0.74-0.84C-1262.58,1717.35-1263.18,1717.35-1263.15,1717.74L-1263.15,1717.74z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1263.7,1732.2l3.87-4.78c0.51-0.63,1.44-0.73,2.07-0.22l1.25,1.01c0.63,0.51,0.73,1.44,0.22,2.07l-3.87,4.78
				c-0.51,0.63-1.44,0.73-2.07,0.22l-1.25-1.01C-1264.11,1733.75-1264.21,1732.83-1263.7,1732.2z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1258.73,1729.7c-0.23,0.52-0.6,0.92-1.04,1.28c-0.23,0.19-0.48,0.37-0.73,0.54
					c-0.11,0.08-0.22,0.15-0.34,0.21c-0.27,0.41-0.31,0.42-0.12,0.03c0.23-0.47,0.6-0.86,0.92-1.27c0.32-0.42,0.56-0.88,0.76-1.37
					c0.15-0.36-0.43-0.51-0.58-0.16c-0.35,0.86-0.99,1.47-1.47,2.24c-0.19,0.31-0.6,0.99-0.09,1.22c0.54,0.25,1.34-0.45,1.71-0.73
					c0.62-0.46,1.18-0.97,1.5-1.69C-1258.06,1729.65-1258.58,1729.34-1258.73,1729.7L-1258.73,1729.7z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1260.34,1732.88c0.69,0.05,1.31-0.59,1.83-0.96c0.52-0.37,0.87-0.86,1.36-1.26
					c0.3-0.24-0.13-0.67-0.42-0.42c-0.39,0.32-0.65,0.74-1.06,1.04c-0.42,0.3-1.16,1.04-1.7,1
					C-1260.72,1732.25-1260.72,1732.85-1260.34,1732.88L-1260.34,1732.88z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1261.3,1737.19l1.73,5.9c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46c-0.78,0.23-1.6-0.21-1.83-0.99l-1.73-5.9
				c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46C-1262.35,1735.96-1261.53,1736.41-1261.3,1737.19z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1262.08,1742.67c-0.3-0.49-0.41-1.02-0.45-1.59c-0.03-0.41-0.16-1.39,0.16-1.7
					c-0.1,0.03-0.19,0.05-0.29,0.08c0.34,0.06,0.56,1.31,0.66,1.63c0.17,0.52,0.4,0.99,0.69,1.45c0.21,0.32,0.73,0.02,0.52-0.3
					c-0.51-0.8-0.66-1.67-1.04-2.52c-0.15-0.34-0.46-1.04-0.94-0.78c-0.52,0.28-0.4,1.35-0.39,1.8c0.03,0.79,0.13,1.55,0.55,2.24
					C-1262.4,1743.3-1261.88,1743-1262.08,1742.67L-1262.08,1742.67z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1263.74,1739.52c-0.4,0.49-0.3,1.1-0.29,1.7c0,0.35-0.02,0.72,0.03,1.07c0.05,0.38,0.2,0.72,0.24,1.11
					c0.03,0.38,0.64,0.39,0.6,0c-0.05-0.53-0.25-1.02-0.26-1.56c-0.01-0.47-0.21-1.5,0.11-1.89
					C-1263.08,1739.65-1263.5,1739.22-1263.74,1739.52L-1263.74,1739.52z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M-1253.65,1718.63l1.73,5.9c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46c-0.78,0.23-1.6-0.21-1.83-0.99l-1.73-5.9
				c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46C-1254.7,1717.4-1253.88,1717.84-1253.65,1718.63z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1254.43,1724.11c-0.3-0.49-0.41-1.02-0.45-1.59c-0.03-0.41-0.16-1.39,0.16-1.7
					c-0.1,0.03-0.19,0.05-0.29,0.08c0.34,0.06,0.56,1.31,0.66,1.63c0.17,0.52,0.4,0.99,0.69,1.45c0.21,0.32,0.73,0.02,0.52-0.3
					c-0.51-0.8-0.66-1.67-1.04-2.52c-0.15-0.34-0.46-1.04-0.94-0.78c-0.52,0.28-0.4,1.35-0.39,1.8c0.03,0.79,0.13,1.55,0.55,2.24
					C-1254.75,1724.74-1254.23,1724.44-1254.43,1724.11L-1254.43,1724.11z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M-1256.09,1720.96c-0.4,0.49-0.3,1.1-0.29,1.7c0,0.35-0.02,0.72,0.03,1.07c0.05,0.38,0.2,0.72,0.24,1.11
					c0.03,0.38,0.64,0.39,0.6,0c-0.05-0.53-0.25-1.02-0.26-1.56c-0.01-0.47-0.21-1.5,0.11-1.89
					C-1255.43,1721.09-1255.85,1720.66-1256.09,1720.96L-1256.09,1720.96z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="-1260.34,1739.16 -1255.11,1738.07 -1256.64,1736.51 -1261.34,1737.83 			"/>
		</g>
	</g>
	<g id="XMLID_52_">
		<g>
			<g>
				<polygon className="st24" points="-1261.45,1723.64 -1259.35,1723.18 -1260.06,1727.67 -1261.73,1727.84 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_51_">
		<g>
			<g>
				<polygon className="st24" points="-1265.31,1719.41 -1263.2,1718.95 -1263.91,1723.44 -1265.59,1723.61 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M-1251.01,1717.26v24.81c0,3.16-2.56,5.73-5.73,5.73h-8.49c-3.16,0-5.73-2.56-5.73-5.73v-24.81
				c0-3.16,2.56-5.73,5.73-5.73h8.49C-1253.58,1711.53-1251.01,1714.09-1251.01,1717.26z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M-1268.58,1713.92v31.62c0,2.31-1.87,4.19-4.19,4.19h-2.24c-0.22,0-0.4-0.18-0.4-0.4v-38.79
				c0-0.22,0.18-0.4,0.4-0.4h2.65C-1270.27,1710.14-1268.58,1711.83-1268.58,1713.92z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M1168.01,2440.52v-28.81c0-3.16,2.56-5.73,5.73-5.73h13.5c3.16,0,5.73,2.56,5.73,5.73v28.81
				c0,3.16-2.56,5.73-5.73,5.73h-13.5C1170.57,2446.24,1168.01,2443.68,1168.01,2440.52z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1176.89,2420.52l-2.81-2.87c-0.55-0.56-0.54-1.46,0.02-2.01l1.11-1.08c0.56-0.55,1.46-0.54,2.01,0.02
				l2.81,2.87c0.55,0.56,0.54,1.46-0.02,2.01l-1.11,1.08C1178.34,2421.09,1177.44,2421.08,1176.89,2420.52z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1181.38,2432.16l-3.99,0.46c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54c-0.09-0.78,0.47-1.48,1.25-1.57
				l3.99-0.46c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54C1182.72,2431.37,1182.16,2432.07,1181.38,2432.16z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1185.49,2436.29l-0.78,0.09l-3.21,0.37c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54
				c-0.09-0.78,0.47-1.48,1.25-1.57l3.99-0.46c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54
				C1186.83,2435.5,1186.27,2436.2,1185.49,2436.29z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M1182.13,2441.22l-5.28-2.7c-0.7-0.36-0.97-1.21-0.62-1.91l0.71-1.38c0.36-0.7,1.21-0.97,1.91-0.62l5.28,2.7
				c0.7,0.36,0.97,1.21,0.62,1.91l-0.71,1.38C1183.68,2441.3,1182.83,2441.58,1182.13,2441.22z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1178.8,2437.05c0.56,0.12,1.02,0.4,1.46,0.77c0.32,0.27,1.04,0.75,1.04,1.2c0.05-0.09,0.1-0.17,0.15-0.26
					c-0.28,0.2-1.31-0.49-1.58-0.62c-0.47-0.22-0.95-0.38-1.46-0.47c-0.38-0.07-0.54,0.51-0.16,0.58c0.85,0.16,1.54,0.58,2.33,0.9
					c0.33,0.13,1.18,0.48,1.32-0.09c0.14-0.55-0.64-1.16-0.98-1.46c-0.58-0.51-1.19-0.96-1.95-1.13
					C1178.58,2436.39,1178.42,2436.97,1178.8,2437.05L1178.8,2437.05z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1182.12,2437.98c-0.06-0.63-0.63-1-1.07-1.41c-0.23-0.22-0.46-0.46-0.72-0.65
					c-0.29-0.21-0.62-0.32-0.9-0.54c-0.3-0.24-0.73,0.18-0.42,0.42c0.37,0.3,0.82,0.46,1.17,0.77c0.2,0.18,0.4,0.37,0.6,0.55
					c0.2,0.19,0.71,0.54,0.74,0.84C1181.56,2438.36,1182.16,2438.36,1182.12,2437.98L1182.12,2437.98z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1182.68,2423.52l-3.87,4.78c-0.51,0.63-1.44,0.73-2.07,0.22l-1.25-1.01c-0.63-0.51-0.73-1.44-0.22-2.07l3.87-4.78
				c0.51-0.63,1.44-0.73,2.07-0.22l1.25,1.01C1183.09,2421.96,1183.19,2422.89,1182.68,2423.52z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1177.71,2426.02c0.23-0.52,0.6-0.92,1.04-1.28c0.23-0.19,0.48-0.37,0.73-0.54
					c0.11-0.08,0.22-0.15,0.34-0.21c0.27-0.41,0.31-0.42,0.12-0.03c-0.23,0.47-0.6,0.86-0.92,1.27c-0.32,0.42-0.56,0.88-0.76,1.37
					c-0.15,0.36,0.43,0.51,0.58,0.16c0.35-0.86,0.99-1.47,1.47-2.24c0.19-0.31,0.6-0.99,0.09-1.22c-0.54-0.25-1.34,0.45-1.71,0.73
					c-0.62,0.46-1.18,0.97-1.5,1.69C1177.04,2426.06,1177.55,2426.37,1177.71,2426.02L1177.71,2426.02z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1179.32,2422.84c-0.69-0.05-1.31,0.59-1.83,0.96c-0.52,0.37-0.87,0.86-1.36,1.26
					c-0.3,0.24,0.13,0.67,0.42,0.42c0.39-0.32,0.65-0.74,1.06-1.04c0.42-0.3,1.16-1.04,1.7-1
					C1179.7,2423.47,1179.7,2422.86,1179.32,2422.84L1179.32,2422.84z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1180.28,2418.53l-1.73-5.9c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46c0.78-0.23,1.6,0.21,1.83,0.99l1.73,5.9
				c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46C1181.33,2419.75,1180.51,2419.31,1180.28,2418.53z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1181.06,2413.05c0.3,0.49,0.41,1.02,0.45,1.59c0.03,0.41,0.16,1.39-0.16,1.7
					c0.1-0.03,0.19-0.05,0.29-0.08c-0.34-0.06-0.56-1.31-0.66-1.63c-0.17-0.52-0.4-0.99-0.69-1.45c-0.21-0.32-0.73-0.02-0.52,0.3
					c0.51,0.8,0.66,1.67,1.04,2.52c0.15,0.34,0.46,1.04,0.94,0.78c0.52-0.28,0.4-1.35,0.39-1.8c-0.03-0.79-0.13-1.55-0.55-2.24
					C1181.38,2412.41,1180.86,2412.71,1181.06,2413.05L1181.06,2413.05z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1182.72,2416.19c0.4-0.49,0.3-1.1,0.29-1.7c0-0.35,0.02-0.72-0.03-1.07c-0.05-0.38-0.2-0.72-0.24-1.11
					c-0.03-0.38-0.64-0.39-0.6,0c0.05,0.53,0.25,1.02,0.26,1.56c0.01,0.47,0.21,1.5-0.11,1.89
					C1182.05,2416.07,1182.47,2416.49,1182.72,2416.19L1182.72,2416.19z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1172.63,2437.09l-1.73-5.9c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46c0.78-0.23,1.6,0.21,1.83,0.99l1.73,5.9
				c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46C1173.68,2438.31,1172.86,2437.87,1172.63,2437.09z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1173.41,2431.61c0.3,0.49,0.41,1.02,0.45,1.59c0.03,0.41,0.16,1.39-0.16,1.7
					c0.1-0.03,0.19-0.05,0.29-0.08c-0.34-0.06-0.56-1.31-0.66-1.63c-0.17-0.52-0.4-0.99-0.69-1.45c-0.21-0.32-0.73-0.02-0.52,0.3
					c0.51,0.8,0.66,1.67,1.04,2.52c0.15,0.34,0.46,1.04,0.94,0.78c0.52-0.28,0.4-1.35,0.39-1.8c-0.03-0.79-0.13-1.55-0.55-2.24
					C1173.73,2430.97,1173.21,2431.27,1173.41,2431.61L1173.41,2431.61z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1175.07,2434.75c0.4-0.49,0.3-1.1,0.29-1.7c0-0.35,0.02-0.72-0.03-1.07c-0.05-0.38-0.2-0.72-0.24-1.11
					c-0.03-0.38-0.64-0.39-0.6,0c0.05,0.53,0.25,1.02,0.26,1.56c0.01,0.47,0.21,1.5-0.11,1.89
					C1174.4,2434.63,1174.83,2435.05,1175.07,2434.75L1175.07,2434.75z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="1179.32,2416.55 1174.09,2417.64 1175.61,2419.21 1180.32,2417.88 			"/>
		</g>
	</g>
	<g id="XMLID_46_">
		<g>
			<g>
				<polygon className="st24" points="1180.43,2432.07 1178.32,2432.53 1179.03,2428.04 1180.71,2427.88 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_45_">
		<g>
			<g>
				<polygon className="st24" points="1184.28,2436.3 1182.18,2436.76 1182.89,2432.27 1184.56,2432.1 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M1169.99,2438.46v-24.81c0-3.16,2.56-5.73,5.73-5.73h8.49c3.16,0,5.73,2.56,5.73,5.73v24.81
				c0,3.16-2.56,5.73-5.73,5.73h-8.49C1172.55,2444.19,1169.99,2441.62,1169.99,2438.46z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M1187.55,2441.79v-31.62c0-2.31,1.87-4.19,4.19-4.19h2.24c0.22,0,0.4,0.18,0.4,0.4v38.79
				c0,0.22-0.18,0.4-0.4,0.4h-2.65C1189.25,2445.57,1187.55,2443.88,1187.55,2441.79z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M1168.01,1535.56v-28.81c0-3.16,2.56-5.73,5.73-5.73h13.5c3.16,0,5.73,2.56,5.73,5.73v28.81
				c0,3.16-2.56,5.73-5.73,5.73h-13.5C1170.57,1541.29,1168.01,1538.73,1168.01,1535.56z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1176.89,1515.57l-2.81-2.87c-0.55-0.56-0.54-1.46,0.02-2.01l1.11-1.08c0.56-0.55,1.46-0.54,2.01,0.02
				l2.81,2.87c0.55,0.56,0.54,1.46-0.02,2.01l-1.11,1.08C1178.34,1516.14,1177.44,1516.13,1176.89,1515.57z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1181.38,1527.21l-3.99,0.46c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54c-0.09-0.78,0.47-1.48,1.25-1.57
				l3.99-0.46c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54C1182.72,1526.41,1182.16,1527.12,1181.38,1527.21z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1185.49,1531.34l-0.78,0.09l-3.21,0.37c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54
				c-0.09-0.78,0.47-1.48,1.25-1.57l3.99-0.46c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54
				C1186.83,1530.55,1186.27,1531.25,1185.49,1531.34z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M1182.13,1536.27l-5.28-2.7c-0.7-0.36-0.97-1.21-0.62-1.91l0.71-1.38c0.36-0.7,1.21-0.97,1.91-0.62l5.28,2.7
				c0.7,0.36,0.97,1.21,0.62,1.91l-0.71,1.38C1183.68,1536.35,1182.83,1536.62,1182.13,1536.27z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1178.8,1532.1c0.56,0.12,1.02,0.4,1.46,0.77c0.32,0.27,1.04,0.75,1.04,1.2c0.05-0.09,0.1-0.17,0.15-0.26
					c-0.28,0.2-1.31-0.49-1.58-0.62c-0.47-0.22-0.95-0.38-1.46-0.47c-0.38-0.07-0.54,0.51-0.16,0.58c0.85,0.16,1.54,0.58,2.33,0.9
					c0.33,0.13,1.18,0.48,1.32-0.09c0.14-0.55-0.64-1.16-0.98-1.46c-0.58-0.51-1.19-0.96-1.95-1.13
					C1178.58,1531.44,1178.42,1532.01,1178.8,1532.1L1178.8,1532.1z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1182.12,1533.03c-0.06-0.63-0.63-1-1.07-1.41c-0.23-0.22-0.46-0.46-0.72-0.65
					c-0.29-0.21-0.62-0.32-0.9-0.54c-0.3-0.24-0.73,0.18-0.42,0.42c0.37,0.3,0.82,0.46,1.17,0.77c0.2,0.18,0.4,0.37,0.6,0.55
					c0.2,0.19,0.71,0.54,0.74,0.84C1181.56,1533.41,1182.16,1533.41,1182.12,1533.03L1182.12,1533.03z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1182.68,1518.57l-3.87,4.78c-0.51,0.63-1.44,0.73-2.07,0.22l-1.25-1.01c-0.63-0.51-0.73-1.44-0.22-2.07l3.87-4.78
				c0.51-0.63,1.44-0.73,2.07-0.22l1.25,1.01C1183.09,1517.01,1183.19,1517.93,1182.68,1518.57z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1177.71,1521.06c0.23-0.52,0.6-0.92,1.04-1.28c0.23-0.19,0.48-0.37,0.73-0.54
					c0.11-0.08,0.22-0.15,0.34-0.21c0.27-0.41,0.31-0.42,0.12-0.03c-0.23,0.47-0.6,0.86-0.92,1.27c-0.32,0.42-0.56,0.88-0.76,1.37
					c-0.15,0.36,0.43,0.51,0.58,0.16c0.35-0.86,0.99-1.47,1.47-2.24c0.19-0.31,0.6-0.99,0.09-1.22c-0.54-0.25-1.34,0.45-1.71,0.73
					c-0.62,0.46-1.18,0.97-1.5,1.69C1177.04,1521.11,1177.55,1521.42,1177.71,1521.06L1177.71,1521.06z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1179.32,1517.88c-0.69-0.05-1.31,0.59-1.83,0.96c-0.52,0.37-0.87,0.86-1.36,1.26
					c-0.3,0.24,0.13,0.67,0.42,0.42c0.39-0.32,0.65-0.74,1.06-1.04c0.42-0.3,1.16-1.04,1.7-1
					C1179.7,1518.51,1179.7,1517.91,1179.32,1517.88L1179.32,1517.88z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1180.28,1513.58l-1.73-5.9c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46c0.78-0.23,1.6,0.21,1.83,0.99l1.73,5.9
				c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46C1181.33,1514.8,1180.51,1514.36,1180.28,1513.58z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1181.06,1508.09c0.3,0.49,0.41,1.02,0.45,1.59c0.03,0.41,0.16,1.39-0.16,1.7
					c0.1-0.03,0.19-0.05,0.29-0.08c-0.34-0.06-0.56-1.31-0.66-1.63c-0.17-0.52-0.4-0.99-0.69-1.45c-0.21-0.32-0.73-0.02-0.52,0.3
					c0.51,0.8,0.66,1.67,1.04,2.52c0.15,0.34,0.46,1.04,0.94,0.78c0.52-0.28,0.4-1.35,0.39-1.8c-0.03-0.79-0.13-1.55-0.55-2.24
					C1181.38,1507.46,1180.86,1507.76,1181.06,1508.09L1181.06,1508.09z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1182.72,1511.24c0.4-0.49,0.3-1.1,0.29-1.7c0-0.35,0.02-0.72-0.03-1.07c-0.05-0.38-0.2-0.72-0.24-1.11
					c-0.03-0.38-0.64-0.39-0.6,0c0.05,0.53,0.25,1.02,0.26,1.56c0.01,0.47,0.21,1.5-0.11,1.89
					C1182.05,1511.11,1182.47,1511.54,1182.72,1511.24L1182.72,1511.24z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1172.63,1532.14l-1.73-5.9c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46c0.78-0.23,1.6,0.21,1.83,0.99l1.73,5.9
				c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46C1173.68,1533.36,1172.86,1532.92,1172.63,1532.14z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1173.41,1526.65c0.3,0.49,0.41,1.02,0.45,1.59c0.03,0.41,0.16,1.39-0.16,1.7
					c0.1-0.03,0.19-0.05,0.29-0.08c-0.34-0.06-0.56-1.31-0.66-1.63c-0.17-0.52-0.4-0.99-0.69-1.45c-0.21-0.32-0.73-0.02-0.52,0.3
					c0.51,0.8,0.66,1.67,1.04,2.52c0.15,0.34,0.46,1.04,0.94,0.78c0.52-0.28,0.4-1.35,0.39-1.8c-0.03-0.79-0.13-1.55-0.55-2.24
					C1173.73,1526.02,1173.21,1526.32,1173.41,1526.65L1173.41,1526.65z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1175.07,1529.8c0.4-0.49,0.3-1.1,0.29-1.7c0-0.35,0.02-0.72-0.03-1.07c-0.05-0.38-0.2-0.72-0.24-1.11
					c-0.03-0.38-0.64-0.39-0.6,0c0.05,0.53,0.25,1.02,0.26,1.56c0.01,0.47,0.21,1.5-0.11,1.89
					C1174.4,1529.68,1174.83,1530.1,1175.07,1529.8L1175.07,1529.8z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="1179.32,1511.6 1174.09,1512.69 1175.61,1514.26 1180.32,1512.93 			"/>
		</g>
	</g>
	<g id="XMLID_212_">
		<g>
			<g>
				<polygon className="st24" points="1180.43,1527.12 1178.32,1527.58 1179.03,1523.09 1180.71,1522.92 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_211_">
		<g>
			<g>
				<polygon className="st24" points="1184.28,1531.35 1182.18,1531.81 1182.89,1527.32 1184.56,1527.15 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M1169.99,1533.51v-24.81c0-3.16,2.56-5.73,5.73-5.73h8.49c3.16,0,5.73,2.56,5.73,5.73v24.81
				c0,3.16-2.56,5.73-5.73,5.73h-8.49C1172.55,1539.23,1169.99,1536.67,1169.99,1533.51z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M1187.55,1536.84v-31.62c0-2.31,1.87-4.19,4.19-4.19h2.24c0.22,0,0.4,0.18,0.4,0.4v38.79
				c0,0.22-0.18,0.4-0.4,0.4h-2.65C1189.25,1540.62,1187.55,1538.93,1187.55,1536.84z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M1967.81,822.07H1939c-3.16,0-5.73-2.56-5.73-5.73v-13.5c0-3.16,2.56-5.73,5.73-5.73h28.81
				c3.16,0,5.73,2.56,5.73,5.73v13.5C1973.54,819.51,1970.97,822.07,1967.81,822.07z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1947.81,813.19l-2.87,2.81c-0.56,0.55-1.46,0.54-2.01-0.02l-1.08-1.11c-0.55-0.56-0.54-1.46,0.02-2.01
				l2.87-2.81c0.56-0.55,1.46-0.54,2.01,0.02l1.08,1.11C1948.38,811.74,1948.37,812.64,1947.81,813.19z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1959.45,808.69l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18c-0.78,0.09-1.48-0.47-1.57-1.25
				l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C1958.66,807.36,1959.36,807.92,1959.45,808.69z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1963.58,804.59l0.09,0.78l0.37,3.21c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18
				c-0.78,0.09-1.48-0.47-1.57-1.25l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18
				C1962.79,803.25,1963.49,803.81,1963.58,804.59z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M1968.51,807.95l-2.7,5.28c-0.36,0.7-1.21,0.97-1.91,0.62l-1.38-0.71c-0.7-0.36-0.97-1.21-0.62-1.91l2.7-5.28
				c0.36-0.7,1.21-0.97,1.91-0.62l1.38,0.71C1968.59,806.4,1968.87,807.25,1968.51,807.95z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1964.34,811.28c0.12-0.56,0.4-1.02,0.77-1.46c0.27-0.32,0.75-1.04,1.2-1.04
					c-0.09-0.05-0.17-0.1-0.26-0.15c0.2,0.28-0.49,1.31-0.62,1.58c-0.22,0.47-0.38,0.95-0.47,1.46c-0.07,0.38,0.51,0.54,0.58,0.16
					c0.16-0.85,0.58-1.54,0.9-2.33c0.13-0.33,0.48-1.18-0.09-1.32c-0.55-0.14-1.16,0.64-1.46,0.98c-0.51,0.58-0.96,1.19-1.13,1.95
					C1963.68,811.5,1964.26,811.66,1964.34,811.28L1964.34,811.28z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1965.27,807.96c-0.63,0.06-1,0.63-1.41,1.07c-0.22,0.23-0.46,0.46-0.65,0.72
					c-0.21,0.29-0.32,0.62-0.54,0.9c-0.24,0.3,0.18,0.73,0.42,0.42c0.3-0.37,0.46-0.82,0.77-1.17c0.18-0.2,0.37-0.4,0.55-0.6
					c0.19-0.2,0.54-0.71,0.84-0.74C1965.65,808.52,1965.66,807.92,1965.27,807.96L1965.27,807.96z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1950.81,807.4l4.78,3.87c0.63,0.51,0.73,1.44,0.22,2.08l-1.01,1.25c-0.51,0.63-1.44,0.73-2.07,0.22l-4.78-3.87
				c-0.63-0.51-0.73-1.44-0.22-2.08l1.01-1.25C1949.25,806.99,1950.18,806.89,1950.81,807.4z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1953.31,812.37c-0.52-0.23-0.92-0.6-1.28-1.04c-0.19-0.23-0.37-0.48-0.54-0.73
					c-0.08-0.11-0.15-0.22-0.21-0.34c-0.41-0.27-0.42-0.31-0.03-0.12c0.47,0.23,0.86,0.6,1.27,0.92c0.42,0.32,0.88,0.56,1.37,0.76
					c0.36,0.15,0.51-0.43,0.16-0.58c-0.86-0.35-1.47-0.99-2.24-1.47c-0.31-0.19-0.99-0.6-1.22-0.09c-0.25,0.54,0.45,1.34,0.73,1.71
					c0.46,0.62,0.97,1.18,1.69,1.5C1953.36,813.04,1953.66,812.53,1953.31,812.37L1953.31,812.37z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1950.13,810.76c-0.05,0.69,0.59,1.31,0.96,1.83c0.37,0.52,0.86,0.87,1.26,1.36
					c0.24,0.3,0.67-0.13,0.42-0.42c-0.32-0.39-0.74-0.65-1.04-1.06c-0.3-0.42-1.04-1.16-1-1.7
					C1950.76,810.38,1950.16,810.38,1950.13,810.76L1950.13,810.76z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1945.82,809.8l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C1947.05,808.75,1946.6,809.57,1945.82,809.8z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1940.34,809.02c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C1939.7,808.7,1940.01,809.22,1940.34,809.02L1940.34,809.02z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1943.49,807.36c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C1943.36,808.03,1943.79,807.61,1943.49,807.36L1943.49,807.36z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1964.38,817.45l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C1965.61,816.4,1965.16,817.22,1964.38,817.45z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1958.9,816.67c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16c-0.03-0.1-0.05-0.19-0.08-0.29
					c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52c0.8-0.51,1.67-0.66,2.52-1.04
					c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C1958.27,816.35,1958.57,816.87,1958.9,816.67L1958.9,816.67z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1962.05,815.01c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C1961.92,815.68,1962.35,815.25,1962.05,815.01L1962.05,815.01z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="1943.85,810.76 1944.94,815.99 1946.5,814.47 1945.17,809.76 			"/>
		</g>
	</g>
	<g id="XMLID_31_">
		<g>
			<g>
				<polygon className="st24" points="1959.36,809.65 1959.83,811.76 1955.33,811.05 1955.17,809.37 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_30_">
		<g>
			<g>
				<polygon className="st24" points="1963.59,805.8 1964.05,807.9 1959.56,807.19 1959.4,805.51 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M1965.75,820.09h-24.81c-3.16,0-5.73-2.56-5.73-5.73v-8.49c0-3.16,2.56-5.73,5.73-5.73h24.81
				c3.16,0,5.73,2.56,5.73,5.73v8.49C1971.48,817.53,1968.91,820.09,1965.75,820.09z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M1969.09,802.53h-31.62c-2.31,0-4.19-1.87-4.19-4.19v-2.24c0-0.22,0.18-0.4,0.4-0.4h38.79
				c0.22,0,0.4,0.18,0.4,0.4v2.65C1972.86,800.83,1971.17,802.53,1969.09,802.53z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M2732.43,822.07h-28.81c-3.16,0-5.73-2.56-5.73-5.73v-13.5c0-3.16,2.56-5.73,5.73-5.73h28.81
				c3.16,0,5.73,2.56,5.73,5.73v13.5C2738.16,819.51,2735.6,822.07,2732.43,822.07z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2712.44,813.19l-2.87,2.81c-0.56,0.55-1.46,0.54-2.01-0.02l-1.08-1.11c-0.55-0.56-0.54-1.46,0.02-2.01
				l2.87-2.81c0.56-0.55,1.46-0.54,2.01,0.02l1.08,1.11C2713.01,811.74,2713,812.64,2712.44,813.19z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2724.08,808.69l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18c-0.78,0.09-1.48-0.47-1.57-1.25
				l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C2723.28,807.36,2723.99,807.92,2724.08,808.69z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2728.21,804.59l0.09,0.78l0.37,3.21c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18
				c-0.78,0.09-1.48-0.47-1.57-1.25l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18
				C2727.41,803.25,2728.12,803.81,2728.21,804.59z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M2733.14,807.95l-2.7,5.28c-0.36,0.7-1.21,0.97-1.91,0.62l-1.38-0.71c-0.7-0.36-0.97-1.21-0.62-1.91l2.7-5.28
				c0.36-0.7,1.21-0.97,1.91-0.62l1.38,0.71C2733.22,806.4,2733.49,807.25,2733.14,807.95z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2728.96,811.28c0.12-0.56,0.4-1.02,0.77-1.46c0.27-0.32,0.75-1.04,1.2-1.04
					c-0.09-0.05-0.17-0.1-0.26-0.15c0.2,0.28-0.49,1.31-0.62,1.58c-0.22,0.47-0.38,0.95-0.47,1.46c-0.07,0.38,0.51,0.54,0.58,0.16
					c0.16-0.85,0.58-1.54,0.9-2.33c0.13-0.33,0.48-1.18-0.09-1.32c-0.55-0.14-1.16,0.64-1.46,0.98c-0.51,0.58-0.96,1.19-1.13,1.95
					C2728.3,811.5,2728.88,811.66,2728.96,811.28L2728.96,811.28z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2729.89,807.96c-0.63,0.06-1,0.63-1.41,1.07c-0.22,0.23-0.46,0.46-0.65,0.72
					c-0.21,0.29-0.32,0.62-0.54,0.9c-0.24,0.3,0.18,0.73,0.42,0.42c0.3-0.37,0.46-0.82,0.77-1.17c0.18-0.2,0.37-0.4,0.55-0.6
					c0.19-0.2,0.54-0.71,0.84-0.74C2730.28,808.52,2730.28,807.92,2729.89,807.96L2729.89,807.96z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2715.43,807.4l4.78,3.87c0.63,0.51,0.73,1.44,0.22,2.08l-1.01,1.25c-0.51,0.63-1.44,0.73-2.07,0.22l-4.78-3.87
				c-0.63-0.51-0.73-1.44-0.22-2.08l1.01-1.25C2713.88,806.99,2714.8,806.89,2715.43,807.4z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2717.93,812.37c-0.52-0.23-0.92-0.6-1.28-1.04c-0.19-0.23-0.37-0.48-0.54-0.73
					c-0.08-0.11-0.15-0.22-0.21-0.34c-0.41-0.27-0.42-0.31-0.03-0.12c0.47,0.23,0.86,0.6,1.27,0.92c0.42,0.32,0.88,0.56,1.37,0.76
					c0.36,0.15,0.51-0.43,0.16-0.58c-0.86-0.35-1.47-0.99-2.24-1.47c-0.31-0.19-0.99-0.6-1.22-0.09c-0.25,0.54,0.45,1.34,0.73,1.71
					c0.46,0.62,0.97,1.18,1.69,1.5C2717.98,813.04,2718.29,812.53,2717.93,812.37L2717.93,812.37z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2714.75,810.76c-0.05,0.69,0.59,1.31,0.96,1.83c0.37,0.52,0.86,0.87,1.26,1.36
					c0.24,0.3,0.67-0.13,0.42-0.42c-0.32-0.39-0.74-0.65-1.04-1.06c-0.3-0.42-1.04-1.16-1-1.7
					C2715.38,810.38,2714.78,810.38,2714.75,810.76L2714.75,810.76z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2710.44,809.8l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C2711.67,808.75,2711.22,809.57,2710.44,809.8z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2704.96,809.02c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C2704.33,808.7,2704.63,809.22,2704.96,809.02L2704.96,809.02z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2708.11,807.36c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C2707.98,808.03,2708.41,807.61,2708.11,807.36L2708.11,807.36z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2729.01,817.45l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C2730.23,816.4,2729.79,817.22,2729.01,817.45z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2723.52,816.67c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C2722.89,816.35,2723.19,816.87,2723.52,816.67L2723.52,816.67z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2726.67,815.01c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C2726.54,815.68,2726.97,815.25,2726.67,815.01L2726.67,815.01z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="2708.47,810.76 2709.56,815.99 2711.12,814.47 2709.8,809.76 			"/>
		</g>
	</g>
	<g id="XMLID_80_">
		<g>
			<g>
				<polygon className="st24" points="2723.99,809.65 2724.45,811.76 2719.96,811.05 2719.79,809.37 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_79_">
		<g>
			<g>
				<polygon className="st24" points="2728.22,805.8 2728.68,807.9 2724.19,807.19 2724.02,805.51 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M2730.38,820.09h-24.81c-3.16,0-5.73-2.56-5.73-5.73v-8.49c0-3.16,2.56-5.73,5.73-5.73h24.81
				c3.16,0,5.73,2.56,5.73,5.73v8.49C2736.1,817.53,2733.54,820.09,2730.38,820.09z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M2733.71,802.53h-31.62c-2.31,0-4.19-1.87-4.19-4.19v-2.24c0-0.22,0.18-0.4,0.4-0.4h38.79
				c0.22,0,0.4,0.18,0.4,0.4v2.65C2737.49,800.83,2735.8,802.53,2733.71,802.53z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M1235.68,825.61h-28.81c-3.16,0-5.73-2.56-5.73-5.73v-13.5c0-3.16,2.56-5.73,5.73-5.73h28.81
				c3.16,0,5.73,2.56,5.73,5.73v13.5C1241.41,823.05,1238.84,825.61,1235.68,825.61z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1215.68,816.73l-2.87,2.81c-0.56,0.55-1.46,0.54-2.01-0.02l-1.08-1.11c-0.55-0.56-0.54-1.46,0.02-2.01
				l2.87-2.81c0.56-0.55,1.46-0.54,2.01,0.02l1.08,1.11C1216.26,815.28,1216.24,816.18,1215.68,816.73z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1227.32,812.24l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18c-0.78,0.09-1.48-0.47-1.57-1.25
				l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C1226.53,810.9,1227.23,811.46,1227.32,812.24z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M1231.46,808.13l0.09,0.78l0.37,3.21c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18
				c-0.78,0.09-1.48-0.47-1.57-1.25l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18
				C1230.66,806.8,1231.37,807.36,1231.46,808.13z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M1236.38,811.5l-2.7,5.28c-0.36,0.7-1.21,0.97-1.91,0.62l-1.38-0.71c-0.7-0.36-0.97-1.21-0.62-1.91l2.7-5.28
				c0.36-0.7,1.21-0.97,1.91-0.62l1.38,0.71C1236.46,809.94,1236.74,810.8,1236.38,811.5z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1232.21,814.83c0.12-0.56,0.4-1.02,0.77-1.46c0.27-0.32,0.75-1.04,1.2-1.04
					c-0.09-0.05-0.17-0.1-0.26-0.15c0.2,0.28-0.49,1.31-0.62,1.58c-0.22,0.47-0.38,0.95-0.47,1.46c-0.07,0.38,0.51,0.54,0.58,0.16
					c0.16-0.85,0.58-1.54,0.9-2.33c0.13-0.33,0.48-1.18-0.09-1.32c-0.55-0.14-1.16,0.64-1.46,0.98c-0.51,0.58-0.96,1.19-1.13,1.95
					C1231.55,815.05,1232.13,815.21,1232.21,814.83L1232.21,814.83z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1233.14,811.5c-0.63,0.06-1,0.63-1.41,1.07c-0.22,0.23-0.46,0.46-0.65,0.72
					c-0.21,0.29-0.32,0.62-0.54,0.9c-0.24,0.3,0.18,0.73,0.42,0.42c0.3-0.37,0.46-0.82,0.77-1.17c0.18-0.2,0.37-0.4,0.55-0.6
					c0.19-0.2,0.54-0.71,0.84-0.74C1233.52,812.07,1233.53,811.46,1233.14,811.5L1233.14,811.5z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1218.68,810.95l4.78,3.87c0.63,0.51,0.73,1.44,0.22,2.07l-1.01,1.25c-0.51,0.63-1.44,0.73-2.07,0.22l-4.78-3.87
				c-0.63-0.51-0.73-1.44-0.22-2.07l1.01-1.25C1217.12,810.54,1218.05,810.44,1218.68,810.95z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1221.18,815.92c-0.52-0.23-0.92-0.6-1.28-1.04c-0.19-0.23-0.37-0.48-0.54-0.73
					c-0.08-0.11-0.15-0.22-0.21-0.34c-0.41-0.27-0.42-0.31-0.03-0.12c0.47,0.23,0.86,0.6,1.27,0.92c0.42,0.32,0.88,0.56,1.37,0.76
					c0.36,0.15,0.51-0.43,0.16-0.58c-0.86-0.35-1.47-0.99-2.24-1.47c-0.31-0.19-0.99-0.6-1.22-0.09c-0.25,0.54,0.45,1.34,0.73,1.71
					c0.46,0.62,0.97,1.18,1.69,1.5C1221.23,816.59,1221.53,816.07,1221.18,815.92L1221.18,815.92z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1218,814.31c-0.05,0.69,0.59,1.31,0.96,1.83c0.37,0.52,0.86,0.87,1.26,1.36c0.24,0.3,0.67-0.13,0.42-0.42
					c-0.32-0.39-0.74-0.65-1.04-1.06c-0.3-0.42-1.04-1.16-1-1.7C1218.63,813.92,1218.03,813.93,1218,814.31L1218,814.31z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1213.69,813.34l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C1214.92,812.3,1214.47,813.12,1213.69,813.34z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1208.21,812.56c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C1207.58,812.24,1207.88,812.76,1208.21,812.56L1208.21,812.56z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1211.36,810.91c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C1211.23,811.57,1211.66,811.15,1211.36,810.91L1211.36,810.91z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M1232.25,820.99l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C1233.48,819.95,1233.03,820.76,1232.25,820.99z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1226.77,820.21c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C1226.14,819.89,1226.44,820.41,1226.77,820.21L1226.77,820.21z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M1229.92,818.56c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C1229.79,819.22,1230.22,818.8,1229.92,818.56L1229.92,818.56z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="1211.72,814.31 1212.81,819.54 1214.37,818.01 1213.04,813.3 			"/>
		</g>
	</g>
	<g id="XMLID_25_">
		<g>
			<g>
				<polygon className="st24" points="1227.24,813.2 1227.7,815.3 1223.21,814.59 1223.04,812.92 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_24_">
		<g>
			<g>
				<polygon className="st24" points="1231.47,809.34 1231.93,811.44 1227.43,810.73 1227.27,809.06 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M1233.62,823.64h-24.81c-3.16,0-5.73-2.56-5.73-5.73v-8.49c0-3.16,2.56-5.73,5.73-5.73h24.81
				c3.16,0,5.73,2.56,5.73,5.73v8.49C1239.35,821.07,1236.79,823.64,1233.62,823.64z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M1236.96,806.07h-31.62c-2.31,0-4.19-1.87-4.19-4.19v-2.24c0-0.22,0.18-0.4,0.4-0.4h38.79
				c0.22,0,0.4,0.18,0.4,0.4v2.65C1240.74,804.38,1239.04,806.07,1236.96,806.07z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<rect x="2114.79" y="886.64" className="st28" width="10.91" height="325.02"/>
	</g>
</g>
<g>
	<g>
		<rect x="2910.27" y="886.64" className="st28" width="10.91" height="325.02"/>
	</g>
</g>
<g>
	<g>
		
			<rect x="2511.1" y="804.44" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 3722.7512 -1310.3527)" className="st28" width="10.91" height="803.52"/>
	</g>
</g>
<g>
	<g>
		
			<rect x="2511.1" y="490.33" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 3408.6411 -1624.4629)" className="st28" width="10.91" height="803.52"/>
	</g>
</g>
<g>
	<g>
		<rect x="2212.4" y="891.27" className="st28" width="11.45" height="317.38"/>
	</g>
</g>
<g>
	<g>
		<rect x="2312.2" y="891.27" className="st28" width="11.45" height="317.38"/>
	</g>
</g>
<g>
	<g>
		<rect x="2412" y="891.27" className="st28" width="11.45" height="317.38"/>
	</g>
</g>
<g>
	<g>
		<rect x="2511.79" y="891.27" className="st28" width="11.45" height="317.38"/>
	</g>
</g>
<g>
	<g>
		<rect x="2611.99" y="891.27" className="st28" width="11.45" height="317.38"/>
	</g>
</g>
<g>
	<g>
		<rect x="2712.61" y="891.27" className="st28" width="11.45" height="317.38"/>
	</g>
</g>
<g>
	<g>
		<rect x="2812.81" y="891.27" className="st28" width="11.45" height="317.38"/>
	</g>
</g>
<g className="st29">
	<g>
		<rect x="2122.7" y="892.63" className="st30" width="90.8" height="311.66"/>
	</g>
</g>
<g>
	<g>
		<polygon className="st0" points="2106.06,1219.65 2106.06,2558.35 2402.9,2558.35 2402.9,2183.05 2693.03,2183.05 2693.03,2558.35 
			2985.13,2558.35 2985.13,1219.65 		"/>
	</g>
</g>
<g className="st29">
	<g>
		<rect x="2222.08" y="892.63" className="st30" width="90.8" height="311.66"/>
	</g>
</g>
<g className="st29">
	<g>
		<rect x="2322.29" y="892.63" className="st30" width="90.8" height="311.66"/>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M2917.85,1691.68h-28.81c-3.16,0-5.73-2.56-5.73-5.73v-13.5c0-3.16,2.56-5.73,5.73-5.73h28.81
				c3.16,0,5.73,2.56,5.73,5.73v13.5C2923.58,1689.11,2921.02,1691.68,2917.85,1691.68z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2897.86,1682.79l-2.87,2.81c-0.56,0.55-1.46,0.54-2.01-0.02l-1.08-1.11c-0.55-0.56-0.54-1.46,0.02-2.01
				l2.87-2.81c0.56-0.55,1.46-0.54,2.01,0.02l1.08,1.11C2898.43,1681.35,2898.42,1682.25,2897.86,1682.79z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2909.5,1678.3l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18c-0.78,0.09-1.48-0.47-1.57-1.25
				l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C2908.7,1676.97,2909.41,1677.52,2909.5,1678.3z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2913.63,1674.2l0.09,0.78l0.37,3.21c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18
				c-0.78,0.09-1.48-0.47-1.57-1.25l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18
				C2912.83,1672.86,2913.54,1673.42,2913.63,1674.2z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M2918.56,1677.56l-2.7,5.28c-0.36,0.7-1.21,0.97-1.91,0.62l-1.38-0.71c-0.7-0.36-0.97-1.21-0.62-1.91l2.7-5.28
				c0.36-0.7,1.21-0.97,1.91-0.62l1.38,0.71C2918.64,1676.01,2918.91,1676.86,2918.56,1677.56z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2914.39,1680.89c0.12-0.56,0.4-1.02,0.77-1.46c0.27-0.32,0.75-1.04,1.2-1.04
					c-0.09-0.05-0.17-0.1-0.26-0.15c0.2,0.28-0.49,1.31-0.62,1.58c-0.22,0.47-0.38,0.95-0.47,1.46c-0.07,0.38,0.51,0.54,0.58,0.16
					c0.16-0.85,0.58-1.54,0.9-2.33c0.13-0.33,0.48-1.18-0.09-1.32c-0.55-0.14-1.16,0.64-1.46,0.98c-0.51,0.58-0.96,1.19-1.13,1.95
					C2913.73,1681.11,2914.3,1681.27,2914.39,1680.89L2914.39,1680.89z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2915.31,1677.56c-0.63,0.06-1,0.63-1.41,1.07c-0.22,0.23-0.46,0.46-0.65,0.72
					c-0.21,0.29-0.32,0.62-0.54,0.9c-0.24,0.3,0.18,0.73,0.42,0.42c0.3-0.37,0.46-0.82,0.77-1.17c0.18-0.2,0.37-0.4,0.55-0.6
					c0.19-0.2,0.54-0.71,0.84-0.74C2915.7,1678.13,2915.7,1677.53,2915.31,1677.56L2915.31,1677.56z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2900.85,1677.01l4.78,3.87c0.63,0.51,0.73,1.44,0.22,2.07l-1.01,1.25c-0.51,0.63-1.44,0.73-2.07,0.22l-4.78-3.87
				c-0.63-0.51-0.73-1.44-0.22-2.07l1.01-1.25C2899.3,1676.6,2900.22,1676.5,2900.85,1677.01z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2903.35,1681.98c-0.52-0.23-0.92-0.6-1.28-1.04c-0.19-0.23-0.37-0.48-0.54-0.73
					c-0.08-0.11-0.15-0.22-0.21-0.34c-0.41-0.27-0.42-0.31-0.03-0.12c0.47,0.23,0.86,0.6,1.27,0.92c0.42,0.32,0.88,0.56,1.37,0.76
					c0.36,0.15,0.51-0.43,0.16-0.58c-0.86-0.35-1.47-0.99-2.24-1.47c-0.31-0.19-0.99-0.6-1.22-0.09c-0.25,0.54,0.45,1.34,0.73,1.71
					c0.46,0.62,0.97,1.18,1.69,1.5C2903.4,1682.65,2903.71,1682.14,2903.35,1681.98L2903.35,1681.98z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2900.17,1680.37c-0.05,0.69,0.59,1.31,0.96,1.83c0.37,0.52,0.86,0.87,1.26,1.36
					c0.24,0.3,0.67-0.13,0.42-0.42c-0.32-0.39-0.74-0.65-1.04-1.06c-0.3-0.42-1.04-1.16-1-1.7
					C2900.8,1679.99,2900.2,1679.99,2900.17,1680.37L2900.17,1680.37z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2895.86,1679.41l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C2897.09,1678.36,2896.65,1679.18,2895.86,1679.41z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2890.38,1678.63c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C2889.75,1678.31,2890.05,1678.83,2890.38,1678.63L2890.38,1678.63z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2893.53,1676.97c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C2893.4,1677.64,2893.83,1677.21,2893.53,1676.97L2893.53,1676.97z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2914.43,1687.06l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C2915.65,1686.01,2915.21,1686.83,2914.43,1687.06z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2908.94,1686.28c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C2908.31,1685.96,2908.61,1686.48,2908.94,1686.28L2908.94,1686.28z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2912.09,1684.62c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.04-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C2911.96,1685.29,2912.39,1684.86,2912.09,1684.62L2912.09,1684.62z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="2893.89,1680.37 2894.98,1685.6 2896.54,1684.07 2895.22,1679.37 			"/>
		</g>
	</g>
	<g id="XMLID_130_">
		<g>
			<g>
				<polygon className="st24" points="2909.41,1679.26 2909.87,1681.36 2905.38,1680.65 2905.21,1678.98 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_129_">
		<g>
			<g>
				<polygon className="st24" points="2913.64,1675.41 2914.1,1677.51 2909.61,1676.8 2909.44,1675.12 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M2915.8,1689.7h-24.81c-3.16,0-5.73-2.56-5.73-5.73v-8.49c0-3.16,2.56-5.73,5.73-5.73h24.81
				c3.16,0,5.73,2.56,5.73,5.73v8.49C2921.52,1687.14,2918.96,1689.7,2915.8,1689.7z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M2919.13,1672.13h-31.62c-2.31,0-4.19-1.87-4.19-4.19v-2.24c0-0.22,0.18-0.4,0.4-0.4h38.79
				c0.22,0,0.4,0.18,0.4,0.4v2.65C2922.91,1670.44,2921.22,1672.13,2919.13,1672.13z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M2524.22,1690h-28.81c-3.16,0-5.73-2.56-5.73-5.73v-13.5c0-3.16,2.56-5.73,5.73-5.73h28.81
				c3.16,0,5.73,2.56,5.73,5.73v13.5C2529.95,1687.44,2527.38,1690,2524.22,1690z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2504.22,1681.12l-2.87,2.81c-0.56,0.55-1.46,0.54-2.01-0.02l-1.08-1.11c-0.55-0.56-0.54-1.46,0.02-2.01
				l2.87-2.81c0.56-0.55,1.46-0.54,2.01,0.02l1.08,1.11C2504.79,1679.67,2504.78,1680.57,2504.22,1681.12z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2515.86,1676.63l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18c-0.78,0.09-1.48-0.47-1.57-1.25
				l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C2515.07,1675.29,2515.77,1675.85,2515.86,1676.63z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2520,1672.52l0.09,0.78l0.37,3.21c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18
				c-0.78,0.09-1.48-0.47-1.57-1.25l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18
				C2519.2,1671.18,2519.91,1671.74,2520,1672.52z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M2524.92,1675.88l-2.7,5.28c-0.36,0.7-1.21,0.97-1.91,0.62l-1.38-0.71c-0.7-0.36-0.97-1.21-0.62-1.91l2.7-5.28
				c0.36-0.7,1.21-0.97,1.91-0.62l1.38,0.71C2525,1674.33,2525.28,1675.19,2524.92,1675.88z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2520.75,1679.22c0.12-0.56,0.4-1.02,0.77-1.46c0.27-0.32,0.75-1.04,1.2-1.04
					c-0.09-0.05-0.17-0.1-0.26-0.15c0.2,0.28-0.49,1.31-0.62,1.58c-0.22,0.47-0.38,0.95-0.47,1.46c-0.07,0.38,0.51,0.54,0.58,0.16
					c0.16-0.85,0.58-1.54,0.9-2.33c0.13-0.33,0.48-1.18-0.09-1.32c-0.55-0.14-1.16,0.64-1.46,0.98c-0.51,0.58-0.96,1.19-1.13,1.95
					C2520.09,1679.43,2520.67,1679.59,2520.75,1679.22L2520.75,1679.22z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2521.68,1675.89c-0.63,0.06-1,0.63-1.41,1.07c-0.22,0.23-0.46,0.46-0.65,0.72
					c-0.21,0.29-0.32,0.62-0.54,0.9c-0.24,0.3,0.18,0.73,0.42,0.42c0.3-0.37,0.46-0.82,0.77-1.17c0.18-0.2,0.37-0.4,0.55-0.6
					c0.19-0.2,0.54-0.71,0.84-0.74C2522.06,1676.45,2522.07,1675.85,2521.68,1675.89L2521.68,1675.89z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2507.22,1675.34l4.78,3.87c0.63,0.51,0.73,1.44,0.22,2.07l-1.01,1.25c-0.51,0.63-1.44,0.73-2.07,0.22l-4.78-3.87
				c-0.63-0.51-0.73-1.44-0.22-2.07l1.01-1.25C2505.66,1674.92,2506.59,1674.82,2507.22,1675.34z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2509.72,1680.3c-0.52-0.23-0.92-0.6-1.28-1.04c-0.19-0.23-0.37-0.48-0.54-0.73
					c-0.08-0.11-0.15-0.22-0.21-0.34c-0.41-0.27-0.42-0.31-0.03-0.12c0.47,0.23,0.86,0.6,1.27,0.92c0.42,0.32,0.88,0.56,1.37,0.76
					c0.36,0.15,0.51-0.43,0.16-0.58c-0.86-0.35-1.47-0.99-2.24-1.47c-0.31-0.19-0.99-0.6-1.22-0.09c-0.25,0.54,0.45,1.34,0.73,1.71
					c0.46,0.62,0.97,1.18,1.69,1.5C2509.77,1680.98,2510.07,1680.46,2509.72,1680.3L2509.72,1680.3z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2506.54,1678.7c-0.05,0.69,0.59,1.31,0.96,1.83c0.37,0.52,0.86,0.87,1.26,1.36
					c0.24,0.3,0.67-0.13,0.42-0.42c-0.32-0.39-0.74-0.65-1.04-1.06c-0.3-0.42-1.04-1.16-1-1.7
					C2507.17,1678.31,2506.57,1678.31,2506.54,1678.7L2506.54,1678.7z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2502.23,1677.73l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C2503.46,1676.68,2503.01,1677.5,2502.23,1677.73z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2496.75,1676.95c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C2496.12,1676.63,2496.42,1677.15,2496.75,1676.95L2496.75,1676.95z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2499.9,1675.29c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.04-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C2499.77,1675.96,2500.2,1675.54,2499.9,1675.29L2499.9,1675.29z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2520.79,1685.38l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C2522.02,1684.33,2521.57,1685.15,2520.79,1685.38z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2515.31,1684.6c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C2514.68,1684.28,2514.98,1684.8,2515.31,1684.6L2515.31,1684.6z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2518.46,1682.94c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.04-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C2518.33,1683.61,2518.76,1683.19,2518.46,1682.94L2518.46,1682.94z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="2500.26,1678.7 2501.35,1683.92 2502.91,1682.4 2501.58,1677.69 			"/>
		</g>
	</g>
	<g id="XMLID_39_">
		<g>
			<g>
				<polygon className="st24" points="2515.78,1677.59 2516.24,1679.69 2511.74,1678.98 2511.58,1677.3 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_38_">
		<g>
			<g>
				<polygon className="st24" points="2520,1673.73 2520.47,1675.83 2515.97,1675.12 2515.81,1673.45 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M2522.16,1688.02h-24.81c-3.16,0-5.73-2.56-5.73-5.73v-8.49c0-3.16,2.56-5.73,5.73-5.73h24.81
				c3.16,0,5.73,2.56,5.73,5.73v8.49C2527.89,1685.46,2525.33,1688.02,2522.16,1688.02z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M2525.5,1670.46h-31.62c-2.31,0-4.19-1.87-4.19-4.19v-2.24c0-0.22,0.18-0.4,0.4-0.4h38.79
				c0.22,0,0.4,0.18,0.4,0.4v2.65C2529.27,1668.77,2527.58,1670.46,2525.5,1670.46z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M2641.81,2146.59h28.81c3.16,0,5.73,2.56,5.73,5.73v13.5c0,3.16-2.56,5.73-5.73,5.73h-28.81
				c-3.16,0-5.73-2.56-5.73-5.73v-13.5C2636.08,2149.15,2638.64,2146.59,2641.81,2146.59z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2661.8,2155.47l2.87-2.81c0.56-0.55,1.46-0.54,2.01,0.02l1.08,1.11c0.55,0.56,0.54,1.46-0.02,2.01
				l-2.87,2.81c-0.56,0.55-1.46,0.54-2.01-0.02l-1.08-1.11C2661.23,2156.92,2661.24,2156.02,2661.8,2155.47z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2650.16,2159.96l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18c0.78-0.09,1.48,0.47,1.57,1.25
				l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18C2650.96,2161.3,2650.25,2160.74,2650.16,2159.96z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2646.03,2164.07l-0.09-0.78l-0.37-3.21c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18
				c0.78-0.09,1.48,0.47,1.57,1.25l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18
				C2646.83,2165.41,2646.12,2164.85,2646.03,2164.07z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M2641.11,2160.71l2.7-5.28c0.36-0.7,1.21-0.97,1.91-0.62l1.38,0.71c0.7,0.36,0.97,1.21,0.62,1.91l-2.7,5.28
				c-0.36,0.7-1.21,0.97-1.91,0.62l-1.38-0.71C2641.02,2162.26,2640.75,2161.4,2641.11,2160.71z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2645.28,2157.37c-0.12,0.56-0.4,1.02-0.77,1.46c-0.27,0.32-0.75,1.04-1.2,1.04
					c0.09,0.05,0.17,0.1,0.26,0.15c-0.2-0.28,0.49-1.31,0.62-1.58c0.22-0.47,0.38-0.95,0.47-1.46c0.07-0.38-0.51-0.54-0.58-0.16
					c-0.16,0.85-0.58,1.54-0.9,2.33c-0.13,0.33-0.48,1.18,0.09,1.32c0.55,0.14,1.16-0.64,1.46-0.98c0.51-0.58,0.96-1.19,1.13-1.95
					C2645.94,2157.16,2645.36,2157,2645.28,2157.37L2645.28,2157.37z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2644.35,2160.7c0.63-0.06,1-0.63,1.41-1.07c0.22-0.23,0.46-0.46,0.65-0.72c0.21-0.29,0.32-0.62,0.54-0.9
					c0.24-0.3-0.18-0.73-0.42-0.42c-0.3,0.37-0.46,0.82-0.77,1.17c-0.18,0.2-0.37,0.4-0.55,0.6c-0.19,0.2-0.54,0.71-0.84,0.74
					C2643.96,2160.14,2643.96,2160.74,2644.35,2160.7L2644.35,2160.7z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2658.81,2161.25l-4.78-3.87c-0.63-0.51-0.73-1.44-0.22-2.07l1.01-1.25c0.51-0.63,1.44-0.73,2.07-0.22l4.78,3.87
				c0.63,0.51,0.73,1.44,0.22,2.07l-1.01,1.25C2660.36,2161.67,2659.44,2161.77,2658.81,2161.25z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2656.31,2156.29c0.52,0.23,0.92,0.59,1.28,1.04c0.19,0.23,0.37,0.48,0.54,0.73
					c0.08,0.11,0.15,0.22,0.21,0.34c0.41,0.27,0.42,0.31,0.03,0.12c-0.47-0.23-0.86-0.6-1.27-0.92c-0.42-0.32-0.88-0.56-1.37-0.76
					c-0.36-0.15-0.51,0.43-0.16,0.58c0.86,0.35,1.47,0.99,2.24,1.47c0.31,0.19,0.99,0.6,1.22,0.09c0.25-0.54-0.45-1.34-0.73-1.71
					c-0.46-0.62-0.97-1.18-1.69-1.5C2656.26,2155.61,2655.95,2156.13,2656.31,2156.29L2656.31,2156.29z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2659.49,2157.89c0.05-0.69-0.59-1.31-0.96-1.83c-0.37-0.52-0.86-0.87-1.26-1.36
					c-0.24-0.3-0.67,0.13-0.42,0.42c0.32,0.39,0.74,0.65,1.04,1.06c0.3,0.42,1.04,1.16,1,1.7
					C2658.86,2158.28,2659.46,2158.28,2659.49,2157.89L2659.49,2157.89z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2663.8,2158.86l5.9-1.73c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54c0.23,0.78-0.21,1.6-0.99,1.83l-5.9,1.73
				c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54C2662.57,2159.91,2663.02,2159.09,2663.8,2158.86z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2669.28,2159.64c-0.49,0.3-1.02,0.41-1.59,0.45c-0.41,0.03-1.39,0.16-1.7-0.16
					c0.03,0.1,0.05,0.19,0.08,0.29c0.06-0.34,1.31-0.56,1.63-0.66c0.52-0.17,0.99-0.4,1.45-0.69c0.32-0.21,0.02-0.73-0.3-0.52
					c-0.8,0.51-1.67,0.66-2.52,1.04c-0.34,0.15-1.04,0.46-0.78,0.94c0.28,0.52,1.35,0.4,1.8,0.39c0.79-0.03,1.55-0.13,2.24-0.55
					C2669.91,2159.96,2669.61,2159.44,2669.28,2159.64L2669.28,2159.64z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2666.13,2161.3c0.49,0.4,1.1,0.3,1.7,0.29c0.35,0,0.72,0.02,1.07-0.03c0.38-0.05,0.72-0.2,1.11-0.24
					c0.38-0.03,0.39-0.64,0-0.6c-0.53,0.05-1.02,0.25-1.56,0.26c-0.47,0.01-1.5,0.21-1.89-0.11
					C2666.26,2160.63,2665.83,2161.05,2666.13,2161.3L2666.13,2161.3z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2645.24,2151.21l5.9-1.73c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54c0.23,0.78-0.21,1.6-0.99,1.83l-5.9,1.73
				c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54C2644.01,2152.26,2644.45,2151.44,2645.24,2151.21z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2650.72,2151.99c-0.49,0.3-1.02,0.41-1.59,0.45c-0.41,0.03-1.39,0.16-1.7-0.16
					c0.03,0.1,0.05,0.19,0.08,0.29c0.06-0.34,1.31-0.56,1.63-0.66c0.52-0.17,0.99-0.4,1.45-0.69c0.32-0.21,0.02-0.73-0.3-0.52
					c-0.8,0.51-1.67,0.66-2.52,1.04c-0.34,0.15-1.04,0.46-0.78,0.94c0.28,0.52,1.35,0.4,1.8,0.39c0.79-0.03,1.55-0.13,2.24-0.55
					C2651.35,2152.31,2651.05,2151.79,2650.72,2151.99L2650.72,2151.99z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2647.57,2153.65c0.49,0.4,1.1,0.3,1.7,0.29c0.35,0,0.72,0.02,1.07-0.03c0.38-0.05,0.72-0.2,1.11-0.24
					c0.38-0.03,0.39-0.64,0-0.6c-0.53,0.05-1.02,0.25-1.56,0.26c-0.47,0.01-1.5,0.21-1.89-0.11
					C2647.7,2152.98,2647.27,2153.4,2647.57,2153.65L2647.57,2153.65z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="2665.77,2157.89 2664.68,2152.67 2663.12,2154.19 2664.44,2158.9 			"/>
		</g>
	</g>
	<g id="XMLID_60_">
		<g>
			<g>
				<polygon className="st24" points="2650.25,2159 2649.79,2156.9 2654.28,2157.61 2654.45,2159.29 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_59_">
		<g>
			<g>
				<polygon className="st24" points="2646.02,2162.86 2645.56,2160.76 2650.05,2161.47 2650.22,2163.14 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M2643.86,2148.57h24.81c3.16,0,5.73,2.56,5.73,5.73v8.49c0,3.16-2.56,5.73-5.73,5.73h-24.81
				c-3.16,0-5.73-2.56-5.73-5.73v-8.49C2638.14,2151.13,2640.7,2148.57,2643.86,2148.57z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M2640.53,2166.13h31.62c2.31,0,4.19,1.87,4.19,4.19v2.24c0,0.22-0.18,0.4-0.4,0.4h-38.79
				c-0.22,0-0.4-0.18-0.4-0.4v-2.65C2636.75,2167.82,2638.44,2166.13,2640.53,2166.13z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M2148.82,1690.15h-28.81c-3.16,0-5.73-2.56-5.73-5.73v-13.5c0-3.16,2.56-5.73,5.73-5.73h28.81
				c3.16,0,5.73,2.56,5.73,5.73v13.5C2154.55,1687.59,2151.99,1690.15,2148.82,1690.15z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2128.83,1681.27l-2.87,2.81c-0.56,0.55-1.46,0.54-2.01-0.02l-1.08-1.11c-0.55-0.56-0.54-1.46,0.02-2.01
				l2.87-2.81c0.56-0.55,1.46-0.54,2.01,0.02l1.08,1.11C2129.4,1679.82,2129.39,1680.72,2128.83,1681.27z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2140.47,1676.78l0.46,3.99c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18c-0.78,0.09-1.48-0.47-1.57-1.25
				l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18C2139.67,1675.44,2140.38,1676,2140.47,1676.78z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2144.6,1672.67l0.09,0.78l0.37,3.21c0.09,0.78-0.47,1.48-1.25,1.57l-1.54,0.18
				c-0.78,0.09-1.48-0.47-1.57-1.25l-0.46-3.99c-0.09-0.78,0.47-1.48,1.25-1.57l1.54-0.18
				C2143.81,1671.33,2144.51,1671.89,2144.6,1672.67z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M2149.53,1676.03l-2.7,5.28c-0.36,0.7-1.21,0.97-1.91,0.62l-1.38-0.71c-0.7-0.36-0.97-1.21-0.62-1.91l2.7-5.28
				c0.36-0.7,1.21-0.97,1.91-0.62l1.38,0.71C2149.61,1674.48,2149.88,1675.33,2149.53,1676.03z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2145.36,1679.36c0.12-0.56,0.4-1.02,0.77-1.46c0.27-0.32,0.75-1.04,1.2-1.04
					c-0.09-0.05-0.17-0.1-0.26-0.15c0.2,0.28-0.49,1.31-0.62,1.58c-0.22,0.47-0.38,0.95-0.47,1.46c-0.07,0.38,0.51,0.54,0.58,0.16
					c0.16-0.85,0.58-1.54,0.9-2.33c0.13-0.33,0.48-1.18-0.09-1.32c-0.55-0.14-1.16,0.64-1.46,0.98c-0.51,0.58-0.96,1.19-1.13,1.95
					C2144.7,1679.58,2145.27,1679.74,2145.36,1679.36L2145.36,1679.36z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2146.29,1676.04c-0.63,0.06-1,0.63-1.41,1.07c-0.22,0.23-0.46,0.46-0.65,0.72
					c-0.21,0.29-0.32,0.62-0.54,0.9c-0.24,0.3,0.18,0.73,0.42,0.42c0.3-0.37,0.46-0.82,0.77-1.17c0.18-0.2,0.37-0.4,0.55-0.6
					c0.19-0.2,0.54-0.71,0.84-0.74C2146.67,1676.6,2146.67,1676,2146.29,1676.04L2146.29,1676.04z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2131.83,1675.48l4.78,3.87c0.63,0.51,0.73,1.44,0.22,2.07l-1.01,1.25c-0.51,0.63-1.44,0.73-2.07,0.22l-4.78-3.87
				c-0.63-0.51-0.73-1.44-0.22-2.07l1.01-1.25C2130.27,1675.07,2131.19,1674.97,2131.83,1675.48z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2134.32,1680.45c-0.52-0.23-0.92-0.6-1.28-1.04c-0.19-0.23-0.37-0.48-0.54-0.73
					c-0.08-0.11-0.15-0.22-0.21-0.34c-0.41-0.27-0.42-0.31-0.03-0.12c0.47,0.23,0.86,0.6,1.27,0.92c0.42,0.32,0.88,0.56,1.37,0.76
					c0.36,0.15,0.51-0.43,0.16-0.58c-0.86-0.35-1.47-0.99-2.24-1.47c-0.31-0.19-0.99-0.6-1.22-0.09c-0.25,0.54,0.45,1.34,0.73,1.71
					c0.46,0.62,0.97,1.18,1.69,1.5C2134.37,1681.12,2134.68,1680.61,2134.32,1680.45L2134.32,1680.45z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2131.14,1678.85c-0.05,0.69,0.59,1.31,0.96,1.83c0.37,0.52,0.86,0.87,1.26,1.36
					c0.24,0.3,0.67-0.13,0.42-0.42c-0.32-0.39-0.74-0.65-1.04-1.06c-0.3-0.42-1.04-1.16-1-1.7
					C2131.77,1678.46,2131.17,1678.46,2131.14,1678.85L2131.14,1678.85z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2126.84,1677.88l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C2128.06,1676.83,2127.62,1677.65,2126.84,1677.88z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2121.35,1677.1c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C2120.72,1676.78,2121.02,1677.3,2121.35,1677.1L2121.35,1677.1z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2124.5,1675.44c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C2124.37,1676.11,2124.8,1675.69,2124.5,1675.44L2124.5,1675.44z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2145.4,1685.53l-5.9,1.73c-0.78,0.23-1.6-0.22-1.83-1l-0.46-1.54c-0.23-0.78,0.21-1.6,0.99-1.83l5.9-1.73
				c0.78-0.23,1.6,0.22,1.83,1l0.46,1.54C2146.62,1684.48,2146.18,1685.3,2145.4,1685.53z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2139.91,1684.75c0.49-0.3,1.02-0.41,1.59-0.45c0.41-0.03,1.39-0.16,1.7,0.16
					c-0.03-0.1-0.05-0.19-0.08-0.29c-0.06,0.34-1.31,0.56-1.63,0.66c-0.52,0.17-0.99,0.4-1.45,0.69c-0.32,0.21-0.02,0.73,0.3,0.52
					c0.8-0.51,1.67-0.66,2.52-1.04c0.34-0.15,1.04-0.46,0.78-0.94c-0.28-0.52-1.35-0.4-1.8-0.39c-0.79,0.03-1.55,0.13-2.24,0.55
					C2139.28,1684.43,2139.58,1684.95,2139.91,1684.75L2139.91,1684.75z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2143.06,1683.09c-0.49-0.4-1.1-0.3-1.7-0.29c-0.35,0-0.72-0.02-1.07,0.03c-0.38,0.05-0.72,0.2-1.11,0.24
					c-0.38,0.03-0.39,0.64,0,0.6c0.53-0.05,1.02-0.25,1.56-0.26c0.47-0.01,1.5-0.21,1.89,0.11
					C2142.94,1683.76,2143.36,1683.34,2143.06,1683.09L2143.06,1683.09z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="2124.86,1678.85 2125.95,1684.07 2127.52,1682.55 2126.19,1677.84 			"/>
		</g>
	</g>
	<g id="XMLID_116_">
		<g>
			<g>
				<polygon className="st24" points="2140.38,1677.74 2140.84,1679.84 2136.35,1679.13 2136.18,1677.45 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_115_">
		<g>
			<g>
				<polygon className="st24" points="2144.61,1673.88 2145.07,1675.98 2140.58,1675.27 2140.41,1673.6 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M2146.77,1688.17h-24.81c-3.16,0-5.73-2.56-5.73-5.73v-8.49c0-3.16,2.56-5.73,5.73-5.73h24.81
				c3.16,0,5.73,2.56,5.73,5.73v8.49C2152.49,1685.61,2149.93,1688.17,2146.77,1688.17z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M2150.1,1670.61h-31.62c-2.31,0-4.19-1.87-4.19-4.19v-2.24c0-0.22,0.18-0.4,0.4-0.4h38.79
				c0.22,0,0.4,0.18,0.4,0.4v2.65C2153.88,1668.92,2152.19,1670.61,2150.1,1670.61z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st22" d="M2961.38,1350.35v28.81c0,3.16-2.56,5.73-5.73,5.73h-13.5c-3.16,0-5.73-2.56-5.73-5.73v-28.81
				c0-3.16,2.56-5.73,5.73-5.73h13.5C2958.81,1344.62,2961.38,1347.19,2961.38,1350.35z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2952.49,1370.35l2.81,2.87c0.55,0.56,0.54,1.46-0.02,2.01l-1.11,1.08c-0.56,0.55-1.46,0.54-2.01-0.02
				l-2.81-2.87c-0.55-0.56-0.54-1.46,0.02-2.01l1.11-1.08C2951.05,1369.78,2951.95,1369.79,2952.49,1370.35z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2948,1358.71l3.99-0.46c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54c0.09,0.78-0.47,1.48-1.25,1.57
				l-3.99,0.46c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54C2946.66,1359.5,2947.22,1358.8,2948,1358.71z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st21" d="M2943.9,1354.58l0.78-0.09l3.21-0.37c0.78-0.09,1.48,0.47,1.57,1.25l0.18,1.54
				c0.09,0.78-0.47,1.48-1.25,1.57l-3.99,0.46c-0.78,0.09-1.48-0.47-1.57-1.25l-0.18-1.54
				C2942.56,1355.37,2943.12,1354.67,2943.9,1354.58z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M2947.26,1349.65l5.28,2.7c0.7,0.36,0.97,1.21,0.62,1.91l-0.71,1.38c-0.36,0.7-1.21,0.97-1.91,0.62l-5.28-2.7
				c-0.7-0.36-0.97-1.21-0.62-1.91l0.71-1.38C2945.71,1349.57,2946.56,1349.29,2947.26,1349.65z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2950.59,1353.82c-0.56-0.12-1.02-0.4-1.46-0.77c-0.32-0.27-1.04-0.75-1.04-1.2
					c-0.05,0.09-0.1,0.17-0.15,0.26c0.28-0.2,1.31,0.49,1.58,0.62c0.47,0.22,0.95,0.38,1.46,0.47c0.38,0.07,0.54-0.51,0.16-0.58
					c-0.85-0.16-1.54-0.58-2.33-0.9c-0.33-0.13-1.18-0.48-1.32,0.09c-0.14,0.55,0.64,1.16,0.98,1.46c0.58,0.51,1.19,0.96,1.95,1.13
					C2950.81,1354.48,2950.97,1353.9,2950.59,1353.82L2950.59,1353.82z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2947.26,1352.89c0.06,0.63,0.63,1,1.07,1.41c0.23,0.22,0.46,0.46,0.72,0.65c0.29,0.21,0.62,0.32,0.9,0.54
					c0.3,0.24,0.73-0.18,0.42-0.42c-0.37-0.3-0.82-0.46-1.17-0.77c-0.2-0.18-0.4-0.37-0.6-0.55c-0.2-0.19-0.71-0.54-0.74-0.84
					C2947.83,1352.51,2947.23,1352.51,2947.26,1352.89L2947.26,1352.89z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2946.71,1367.35l3.87-4.78c0.51-0.63,1.44-0.73,2.07-0.22l1.25,1.01c0.63,0.51,0.73,1.44,0.22,2.07l-3.87,4.78
				c-0.51,0.63-1.44,0.73-2.07,0.22l-1.25-1.01C2946.3,1368.91,2946.2,1367.98,2946.71,1367.35z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2951.68,1364.85c-0.23,0.52-0.6,0.92-1.04,1.28c-0.23,0.19-0.48,0.37-0.73,0.54
					c-0.11,0.08-0.22,0.15-0.34,0.21c-0.27,0.41-0.31,0.42-0.12,0.03c0.23-0.47,0.6-0.86,0.92-1.27c0.32-0.42,0.56-0.88,0.76-1.37
					c0.15-0.36-0.43-0.51-0.58-0.16c-0.35,0.86-0.99,1.47-1.47,2.24c-0.19,0.31-0.6,0.99-0.09,1.22c0.54,0.25,1.34-0.45,1.71-0.73
					c0.62-0.46,1.18-0.97,1.5-1.69C2952.35,1364.8,2951.84,1364.5,2951.68,1364.85L2951.68,1364.85z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2950.07,1368.03c0.69,0.05,1.31-0.59,1.83-0.96c0.52-0.37,0.87-0.86,1.36-1.26
					c0.3-0.24-0.13-0.67-0.42-0.42c-0.39,0.32-0.65,0.74-1.06,1.04c-0.42,0.3-1.16,1.04-1.7,1
					C2949.69,1367.4,2949.69,1368,2950.07,1368.03L2950.07,1368.03z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2949.11,1372.34l1.73,5.9c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46c-0.78,0.23-1.6-0.21-1.83-0.99l-1.73-5.9
				c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46C2948.06,1371.12,2948.88,1371.56,2949.11,1372.34z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2948.33,1377.82c-0.3-0.49-0.41-1.02-0.45-1.59c-0.03-0.41-0.16-1.39,0.16-1.7
					c-0.1,0.03-0.19,0.05-0.29,0.08c0.34,0.06,0.56,1.31,0.66,1.63c0.17,0.52,0.4,0.99,0.69,1.45c0.21,0.32,0.73,0.02,0.52-0.3
					c-0.51-0.8-0.66-1.67-1.04-2.52c-0.15-0.34-0.46-1.04-0.94-0.78c-0.52,0.28-0.4,1.35-0.39,1.8c0.03,0.79,0.13,1.55,0.55,2.24
					C2948.01,1378.46,2948.53,1378.16,2948.33,1377.82L2948.33,1377.82z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2946.67,1374.68c-0.4,0.49-0.3,1.1-0.29,1.7c0,0.35-0.02,0.72,0.03,1.07c0.05,0.38,0.2,0.72,0.24,1.11
					c0.04,0.38,0.64,0.39,0.6,0c-0.05-0.53-0.25-1.02-0.26-1.56c-0.01-0.47-0.21-1.5,0.11-1.89
					C2947.34,1374.8,2946.91,1374.38,2946.67,1374.68L2946.67,1374.68z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path d="M2956.76,1353.78l1.73,5.9c0.23,0.78-0.22,1.6-1,1.83l-1.54,0.46c-0.78,0.23-1.6-0.21-1.83-0.99l-1.73-5.9
				c-0.23-0.78,0.22-1.6,1-1.83l1.54-0.46C2955.71,1352.55,2956.53,1353,2956.76,1353.78z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2955.98,1359.26c-0.3-0.49-0.41-1.02-0.45-1.59c-0.03-0.41-0.16-1.39,0.16-1.7
					c-0.1,0.03-0.19,0.05-0.29,0.08c0.34,0.06,0.56,1.31,0.66,1.63c0.17,0.52,0.4,0.99,0.69,1.45c0.21,0.32,0.73,0.02,0.52-0.3
					c-0.51-0.8-0.66-1.67-1.04-2.52c-0.15-0.34-0.46-1.04-0.94-0.78c-0.52,0.28-0.4,1.35-0.39,1.8c0.03,0.79,0.13,1.55,0.55,2.24
					C2955.66,1359.9,2956.18,1359.59,2955.98,1359.26L2955.98,1359.26z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st23" d="M2954.32,1356.11c-0.4,0.49-0.3,1.1-0.29,1.7c0,0.35-0.02,0.72,0.03,1.07c0.05,0.38,0.2,0.72,0.24,1.11
					c0.04,0.38,0.64,0.39,0.6,0c-0.05-0.53-0.25-1.02-0.26-1.56c-0.01-0.47-0.21-1.5,0.11-1.89
					C2954.98,1356.24,2954.56,1355.81,2954.32,1356.11L2954.32,1356.11z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st24" points="2950.07,1374.32 2955.3,1373.22 2953.77,1371.66 2949.07,1372.99 			"/>
		</g>
	</g>
	<g id="XMLID_70_">
		<g>
			<g>
				<polygon className="st24" points="2948.96,1358.8 2951.06,1358.34 2950.35,1362.83 2948.68,1362.99 				"/>
			</g>
		</g>
	</g>
	<g id="XMLID_69_">
		<g>
			<g>
				<polygon className="st24" points="2945.11,1354.57 2947.21,1354.11 2946.5,1358.6 2944.82,1358.76 				"/>
			</g>
		</g>
	</g>
	<g className="st25">
		<g>
			<path className="st26" d="M2959.4,1352.41v24.81c0,3.16-2.56,5.73-5.73,5.73h-8.49c-3.16,0-5.73-2.56-5.73-5.73v-24.81
				c0-3.16,2.56-5.73,5.73-5.73h8.49C2956.84,1346.68,2959.4,1349.25,2959.4,1352.41z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st27" d="M2941.83,1349.08v31.62c0,2.31-1.87,4.19-4.19,4.19h-2.24c-0.22,0-0.4-0.18-0.4-0.4v-38.79
				c0-0.22,0.18-0.4,0.4-0.4h2.65C2940.14,1345.3,2941.83,1346.99,2941.83,1349.08z"/>
		</g>
	</g>
</g>
<g className="st29">
	<g>
		<rect x="2422.9" y="892.63" className="st30" width="90.8" height="311.66"/>
	</g>
</g>
<g className="st29">
	<g>
		<rect x="2522.29" y="892.63" className="st30" width="90.8" height="311.66"/>
	</g>
</g>
<g className="st29">
	<g>
		<rect x="2622.49" y="892.63" className="st30" width="90.8" height="311.66"/>
	</g>
</g>
<g className="st29">
	<g>
		<rect x="2723.11" y="892.63" className="st30" width="90.8" height="311.66"/>
	</g>
</g>
<g className="st29">
	<g>
		<rect x="2822.49" y="892.63" className="st30" width="90.8" height="311.66"/>
	</g>
</g>
<g>
	<g className="st31">
		<g>
			<polygon className="st4" points="2122.7,1096.08 2213.51,1078.47 2213.51,1132.09 2122.7,1150.79 			"/>
		</g>
	</g>
	<g className="st31">
		<g>
			<polygon className="st4" points="2222.07,1076.8 2312.89,1059.18 2312.89,1111.68 2222.07,1130.32 			"/>
		</g>
	</g>
	<g className="st31">
		<g>
			<polygon className="st4" points="2322.29,1057.36 2413.1,1039.75 2413.1,1091.06 2322.29,1109.71 			"/>
		</g>
	</g>
	<g className="st31">
		<g>
			<polygon className="st4" points="2422.89,1037.83 2513.71,1020.22 2513.71,1070.35 2422.89,1089.05 			"/>
		</g>
	</g>
	<g className="st31">
		<g>
			<polygon className="st4" points="2522.27,1018.55 2613.09,1000.94 2613.09,1049.94 2522.27,1068.58 			"/>
		</g>
	</g>
	<g className="st31">
		<g>
			<polygon className="st4" points="2622.49,999.12 2713.3,981.5 2713.3,1029.32 2622.49,1048.02 			"/>
		</g>
	</g>
	<g className="st31">
		<g>
			<polygon className="st4" points="2723.09,979.58 2813.91,961.97 2813.91,1008.61 2723.09,1027.3 			"/>
		</g>
	</g>
	<g className="st31">
		<g>
			<polygon className="st4" points="2913.29,942.69 2913.29,988.19 2822.47,1006.89 2822.47,960.35 			"/>
		</g>
	</g>
	<g>
		<g className="st31">
			<g>
				<polygon className="st4" points="2122.7,1159.34 2213.51,1141.73 2213.51,1177.78 2122.7,1196.47 				"/>
			</g>
		</g>
		<g className="st31">
			<g>
				<polygon className="st4" points="2222.07,1140.06 2312.89,1122.44 2312.89,1157.36 2222.07,1176 				"/>
			</g>
		</g>
		<g className="st31">
			<g>
				<polygon className="st4" points="2322.29,1120.62 2413.1,1103.01 2413.1,1136.74 2322.29,1155.39 				"/>
			</g>
		</g>
		<g className="st31">
			<g>
				<polygon className="st4" points="2422.89,1101.09 2513.71,1083.48 2513.71,1116.03 2422.89,1134.73 				"/>
			</g>
		</g>
		<g className="st31">
			<g>
				<polygon className="st4" points="2522.27,1081.81 2613.09,1064.19 2613.09,1095.62 2522.27,1114.26 				"/>
			</g>
		</g>
		<g className="st31">
			<g>
				<polygon className="st4" points="2622.49,1062.37 2713.3,1044.76 2713.3,1075 2622.49,1093.7 				"/>
			</g>
		</g>
		<g className="st31">
			<g>
				<polygon className="st4" points="2723.09,1042.84 2813.91,1025.23 2813.91,1054.29 2723.09,1072.99 				"/>
			</g>
		</g>
		<g className="st31">
			<g>
				<polygon className="st4" points="2913.29,1005.94 2913.29,1033.88 2822.47,1052.57 2822.47,1023.61 				"/>
			</g>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st32" d="M2206.79,1886.31c0,0.75-0.95,1.36-2.11,1.36h-37.46c-1.17,0-2.11-0.61-2.11-1.36v-0.47
				c0-0.75,0.95-1.36,2.11-1.36h37.46c1.17,0,2.11,0.61,2.11,1.36V1886.31z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st33" d="M2213.03,1730.86c-3.83-1.75-50.53-1.75-54.36,0c-6.19,2.83-8.6,17.85-8.6,17.85s0.37,107.66,0.95,111.81
				c2.5,17.83,10.2,22.28,13.46,23.73c4.56,2.04,37.83,2.65,42.4,0.61c3.26-1.46,11.31-6.51,13.81-24.34
				c0.58-4.15,0.95-111.81,0.95-111.81S2219.22,1733.69,2213.03,1730.86z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st34" d="M2205.64,1783.95c-7.15-5.76-19.79-5.51-19.79-5.51s-12.64-0.25-19.79,5.51
				c-1.72,1.38-1.12,48.88,1.74,51.34c2.86,2.46,18.04,2.26,18.04,2.26s15.19,0.2,18.04-2.26
				C2206.75,1832.83,2207.36,1785.33,2205.64,1783.95z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st32" d="M2210.89,1765.62c-4.24-4.93-25.04-6.05-25.04-6.05s-20.8,1.12-25.04,6.05
				c-1.06,1.23,1.48,15.18,3.67,16.12c1.6,0.69,7.14-5.12,21.38-4.55c15.78,0.63,19.77,5.23,21.37,4.55
				C2209.42,1780.8,2211.96,1766.85,2210.89,1765.62z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st32" d="M2159.29,1850.19c3.88,4.93,26.52,5.14,26.52,5.14s22.73-0.21,26.61-5.14c0.97-1.23-5.05-9.51-7.06-10.45
				c-1.47-0.69-19.55,0-19.55,0s-18.09-0.69-19.55,0C2164.25,1840.68,2158.32,1848.95,2159.29,1850.19z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st34" d="M2210.81,1763.81c0,0-1.66-13.85-3.83-20.23c-2.17-6.38-4.96-9.56-4.96-9.56l-15.84-0.24v-0.01l-0.33,0.01
				l-0.33-0.01v0.01l-15.84,0.24c0,0-2.79,3.18-4.96,9.56s-3.83,20.23-3.83,20.23s5.45-2.8,9.7-3.73
				c3.81-0.84,13.36-1.93,15.26-2.14c1.9,0.21,11.45,1.3,15.26,2.14C2205.36,1761.01,2210.81,1763.81,2210.81,1763.81z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2207.77,1735.23c0.35-0.85,0.87-2.29,1.92-2.44c1.1-0.17,2.65,0.62,3.67,1.06
					c2.35,1.02,3.54,3.24,3.88,5.73c0.15,1.12-0.4,6.51-2.36,5.49l-0.19,0.1c-0.49-0.71-0.56-1.91-0.96-2.76
					c-0.44-0.94-1.02-1.68-1.75-2.38c-0.95-0.91-1.72-1.67-2.92-2.19C2207.65,1737.24,2207.11,1736.79,2207.77,1735.23z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st35" d="M2207.07,1735.96c0.35-0.85,0.87-2.29,1.92-2.44c1.1-0.17,2.65,0.62,3.67,1.06
					c2.35,1.02,3.54,3.24,3.88,5.73c0.15,1.12-0.4,6.51-2.36,5.49l-0.19,0.1c-0.49-0.71-0.56-1.91-0.96-2.76
					c-0.44-0.94-1.02-1.68-1.75-2.38c-0.96-0.91-1.72-1.67-2.92-2.19C2206.95,1737.97,2206.41,1737.53,2207.07,1735.96z"/>
			</g>
		</g>
		<g className="st36">
			<g>
				<path className="st4" d="M2213.95,1736.46c0.05,0.4-0.34,1.41-0.8,1.56c-0.5,0.17-1.31-0.37-1.7-0.59
					c-0.85-0.47-2.67-0.78-2.74-1.97c-0.1-1.73,1.7-1.08,2.56-0.71c0.69,0.29,2.31,0.98,2.63,1.68c0.05,0.12,0.01,0.39,0.03,0.35
					L2213.95,1736.46z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2164.56,1734.3c-0.34-0.85-0.82-2.3-1.87-2.48c-1.1-0.19-2.66,0.56-3.69,0.99
					c-2.37,0.97-3.61,3.17-3.99,5.65c-0.17,1.11,0.26,6.52,2.24,5.54l0.19,0.1c0.51-0.7,0.6-1.9,1.02-2.74
					c0.46-0.93,1.05-1.66,1.8-2.34c0.97-0.89,1.75-1.63,2.97-2.12C2164.63,1736.31,2165.18,1735.88,2164.56,1734.3z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st35" d="M2165.24,1735.05c-0.34-0.85-0.82-2.3-1.87-2.48c-1.1-0.19-2.66,0.56-3.69,0.99
					c-2.37,0.97-3.61,3.17-3.99,5.65c-0.17,1.11,0.26,6.52,2.24,5.54l0.19,0.1c0.51-0.7,0.6-1.9,1.02-2.74
					c0.46-0.93,1.05-1.66,1.8-2.34c0.97-0.89,1.75-1.63,2.97-2.12C2165.32,1737.06,2165.86,1736.63,2165.24,1735.05z"/>
			</g>
		</g>
		<g className="st36">
			<g>
				<path className="st4" d="M2158.35,1735.4c-0.06,0.4,0.31,1.42,0.77,1.58c0.5,0.18,1.32-0.35,1.71-0.55
					c0.86-0.45,2.68-0.72,2.78-1.91c0.14-1.73-1.67-1.11-2.54-0.77c-0.69,0.28-2.33,0.93-2.67,1.62c-0.06,0.12-0.02,0.39-0.03,0.35
					L2158.35,1735.4z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2156.81,1766.54c-3.31,0-3.3,28.17-2.86,31.51c0.44,3.33,9.43,2.24,9.43,1.56c0-1.07,0-15.34,0-15.34
					c-0.4-0.83-2.44-4.17-3.91-8.18C2157.99,1772.07,2157.53,1766.54,2156.81,1766.54z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st32" d="M2153.94,1802.01c-0.92,0.61,1.12,32.78,1.95,39.71c0.45,3.79,8.22-1.82,8.53-4.85
					c0.31-3.03-1.45-32.61-1.71-34.1C2162.51,1801.6,2155.32,1801.1,2153.94,1802.01z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2215.4,1766.54c3.31,0,3.3,28.17,2.86,31.51c-0.44,3.33-9.43,2.24-9.43,1.56c0-1.07,0-15.34,0-15.34
					c0.4-0.83,2.44-4.17,3.91-8.18C2214.21,1772.07,2214.67,1766.54,2215.4,1766.54z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st32" d="M2218.26,1802.01c0.92,0.61-1.12,32.78-1.95,39.71c-0.45,3.79-8.22-1.82-8.53-4.85
					c-0.31-3.03,1.45-32.61,1.71-34.1C2209.69,1801.6,2216.88,1801.1,2218.26,1802.01z"/>
			</g>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2177,1760.44 2169.87,1779.73 2176.54,1777.79 2184.13,1759.69 			"/>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2179.86,1777.34 2187.58,1759.69 2190.22,1759.95 2182.72,1777.17 			"/>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2188.45,1777.34 2198.06,1760.95 2205.62,1762.73 2197.27,1778.44 			"/>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2166.69,1762.54 2161.29,1773.1 2162.29,1777.34 2169.87,1761.7 			"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st34" d="M2213.76,1852.89c0,0-7.43,3.75-12.58,4.82c-5.15,1.06-15.33,0.61-15.33,0.61v-0.1
				c0,0-10.18,0.45-15.33-0.61c-5.15-1.06-12.58-4.82-12.58-4.82s-1.06,12.34,0,16c1.06,3.67,6.15,12.91,7.17,13.52
				c1.02,0.61,20.74,2.29,20.74,2.29v0.1c0,0,19.72-1.68,20.74-2.29c1.02-0.61,6.11-9.85,7.17-13.52
				C2214.82,1865.23,2213.76,1852.89,2213.76,1852.89z"/>
		</g>
	</g>
	<g>
		<g>
			<rect x="2213.65" y="1768.63" className="st32" width="0.31" height="0.78"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st32" d="M2212.58,1729.49c0,0.75-1.22,1.36-2.73,1.36h-48.39c-1.51,0-2.73-0.61-2.73-1.36v-0.47
				c0-0.75,1.22-1.36,2.73-1.36h48.39c1.51,0,2.73,0.61,2.73,1.36V1729.49z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st32" d="M2416.75,1889.83c-0.05,0.75-1.04,1.29-2.2,1.21l-37.36-2.65c-1.16-0.08-2.06-0.76-2.01-1.51l0.03-0.47
				c0.05-0.75,1.04-1.29,2.2-1.21l37.36,2.65c1.16,0.08,2.06,0.76,2.01,1.51L2416.75,1889.83z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st38" d="M2433.99,1735.21c-3.69-2.02-50.28-5.33-54.22-3.85c-6.37,2.39-9.84,17.19-9.84,17.19
				s-7.26,107.41-6.98,111.59c1.23,17.96,8.59,22.94,11.74,24.63c4.41,2.36,37.55,5.32,42.25,3.61c3.35-1.22,11.75-5.69,15.5-23.3
				c0.87-4.1,8.87-111.46,8.87-111.46S2439.96,1738.47,2433.99,1735.21z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st39" d="M2422.85,1787.65c-6.72-6.25-19.35-6.9-19.35-6.9s-12.59-1.15-20.13,4.09c-1.81,1.26-4.58,48.68-1.9,51.33
				c2.68,2.66,17.84,3.54,17.84,3.54s15.14,1.27,18.16-0.98C2420.5,1836.48,2424.47,1789.15,2422.85,1787.65z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st32" d="M2429.4,1769.73c-3.88-5.22-24.55-7.81-24.55-7.81s-20.83-0.36-25.41,4.26c-1.15,1.16,0.4,15.25,2.52,16.34
				c1.55,0.8,7.49-4.6,21.64-3.02c15.69,1.75,19.35,6.62,21,6.05C2426.85,1784.77,2430.37,1771.04,2429.4,1769.73z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st32" d="M2371.93,1850.44c3.52,5.19,26.09,7,26.09,7s22.69,1.4,26.91-3.24c1.06-1.16-4.36-9.84-6.3-10.92
				c-1.42-0.79-19.5-1.39-19.5-1.39s-17.99-1.97-19.5-1.39C2377.55,1841.3,2371.05,1849.14,2371.93,1850.44z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st39" d="M2429.44,1767.93c0,0-0.68-13.93-2.39-20.45c-1.71-6.52-4.27-9.88-4.27-9.88l-15.78-1.36l0-0.01l-0.33-0.02
				l-0.33-0.03l0,0.01l-15.81-0.89c0,0-3.01,2.97-5.62,9.18c-2.61,6.21-5.25,19.9-5.25,19.9s5.64-2.41,9.94-3.04
				c3.86-0.57,13.47-0.98,15.38-1.05c1.88,0.35,11.33,2.11,15.07,3.22C2424.2,1764.75,2429.44,1767.93,2429.44,1767.93z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2428.43,1739.2c0.41-0.82,1.03-2.22,2.09-2.3c1.11-0.09,2.6,0.81,3.58,1.32c2.27,1.18,3.3,3.49,3.46,5.99
					c0.07,1.13-0.86,6.47-2.74,5.31l-0.19,0.09c-0.44-0.74-0.42-1.95-0.76-2.82c-0.37-0.97-0.9-1.75-1.58-2.5
					c-0.89-0.97-1.59-1.79-2.76-2.39C2428.17,1741.2,2427.67,1740.71,2428.43,1739.2z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st35" d="M2427.68,1739.88c0.41-0.82,1.03-2.22,2.09-2.3c1.11-0.09,2.6,0.81,3.58,1.32
					c2.27,1.18,3.3,3.49,3.46,5.99c0.07,1.13-0.86,6.47-2.74,5.31l-0.19,0.09c-0.44-0.74-0.42-1.95-0.76-2.82
					c-0.37-0.97-0.9-1.75-1.58-2.5c-0.89-0.97-1.59-1.79-2.76-2.39C2427.42,1741.88,2426.92,1741.4,2427.68,1739.88z"/>
			</g>
		</g>
		<g className="st36">
			<g>
				<path className="st4" d="M2434.51,1740.87c0.02,0.4-0.44,1.38-0.91,1.5c-0.51,0.13-1.28-0.47-1.65-0.71
					c-0.81-0.52-2.61-0.96-2.59-2.16c0.02-1.74,1.77-0.95,2.6-0.53c0.66,0.34,2.24,1.14,2.51,1.86c0.05,0.12-0.02,0.39,0,0.35
					L2434.51,1740.87z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2385.39,1735.21c-0.27-0.87-0.65-2.36-1.69-2.61c-1.08-0.27-2.7,0.37-3.75,0.72
					c-2.43,0.8-3.83,2.91-4.39,5.35c-0.25,1.1-0.2,6.52,1.85,5.68l0.18,0.12c0.56-0.66,0.73-1.85,1.21-2.66
					c0.52-0.89,1.17-1.58,1.96-2.21c1.03-0.82,1.86-1.51,3.11-1.91C2385.33,1737.23,2385.9,1736.83,2385.39,1735.21z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st35" d="M2386.02,1736.01c-0.27-0.87-0.65-2.36-1.69-2.61c-1.08-0.27-2.69,0.37-3.75,0.72
					c-2.43,0.8-3.83,2.91-4.39,5.35c-0.25,1.1-0.2,6.52,1.85,5.68l0.18,0.12c0.56-0.66,0.73-1.85,1.21-2.66
					c0.52-0.89,1.17-1.58,1.96-2.21c1.03-0.82,1.86-1.51,3.11-1.91C2385.96,1738.02,2386.53,1737.63,2386.02,1736.01z"/>
			</g>
		</g>
		<g className="st36">
			<g>
				<path className="st4" d="M2379.12,1735.87c-0.09,0.39,0.21,1.43,0.65,1.63c0.48,0.22,1.34-0.25,1.75-0.43
					c0.89-0.39,2.73-0.53,2.91-1.71c0.26-1.72-1.59-1.23-2.48-0.95c-0.71,0.23-2.39,0.76-2.78,1.43c-0.06,0.11-0.05,0.39-0.06,0.34
					L2379.12,1735.87z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2375.38,1766.82c-3.31-0.24-5.29,27.87-5.09,31.23c0.2,3.36,9.25,2.9,9.29,2.22
					c0.08-1.07,1.09-15.3,1.09-15.3c-0.34-0.86-2.13-4.33-3.32-8.44S2376.1,1766.87,2375.38,1766.82z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st32" d="M2370.01,1802c-0.96,0.54-1.2,32.78-0.87,39.75c0.18,3.81,8.33-1.23,8.86-4.23
					c0.52-3,0.86-32.63,0.71-34.14C2378.59,1802.2,2371.45,1801.19,2370.01,1802z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2433.82,1770.98c3.31,0.23,1.3,28.34,0.62,31.63c-0.67,3.3-9.56,1.56-9.51,0.89
					c0.08-1.07,1.09-15.3,1.09-15.3c0.46-0.8,2.72-3.98,4.48-7.89C2432.25,1776.41,2433.09,1770.92,2433.82,1770.98z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st32" d="M2434.16,1806.56c0.88,0.67-3.44,32.62-4.76,39.47c-0.72,3.75-8.08-2.4-8.17-5.44s3.76-32.43,4.13-33.9
					C2425.64,1805.54,2432.85,1805.55,2434.16,1806.56z"/>
			</g>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2395.95,1762.17 2387.48,1780.9 2394.27,1779.44 2403.12,1761.92 			"/>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2397.61,1779.22 2406.56,1762.17 2409.18,1762.61 2400.48,1779.26 			"/>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2406.17,1779.83 2416.92,1764.17 2424.34,1766.48 2414.9,1781.56 			"/>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2385.52,1763.53 2379.38,1773.68 2380.09,1777.98 2388.75,1762.92 			"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st39" d="M2426.07,1856.99c0,0-7.67,3.22-12.89,3.91c-5.22,0.69-15.33-0.48-15.33-0.48l0.01-0.1
				c0,0-10.18-0.27-15.25-1.69c-5.07-1.42-12.21-5.69-12.21-5.69s-1.93,12.23-1.13,15.96c0.8,3.73,5.22,13.32,6.19,13.99
				c0.97,0.68,20.53,3.75,20.53,3.75l-0.01,0.1c0,0,19.79-0.28,20.85-0.81c1.06-0.53,6.79-9.39,8.11-12.98
				C2426.25,1869.38,2426.07,1856.99,2426.07,1856.99z"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="2431.66" y="1773.19" transform="matrix(0.0709 -0.9975 0.9975 0.0709 490.7976 4073.5911)" className="st32" width="0.78" height="0.31"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st32" d="M2433.64,1733.82c-0.05,0.75-1.32,1.27-2.82,1.17l-48.27-3.43c-1.5-0.11-2.68-0.8-2.62-1.55l0.03-0.47
				c0.05-0.75,1.31-1.27,2.82-1.17l48.27,3.43c1.5,0.11,2.68,0.8,2.62,1.55L2433.64,1733.82z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M2241.77,1906.9c-0.28,0-0.5-0.22-0.5-0.5v-193.32h-106.34v193.32c0,0.28-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5
			v-194.32h108.34v194.32C2242.27,1906.68,2242.04,1906.9,2241.77,1906.9z"/>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M2349.11,1906.9c-0.28,0-0.5-0.22-0.5-0.5v-193.32h-106.34v193.32c0,0.28-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5
			v-194.32h108.34v194.32C2349.61,1906.68,2349.39,1906.9,2349.11,1906.9z"/>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M2456.46,1906.9c-0.28,0-0.5-0.22-0.5-0.5v-193.32h-106.34v193.32c0,0.28-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5
			v-194.32h108.34v194.32C2456.96,1906.68,2456.73,1906.9,2456.46,1906.9z"/>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M2563.8,1906.9c-0.28,0-0.5-0.22-0.5-0.5v-193.32h-106.34v193.32c0,0.28-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5
			v-194.32h108.34v194.32C2564.3,1906.68,2564.08,1906.9,2563.8,1906.9z"/>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st40" d="M2540.75,1732.47c0.04,0.91-0.69,1.68-1.63,1.72l-61.49,2.45c-0.94,0.04-1.73-0.67-1.76-1.58l0,0
				c-0.04-0.91,0.69-1.68,1.63-1.72l61.49-2.45C2539.92,1730.85,2540.71,1731.56,2540.75,1732.47L2540.75,1732.47z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2486.83,1739.84c0.03,0.72-0.55,1.33-1.29,1.36l0,0c-0.74,0.03-1.36-0.53-1.39-1.25l-0.16-3.91
				c-0.03-0.72,0.55-1.33,1.29-1.36l0,0c0.74-0.03,1.36,0.53,1.39,1.25L2486.83,1739.84z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2534.68,1738.57c0.03,0.72-0.55,1.33-1.29,1.36l0,0c-0.74,0.03-1.36-0.53-1.39-1.25l-0.16-3.91
				c-0.03-0.72,0.55-1.33,1.29-1.36l0,0c0.74-0.03,1.36,0.53,1.39,1.25L2534.68,1738.57z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st41" d="M2504.3,1739.93c0,0-24.21-1.13-27.62,1.1c-3.4,2.23-5.49,4.4-5.57,8.84
				c-0.08,4.44,3.81,123.18,4.99,125.35c1.17,2.17,2.2,7.84,9.75,8.61c7.55,0.77,56.65-0.44,61.13-2.43
				c4.49-1.99,6.22-4.69,6.12-11.75c-0.1-7.52-0.71-7.51-6.99-125.47c-0.17-3.56-3.49-5.73-6.28-6.6
				C2537.06,1736.71,2504.3,1739.93,2504.3,1739.93z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st42" d="M2477.93,1787.14l32.94-2.36l33.02-0.27l-1.15-10.93c0,0-4.93-33.94-5.52-35.32
				c-0.59-1.37-0.21-1.84-2.04-1.66c-7.97,0.78-48.76,1.82-51.84,2.06c-1.26,0.1-2.69-0.07-3.12,2.56
				c-0.43,2.63-2.73,34.95-2.73,34.95L2477.93,1787.14z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st42" d="M2544.36,1873.99c0.07,1.7-1.32,3.13-3.1,3.2l-53.36,2.12c-1.78,0.07-3.27-1.25-3.34-2.94l-2.97-74.72
				c-0.07-1.7,1.32-3.13,3.1-3.2l53.36-2.12c1.78-0.07,3.27,1.25,3.34,2.94L2544.36,1873.99z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st41" d="M2530.86,1774.06l-40.76,1.62c0,0-1.07-26.78-1.14-28.7c-0.08-1.91-0.41-2.6,2.24-2.7
				c2.66-0.11,34.47-1.55,35.91-1.43c1.44,0.12,2.51,0.07,2.59,2.16S2530.86,1774.06,2530.86,1774.06z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st40" d="M2496.88,1770.71c0.02,0.48-0.37,0.89-0.86,0.91l0,0c-0.49,0.02-0.91-0.35-0.93-0.83l-0.94-23.65
					c-0.02-0.48,0.37-0.89,0.86-0.91l0,0c0.49-0.02,0.91,0.35,0.93,0.83L2496.88,1770.71z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st40" d="M2504.03,1770.42c0.02,0.48-0.37,0.89-0.86,0.91l0,0c-0.49,0.02-0.91-0.35-0.93-0.83l-0.94-23.65
					c-0.02-0.48,0.37-0.89,0.86-0.91l0,0c0.49-0.02,0.91,0.35,0.93,0.83L2504.03,1770.42z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st40" d="M2511.18,1770.14c0.02,0.48-0.37,0.89-0.86,0.91l0,0c-0.49,0.02-0.91-0.35-0.93-0.83l-0.94-23.65
					c-0.02-0.48,0.37-0.89,0.86-0.91l0,0c0.49-0.02,0.91,0.35,0.93,0.83L2511.18,1770.14z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st40" d="M2518.33,1769.85c0.02,0.48-0.37,0.89-0.86,0.91l0,0c-0.49,0.02-0.91-0.35-0.93-0.83l-0.94-23.65
					c-0.02-0.48,0.37-0.89,0.86-0.91l0,0c0.49-0.02,0.91,0.35,0.93,0.83L2518.33,1769.85z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st40" d="M2525.48,1769.57c0.02,0.48-0.37,0.89-0.86,0.91l0,0c-0.49,0.02-0.91-0.35-0.93-0.83l-0.94-23.65
					c-0.02-0.48,0.37-0.89,0.86-0.91l0,0c0.49-0.02,0.91,0.35,0.93,0.83L2525.48,1769.57z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2481.25,1788.79c-1.57,0.63,0.37,5.99,1.08,6.88c0.71,0.89,57.95-1.39,58.05-2.31s1.91-6.09,0.53-6.95
				C2539.53,1785.56,2482.7,1788.21,2481.25,1788.79z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2544.38,1786.67l0.19,4.7l1.44-0.84l8.88,0.43c0,0,0.72-2.25-1.34-3.21c-2.05-0.96-6.86-0.25-6.86-0.25
				L2544.38,1786.67z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2477.75,1789.32l0.19,4.7l-1.51-0.72l-8.82,1.13c0,0-0.89-2.19,1.08-3.31c1.97-1.12,6.82-0.79,6.82-0.79
				L2477.75,1789.32z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2539.48,1879.63c0.02,0.6-0.45,1.1-1.07,1.13l-47.38,1.89c-0.61,0.02-1.13-0.44-1.15-1.04l0,0
				c-0.02-0.6,0.45-1.1,1.07-1.13l47.38-1.89C2538.94,1878.57,2539.46,1879.03,2539.48,1879.63L2539.48,1879.63z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2480.8,1828.78c0.04,1.09-0.7,2-1.66,2.03l0,0c-0.96,0.04-1.78-0.81-1.82-1.9l-1.21-30.34
				c-0.04-1.09,0.7-2,1.66-2.03l0,0c0.96-0.04,1.78,0.81,1.82,1.9L2480.8,1828.78z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2482.44,1870.22c0.05,1.24-0.69,2.27-1.65,2.31l0,0c-0.96,0.04-1.78-0.93-1.83-2.17l-1.38-34.63
				c-0.05-1.24,0.69-2.27,1.65-2.31l0,0c0.96-0.04,1.78,0.93,1.83,2.17L2482.44,1870.22z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2547.96,1826.11c0.04,1.09-0.7,2-1.66,2.03l0,0c-0.96,0.04-1.78-0.81-1.82-1.9l-1.21-30.34
				c-0.04-1.09,0.7-2,1.66-2.03l0,0c0.96-0.04,1.78,0.81,1.82,1.9L2547.96,1826.11z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2549.61,1867.55c0.05,1.24-0.69,2.27-1.65,2.31l0,0c-0.96,0.04-1.78-0.93-1.83-2.17l-1.38-34.63
				c-0.05-1.24,0.69-2.27,1.65-2.31l0,0c0.96-0.04,1.78,0.93,1.83,2.17L2549.61,1867.55z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st40" d="M2545.76,1890.01c0.07,1.73-1.52,3.2-3.55,3.28l-27.99,1.11c-2.03,0.08-3.73-1.26-3.8-2.98l-0.19-4.84
				c-0.07-1.73,1.52-3.2,3.55-3.28l27.99-1.11c2.03-0.08,3.73,1.26,3.8,2.98L2545.76,1890.01z"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="2514.24" y="1885.41" transform="matrix(0.9992 -0.0398 0.0398 0.9992 -73.0916 101.7236)" className="st43" width="13.75" height="6.44"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st42" points="2486.61,1883.69 2489.66,1889.7 2504.43,1889.51 2507.4,1883.12 2505.52,1883.19 2503.3,1888.25 
				2490.56,1888.62 2488.06,1883.24 2486.17,1882.92 			"/>
		</g>
	</g>
</g>
<g>
	<g>
		<rect x="2150.67" y="1692.91" className="st44" width="67.99" height="10.29"/>
	</g>
</g>
<g>
	<g>
		<rect x="2368.05" y="1692.91" className="st44" width="67.99" height="10.29"/>
	</g>
</g>
<g>
	<g>
		<rect x="2260.7" y="1692.91" className="st44" width="67.99" height="10.29"/>
	</g>
</g>
<g>
	<g>
		<rect x="2473.6" y="1692.91" className="st44" width="67.99" height="10.29"/>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st32" d="M2752.14,1884.08c0.07,0.75-0.82,1.44-1.98,1.55l-37.3,3.41c-1.16,0.11-2.16-0.42-2.23-1.17l-0.04-0.47
				c-0.07-0.75,0.82-1.44,1.98-1.55l37.3-3.41c1.16-0.11,2.16,0.42,2.23,1.17L2752.14,1884.08z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st45" d="M2744.19,1728.7c-3.97-1.4-50.48,2.86-54.13,4.96c-5.9,3.38-6.94,18.56-6.94,18.56
				s10.18,107.17,11.14,111.26c4.11,17.53,12.19,21.25,15.57,22.41c4.73,1.62,37.92-0.81,42.28-3.26
				c3.11-1.75,10.67-7.51,11.53-25.5c0.2-4.19-9.25-111.43-9.25-111.43S2750.6,1730.95,2744.19,1728.7z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st46" d="M2741.66,1782.24c-7.64-5.08-20.21-3.68-20.21-3.68s-12.61,0.9-19.2,7.29c-1.58,1.53,3.34,48.78,6.41,50.97
				c3.07,2.19,18.18,0.61,18.18,0.61s15.14-1.19,17.76-3.9C2747.23,1830.82,2743.5,1783.47,2741.66,1782.24z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st32" d="M2745.22,1763.51c-4.67-4.52-25.49-3.74-25.49-3.74s-20.61,3.01-24.39,8.3
				c-0.95,1.33,2.85,14.98,5.12,15.72c1.66,0.54,6.65-5.75,20.87-6.48c15.77-0.81,20.17,3.41,21.7,2.58
				C2745.14,1778.76,2746.39,1764.64,2745.22,1763.51z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st32" d="M2701.54,1852.43c4.31,4.55,26.88,2.7,26.88,2.7s22.62-2.28,26.03-7.54c0.86-1.32-5.9-9.01-7.98-9.76
				c-1.52-0.55-19.47,1.78-19.47,1.78s-18.07,0.96-19.47,1.78C2705.62,1842.51,2700.46,1851.29,2701.54,1852.43z"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st46" d="M2744.98,1761.72c0,0-2.92-13.64-5.66-19.79s-5.81-9.06-5.81-9.06l-15.79,1.21l0-0.01l-0.33,0.04
				l-0.33,0.03l0,0.01l-15.75,1.68c0,0-2.49,3.42-4.07,9.97c-1.58,6.55-1.97,20.49-1.97,20.49s5.17-3.29,9.31-4.6
				c3.72-1.18,13.13-3.14,15-3.52c1.91,0.04,11.52,0.25,15.39,0.74C2739.29,1759.43,2744.98,1761.72,2744.98,1761.72z"/>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2739.34,1733.53c0.28-0.87,0.66-2.35,1.69-2.61c1.08-0.27,2.69,0.38,3.75,0.72
					c2.43,0.8,3.82,2.91,4.38,5.35c0.25,1.1,0.2,6.52-1.85,5.68l-0.18,0.12c-0.56-0.66-0.73-1.85-1.21-2.66
					c-0.52-0.9-1.17-1.58-1.96-2.21c-1.03-0.82-1.86-1.51-3.11-1.91C2739.41,1735.54,2738.83,1735.15,2739.34,1733.53z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st35" d="M2738.71,1734.33c0.28-0.87,0.66-2.35,1.69-2.61c1.08-0.27,2.69,0.38,3.75,0.72
					c2.43,0.8,3.82,2.91,4.38,5.35c0.25,1.1,0.2,6.52-1.85,5.68l-0.18,0.12c-0.56-0.66-0.73-1.85-1.21-2.66
					c-0.52-0.9-1.17-1.58-1.96-2.21c-1.03-0.82-1.86-1.51-3.11-1.91C2738.78,1736.34,2738.2,1735.95,2738.71,1734.33z"/>
			</g>
		</g>
		<g className="st36">
			<g>
				<path className="st4" d="M2745.61,1734.19c0.09,0.39-0.21,1.43-0.65,1.63c-0.48,0.22-1.34-0.25-1.75-0.43
					c-0.88-0.39-2.73-0.53-2.91-1.71c-0.26-1.72,1.59-1.23,2.48-0.94c0.71,0.23,2.39,0.77,2.78,1.43c0.06,0.11,0.05,0.39,0.06,0.34
					L2745.61,1734.19z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2696.22,1736.55c-0.41-0.82-1.03-2.22-2.09-2.3c-1.11-0.09-2.6,0.8-3.58,1.32
					c-2.27,1.18-3.31,3.48-3.46,5.99c-0.07,1.13,0.85,6.47,2.74,5.31l0.19,0.09c0.44-0.74,0.42-1.95,0.76-2.82
					c0.37-0.97,0.9-1.75,1.58-2.5c0.89-0.97,1.59-1.79,2.76-2.39C2696.48,1738.55,2696.99,1738.06,2696.22,1736.55z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st35" d="M2696.97,1737.23c-0.41-0.82-1.03-2.22-2.09-2.3c-1.11-0.09-2.6,0.8-3.58,1.32
					c-2.27,1.18-3.31,3.48-3.46,5.99c-0.07,1.13,0.85,6.47,2.74,5.31l0.19,0.09c0.44-0.74,0.42-1.95,0.76-2.82
					c0.37-0.97,0.9-1.75,1.58-2.5c0.89-0.97,1.59-1.79,2.76-2.39C2697.23,1739.23,2697.74,1738.75,2696.97,1737.23z"/>
			</g>
		</g>
		<g className="st36">
			<g>
				<path className="st4" d="M2690.14,1738.21c-0.02,0.4,0.44,1.38,0.91,1.5c0.51,0.14,1.28-0.47,1.65-0.71
					c0.81-0.52,2.61-0.96,2.59-2.16c-0.02-1.74-1.77-0.96-2.6-0.53c-0.66,0.34-2.24,1.14-2.51,1.86c-0.05,0.12,0.02,0.39,0,0.35
					L2690.14,1738.21z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2691.44,1769.36c-3.3,0.3-0.72,28.36,0.02,31.64c0.74,3.28,9.59,1.37,9.53,0.69
					c-0.1-1.07-1.4-15.27-1.4-15.27c-0.48-0.79-2.81-3.93-4.64-7.79C2693.13,1774.76,2692.17,1769.29,2691.44,1769.36z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st32" d="M2691.83,1804.94c-0.86,0.69,4.11,32.54,5.57,39.37c0.8,3.73,8.02-2.56,8.06-5.61s-4.42-32.34-4.81-33.8
					C2700.32,1803.75,2693.12,1803.91,2691.83,1804.94z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path className="st32" d="M2749.79,1764.02c3.3-0.3,5.86,27.76,5.72,31.12c-0.13,3.36-9.18,3.09-9.25,2.41
					c-0.1-1.07-1.4-15.27-1.4-15.27c0.32-0.87,2.05-4.37,3.15-8.51C2749.12,1769.64,2749.07,1764.09,2749.79,1764.02z"/>
			</g>
		</g>
		<g>
			<g>
				<path className="st32" d="M2755.88,1799.08c0.98,0.52,1.87,32.75,1.67,39.72c-0.11,3.81-8.36-1.06-8.94-4.05s-1.53-32.61-1.4-34.12
					C2747.3,1799.45,2754.42,1798.3,2755.88,1799.08z"/>
			</g>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2711,1761.45 2705.66,1781.3 2712.13,1778.77 2718.03,1760.04 			"/>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2715.39,1778.01 2721.46,1759.73 2724.12,1759.75 2718.22,1777.58 			"/>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2723.94,1777.23 2732.01,1760.04 2739.71,1761.11 2732.83,1777.52 			"/>
		</g>
	</g>
	<g className="st37">
		<g>
			<polygon className="st35" points="2700.92,1764.48 2696.51,1775.49 2697.89,1779.61 2704.01,1763.35 			"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st46" d="M2756.04,1850.16c0,0-7.05,4.42-12.09,5.94c-5.04,1.53-15.21,2-15.21,2l-0.01-0.1
				c0,0-10.09,1.38-15.32,0.79c-5.23-0.59-12.97-3.65-12.97-3.65s0.07,12.38,1.46,15.94c1.39,3.55,7.3,12.3,8.37,12.81
				c1.07,0.51,20.86,0.39,20.86,0.39l0.01,0.1c0,0,19.49-3.47,20.45-4.17c0.96-0.7,5.18-10.37,5.91-14.11
				S2756.04,1850.16,2756.04,1850.16z"/>
		</g>
	</g>
	<g>
		<g>
			
				<rect x="2748.28" y="1766.25" transform="matrix(0.9958 -0.0912 0.0912 0.9958 -149.6029 257.9024)" className="st32" width="0.31" height="0.78"/>
		</g>
	</g>
	<g>
		<g>
			<path className="st32" d="M2743.61,1727.38c0.07,0.75-1.09,1.47-2.59,1.61l-48.19,4.41c-1.5,0.14-2.77-0.36-2.84-1.11l-0.04-0.47
				c-0.07-0.75,1.09-1.47,2.59-1.61l48.19-4.41c1.5-0.14,2.77,0.36,2.84,1.11L2743.61,1727.38z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M2671.51,1906.9c-0.28,0-0.5-0.22-0.5-0.5v-193.32h-106.34v193.32c0,0.28-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5
			v-194.32h108.34v194.32C2672.01,1906.68,2671.79,1906.9,2671.51,1906.9z"/>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M2778.86,1906.9c-0.28,0-0.5-0.22-0.5-0.5v-193.32h-106.34v193.32c0,0.28-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5
			v-194.32h108.34v194.32C2779.36,1906.68,2779.13,1906.9,2778.86,1906.9z"/>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M2886.2,1906.9c-0.28,0-0.5-0.22-0.5-0.5v-193.32h-106.34v193.32c0,0.28-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5
			v-194.32h108.34v194.32C2886.7,1906.68,2886.48,1906.9,2886.2,1906.9z"/>
	</g>
</g>
<g>
	<g>
		<rect x="2580.42" y="1692.91" className="st44" width="67.99" height="10.29"/>
	</g>
</g>
<g>
	<g>
		<rect x="2797.79" y="1692.91" className="st44" width="67.99" height="10.29"/>
	</g>
</g>
<g>
	<g>
		<rect x="2690.45" y="1692.91" className="st44" width="67.99" height="10.29"/>
	</g>
</g>
<g>
	<g>
		<polygon className="st47" points="2928.98,1661.02 2091.36,1661.02 2265.32,1434.13 2761.56,1434.13 		"/>
	</g>
</g>
<g>
	<g>
		<polygon className="st48" points="2928.98,1207.83 2761.56,1434.13 2265.32,1434.13 2091.36,1207.83 		"/>
	</g>
</g>
<g>
	<g>
		<polygon className="st49" points="2265.32,1434.13 2091.36,1661.02 2091.36,1207.83 		"/>
	</g>
</g>
<g>
	<g>
		<polygon className="st49" points="2928.98,1207.83 2928.98,1661.02 2761.56,1434.13 		"/>
	</g>
</g>
<g>
	<g>
		<g>
			<polygon className="st47" points="2414.57,2515.35 2414.57,2192.26 2547.77,2259.36 2547.77,2450.78 			"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st48" points="2680.63,2515.35 2547.77,2450.78 2547.77,2259.36 2680.63,2192.26 			"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st49" points="2547.77,2259.36 2414.57,2192.26 2680.63,2192.26 			"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st49" points="2680.63,2515.35 2414.57,2515.35 2547.77,2450.78 			"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<polygon className="st4" points="2273.11,2375.03 2273.11,2298.14 2261.13,2298.14 2261.13,2390.36 2289.84,2375.03 			"/>
		</g>
		<g>
			<path className="st4" d="M2261.01,2390.57l0-92.55h12.22v76.89h17.11L2261.01,2390.57z M2261.26,2298.26l0,91.89l28.08-15h-16.36
				v-76.89H2261.26z"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st4" points="2248.95,2375.03 2232.21,2375.03 2260.92,2390.36 2260.92,2298.14 2248.95,2298.14 			"/>
		</g>
		<g>
			<path className="st4" d="M2261.05,2390.57l-0.18-0.1l-29.15-15.57h17.11v-76.89h12.22V2390.57z M2232.71,2375.15l28.08,15v-91.89
				h-11.72v76.89H2232.71z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<g>
			<polygon className="st4" points="2827.74,2313.47 2827.74,2390.36 2839.71,2390.36 2839.71,2298.14 2811,2313.47 			"/>
		</g>
		<g>
			<path className="st4" d="M2839.84,2390.48h-12.22v-76.89h-17.11l29.33-15.66V2390.48z M2827.86,2390.23h11.72v-91.89l-28.08,15h16.36
				V2390.23z"/>
		</g>
	</g>
	<g>
		<g>
			<polygon className="st4" points="2851.89,2313.47 2868.63,2313.47 2839.92,2298.14 2839.92,2390.36 2851.89,2390.36 			"/>
		</g>
		<g>
			<path className="st4" d="M2852.02,2390.48h-12.22v-92.55l0.18,0.1l29.15,15.57h-17.11V2390.48z M2840.05,2390.23h11.72v-76.89h16.36
				l-28.08-15V2390.23z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<rect x="2115.34" y="2478.87" className="st0" width="35.6" height="35.6"/>
	</g>
</g>
<g>
	<g>
		<path className="st10" d="M2999.28,2499.68H2725.7c-2.76,0-5-2.24-5-5s2.24-5,5-5h273.58c2.76,0,5,2.24,5,5
			S3002.04,2499.68,2999.28,2499.68z"/>
	</g>
</g>
<g>
	<g>
		<rect x="2944.37" y="2489.68" className="st11" width="29.77" height="10"/>
	</g>
</g>
<g>
	<g>
		<rect x="2885.27" y="2489.68" className="st11" width="29.77" height="10"/>
	</g>
</g>
<g>
	<g>
		<rect x="2826.85" y="2489.68" className="st11" width="29.77" height="10"/>
	</g>
</g>
<g>
	<g>
		<rect x="2765.04" y="2489.68" className="st11" width="29.77" height="10"/>
	</g>
</g>
<g>
	<g>
		<g>
			<path className="st10" d="M2389.49,2499.68h-290.91c-2.76,0-5-2.24-5-5s2.24-5,5-5h290.91c2.76,0,5,2.24,5,5
				S2392.26,2499.68,2389.49,2499.68z"/>
		</g>
	</g>
	<g>
		<g>
			<rect x="2331.11" y="2489.68" className="st11" width="31.66" height="10"/>
		</g>
	</g>
	<g>
		<g>
			<rect x="2268.26" y="2489.68" className="st11" width="31.66" height="10"/>
		</g>
	</g>
	<g>
		<g>
			<rect x="2206.14" y="2489.68" className="st11" width="31.66" height="10"/>
		</g>
	</g>
	<g>
		<g>
			<rect x="2140.42" y="2489.68" className="st11" width="31.66" height="10"/>
		</g>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M2098.59,2508.5h-8.79c-2.71,0-4.9-2.19-4.9-4.9v-17.85c0-2.71,2.19-4.9,4.9-4.9h8.79
			c2.71,0,4.9,2.19,4.9,4.9v17.85C2103.49,2506.31,2101.3,2508.5,2098.59,2508.5z"/>
	</g>
</g>
<g>
	<g>
		<path className="st4" d="M3009.85,2508.5h-8.79c-2.71,0-4.9-2.19-4.9-4.9v-17.85c0-2.71,2.19-4.9,4.9-4.9h8.79
			c2.71,0,4.9,2.19,4.9,4.9v17.85C3014.75,2506.31,3012.55,2508.5,3009.85,2508.5z"/>
	</g>
</g>
</svg>


      </div>
			<div className="m-platform__car-1">
				<img src={car1} alt=""/>
			</div>
			<div className="m-platform__car-2">
				<img src={car2} alt=""/>
			</div>
    </div>
  )
}

export default Platform